import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
import SchoolDatePicker from "../../components/SchoolDatePicker/SchoolDatePicker";
import { formatDate as formatDateShared } from "../../utils/dateFormat";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, MenuItem, TableRow, Table, TableHead, TableContainer, Paper, TableBody, Checkbox, TableCell, FormControlLabel, FormHelperText, CircularProgress, Tooltip, IconButton, Menu, Chip, Avatar, Collapse, InputAdornment, Divider, List, ListItem, ListItemText } from "@material-ui/core";

import { Card, Box, Typography } from "@material-ui/core";
import TablePagination from '@material-ui/core/TablePagination';
import ActivityService from "./Locality/Service/activityService";
import ActivityTabelService from "./Locality/Service/activityTabelService";
import SubActivityService from "./Locality/Service/subActivityService";
import StudentService from "./Locality/Service/studentService";
import SuperActivityService from "./Locality/Service/superActivityService";
import * as Yup from 'yup';
import { Grid, Select, TextField } from "@material-ui/core";
import { useFormik } from 'formik';
import { useHistory } from 'react-router-dom';
import LanguageIcon from '@material-ui/icons/Language';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import HistoryIcon from '@material-ui/icons/History';
import TreeView from "@material-ui/lab/TreeView";
import TreeItem from "@material-ui/lab/TreeItem";
import Skeleton from "@material-ui/lab/Skeleton";
import EditIcon from '@material-ui/icons/Edit';
import { makeStyles } from '@material-ui/core/styles';
import FilterPanel, { FilterSection } from "../../components/ui/FilterPanel";
import Switch from "@material-ui/core/Switch";
import AddClassService from "./Locality/Service/addClassService";
import SectionService from "./Locality/Service/sectionService";
import ExportExcel from "../../Excelexport";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import SearchIcon from "@material-ui/icons/Search";
import RefreshIcon from "@material-ui/icons/Refresh";
import ViewColumnIcon from "@material-ui/icons/ViewColumn";
import FilterListIcon from "@material-ui/icons/FilterList";
import CloseIcon from "@material-ui/icons/Close";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import PersonIcon from "@material-ui/icons/Person";
import CheckIcon from "@material-ui/icons/Check";
import PeopleOutlineIcon from "@material-ui/icons/PeopleOutline";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import EventIcon from "@material-ui/icons/Event";

import SchoolIcon from "@material-ui/icons/School";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import GetAppIcon from "@material-ui/icons/GetApp";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import NoteIcon from "@material-ui/icons/Note";
import PhotoLibraryIcon from "@material-ui/icons/PhotoLibrary";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import PublishIcon from "@material-ui/icons/Publish";
import DraftsIcon from "@material-ui/icons/Drafts";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import VideocamIcon from "@material-ui/icons/Videocam";
import PrintIcon from "@material-ui/icons/Print";
import ImagesStoreService from "./Locality/Service/imagesStoreService";
import { canMutatePlannerActivity } from "../../utils/activityPlannerPermissions";
import { showAppConfirm } from '../../context/AlertContext';
import { escapeHtml, openPrintHtml } from "../../utils/printHtml";
const KEY_DISPLAY_LABELS = {
    P: 'Presented',
    WA: 'Work with Assist',
    WI: 'Work Independent',
    M: 'Master',
};

const KEY_STATUS_ORDER = ['P', 'WA', 'WI', 'M'];

/** Build P → WA → WI → M timeline from history + the row's current key. */
const buildKeyStatusTimeline = (history, currentKey) => {
    const current = String(currentKey || '').trim().toUpperCase();
    const currentIdx = KEY_STATUS_ORDER.indexOf(current);
    const firstByKey = {};
    (Array.isArray(history) ? history : [])
        .map((item) => ({
            key: String(item?.key || '').trim().toUpperCase(),
            changedAt: item?.changedAt ? new Date(item.changedAt) : null,
        }))
        .filter((item) => KEY_STATUS_ORDER.includes(item.key))
        .sort((a, b) => (a.changedAt?.getTime() || 0) - (b.changedAt?.getTime() || 0))
        .forEach((item) => {
            if (!firstByKey[item.key]) firstByKey[item.key] = item;
        });

    return KEY_STATUS_ORDER.map((key, idx) => {
        const hit = firstByKey[key];
        let state = 'upcoming';
        if (currentIdx >= 0) {
            if (idx < currentIdx) state = hit ? 'completed' : 'skipped';
            else if (idx === currentIdx) state = 'current';
        } else if (hit) {
            state = 'completed';
        }
        return {
            key,
            label: KEY_DISPLAY_LABELS[key] || key,
            state,
            changedAt: hit?.changedAt || null,
        };
    });
};

/** Print / Excel column headers for activity status keys */
const EXPORT_KEY_COLUMNS = [
    { key: 'P', header: 'Presented' },
    { key: 'WA', header: 'Work with assistance' },
    { key: 'WI', header: 'Work independently' },
    { key: 'M', header: 'Mastered' },
];

const KEY_MARK = '✓';

/** Returns { Presented: '✓'|'', ... } for the activity's current key */
const buildKeyStatusMarks = (activityKey) => {
    const normalized = String(activityKey ?? '').trim().toUpperCase();
    const marks = {};
    EXPORT_KEY_COLUMNS.forEach(({ key, header }) => {
        marks[header] = normalized === key ? KEY_MARK : '';
    });
    return marks;
};

const calculateAgeFromDob = (dob) => {
    if (!dob) return null;
    const birthDate = new Date(dob);
    if (Number.isNaN(birthDate.getTime())) return null;
    const now = new Date();
    let years = now.getFullYear() - birthDate.getFullYear();
    let months = now.getMonth() - birthDate.getMonth();
    if (now.getDate() < birthDate.getDate()) months -= 1;
    if (months < 0) {
        years -= 1;
        months += 12;
    }
    if (years < 0) return null;
    return { years, months };
};

const formatStudentAge = (dob) => {
    const age = calculateAgeFromDob(dob);
    if (!age) return '';
    return `${age.years}y : ${age.months}m`;
};

const formatHalfYearAge = (totalMonths) => {
    const years = totalMonths / 12;
    return Number.isInteger(years) ? String(years) : years.toFixed(1);
};

// Half-year buckets: "2.5 to 3", "3 to 3.5", "3.5 to 4", ...
const getAgeGroupLabel = (dob) => {
    const age = calculateAgeFromDob(dob);
    if (!age) return 'Age N/A';
    const totalMonths = age.years * 12 + age.months;
    const bucketStart = Math.floor(totalMonths / 6) * 6;
    const bucketEnd = bucketStart + 6;
    return `${formatHalfYearAge(bucketStart)} to ${formatHalfYearAge(bucketEnd)}`;
};

const getAgeGroupSortKey = (dob) => {
    const age = calculateAgeFromDob(dob);
    if (!age) return Infinity;
    return Math.floor((age.years * 12 + age.months) / 6) * 6;
};

// Buckets students into half-year age ranges
// (e.g. "2.5 to 3", "3 to 3.5", "3.5 to 4") before picking who to add an activity for.
const buildAgeWiseSummary = (students) => {
    const groups = new Map();
    students.forEach((student) => {
        const label = getAgeGroupLabel(student.dob);
        if (!groups.has(label)) {
            groups.set(label, {
                sortKey: getAgeGroupSortKey(student.dob),
                count: 0,
            });
        }
        groups.get(label).count += 1;
    });
    return Array.from(groups.entries())
        .sort(([, a], [, b]) => a.sortKey - b.sortKey)
        .map(([label, group]) => [label, group.count]);
};

const formatPrintDate = (dateString) => {
    if (!dateString) return '';
    try {
        const date = new Date(dateString);
        if (Number.isNaN(date.getTime())) {
            const parts = String(dateString).split('-');
            if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
            return String(dateString);
        }
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    } catch {
        return String(dateString || '');
    }
};

const getFilteredGroupRecords = (group, groupIndex, {
    matchesActivityFilters,
    studentKeyFilters,
    getStudentGroupKey,
}) => {
    const studentName = `${group.studentId?.firstName || ''} ${group.studentId?.lastName || ''}`.trim();
    const records = (group.activityRecordsId || [])
        .filter(isActivityRecord)
        .filter((activity) => matchesActivityFilters(activity, studentName));
    if (records.length === 0) return [];

    const studentKey = getStudentGroupKey(group, groupIndex);
    const activeKeyFilter = studentKeyFilters[studentKey];
    const displayRecords = activeKeyFilter
        ? records.filter((rec) => {
            const idx = getActivityKeyIndex(rec.key);
            return activeKeyFilter === 'notSet'
                ? idx === -1
                : KEY_SEQUENCE[idx] === activeKeyFilter;
        })
        : records;

    return displayRecords.map((activity) => ({ group, activity, studentName }));
};

const buildPrintRowsFromGroups = (groups, filterCtx) => {
    const rows = [];
    (groups || []).forEach((group, groupIndex) => {
        getFilteredGroupRecords(group, groupIndex, filterCtx).forEach(({ group: g, activity, studentName }) => {
            const keyMarks = buildKeyStatusMarks(activity.key);
            rows.push({
                studentName,
                className: g.classId?.className || activity.classId?.className || '',
                sectionName: activity.sectionId?.sectionName || g.sectionId?.sectionName || '',
                areaOfWork: activity.superActivityId?.superActivityName || '',
                listOfActivities: activity.activityId?.activityName || '',
                exercise: activity.subActivityId?.subActivityName || '',
                presented: keyMarks.Presented,
                workWithAssistance: keyMarks['Work with assistance'],
                workIndependently: keyMarks['Work independently'],
                mastered: keyMarks.Mastered,
                observation: activity.remarks || '',
                startDate: formatPrintDate(activity.date),
                endDate: formatPrintDate(activity.endDate),
                status: String(activity.publicStatus || '').toLowerCase() === 'publish' ? 'Published' : 'Draft',
            });
        });
    });
    return rows;
};

const buildActivityPrintHtml = ({ title, subtitle, filterLines, rows, generatedAt }) => {
    const headers = [
        'Student',
        'Class',
        'Section',
        'Area Of Work',
        'Activity',
        'Exercise',
        'Presented',
        'Work with assistance',
        'Work independently',
        'Mastered',
        'Observation',
        'Start Date',
        'End Date',
    ];
    const headerHtml = headers.map((h) => `<th>${escapeHtml(h)}</th>`).join('');
    const bodyHtml = rows.map((row) => `
        <tr>
            <td>${escapeHtml(row.studentName)}</td>
            <td>${escapeHtml(row.className)}</td>
            <td>${escapeHtml(row.sectionName)}</td>
            <td>${escapeHtml(row.areaOfWork)}</td>
            <td>${escapeHtml(row.listOfActivities)}</td>
            <td>${escapeHtml(row.exercise)}</td>
            <td class="key-mark">${escapeHtml(row.presented)}</td>
            <td class="key-mark">${escapeHtml(row.workWithAssistance)}</td>
            <td class="key-mark">${escapeHtml(row.workIndependently)}</td>
            <td class="key-mark">${escapeHtml(row.mastered)}</td>
            <td>${escapeHtml(row.observation)}</td>
            <td>${escapeHtml(row.startDate)}</td>
            <td>${escapeHtml(row.endDate)}</td>
        </tr>
    `).join('');
    const filtersHtml = (filterLines || [])
        .map((line) => `<div class="filter-line">${escapeHtml(line)}</div>`)
        .join('');

    return `<!doctype html>
<html>
  <head>
    <meta charset="utf-8"/>
    <meta name="viewport" content="width=device-width, initial-scale=1"/>
    <title>${escapeHtml(title)}</title>
    <style>
      * { box-sizing: border-box; }
      body { margin: 0; padding: 24px; font-family: Arial, Helvetica, sans-serif; background: #fff; color: #1a1a1a; }
      .wrap { max-width: 1400px; margin: 0 auto; }
      .header { display: flex; justify-content: space-between; align-items: flex-start; gap: 16px; margin-bottom: 16px; }
      .title { margin: 0; font-size: 22px; font-weight: 800; color: #1a1a1a; }
      .subtitle { margin: 4px 0 0; font-size: 13px; color: #64748b; }
      .meta { font-size: 12px; color: #64748b; text-align: right; white-space: nowrap; }
      .filters { display: flex; flex-wrap: wrap; gap: 8px 16px; margin-bottom: 16px; padding: 12px 14px; border: 1px solid #d9d9d9; border-radius: 10px; background: #f8fafc; }
      .filter-line { font-size: 12px; color: #444; font-weight: 600; }
      table { width: 100%; border-collapse: collapse; font-size: 11px; }
      th, td { border: 1px solid #8f8f8f; padding: 8px 6px; text-align: left; vertical-align: top; }
      th { background: #efefef; color: #444; font-weight: 700; }
      td.key-mark { text-align: center; font-weight: 700; font-size: 14px; color: #1f8a5b; }
      tr:nth-child(even) td { background: #fbfcfe; }
      @media print {
        body { padding: 0; }
        .wrap { max-width: none; }
        @page { size: landscape; margin: 12mm; }
      }
    </style>
  </head>
  <body>
    <div class="wrap">
      <div class="header">
        <div>
          <h1 class="title">${escapeHtml(title)}</h1>
          <p class="subtitle">${escapeHtml(subtitle)}</p>
        </div>
        <div class="meta">Generated: ${escapeHtml(generatedAt)}</div>
      </div>
      <div class="filters">${filtersHtml}</div>
      <table>
        <thead><tr>${headerHtml}</tr></thead>
        <tbody>${bodyHtml}</tbody>
      </table>
    </div>
    <script>window.onload = () => { window.focus(); window.print(); };</script>
  </body>
</html>`;
};

const normalizeRefId = (value) => {
    if (!value) return '';
    if (typeof value === 'object' && value._id) return String(value._id);
    return String(value);
};

/** Catalog rows for this school + global defaults (schooleId null / missing). */
const matchesSchoolCatalogScope = (row, schoolId) => {
    const sid = normalizeRefId(schoolId);
    if (!sid) return true;
    const rowSchool = normalizeRefId(row?.schooleId);
    return !rowSchool || rowSchool === sid;
};

const filterCatalogTreeBySchool = (tree, schoolId) => {
    if (!Array.isArray(tree)) return [];
    return tree
        .filter((area) => matchesSchoolCatalogScope(area, schoolId))
        .map((area) => ({
            ...area,
            activities: (Array.isArray(area.activities) ? area.activities : [])
                .filter((act) => matchesSchoolCatalogScope(act, schoolId) && act?._id)
                .map((act) => ({
                    ...act,
                    subActivities: (Array.isArray(act.subActivities) ? act.subActivities : [])
                        .filter((sub) => matchesSchoolCatalogScope(sub, schoolId) && sub?._id),
                })),
        }));
};

const normalizeStudentIds = (recordStudentId, groupStudentId) => {
    const raw = recordStudentId ?? groupStudentId;
    if (!raw) return [];
    if (Array.isArray(raw)) {
        return raw.map((item) => normalizeRefId(item)).filter(Boolean);
    }
    return [normalizeRefId(raw)].filter(Boolean);
};

const isActivityRecord = (record) => Boolean(record && typeof record === 'object' && record._id);

const getCreatedByLabel = (createdBy) => {
    if (!createdBy) return '—';
    if (createdBy.teacher?.teacherName) return createdBy.teacher.teacherName;
    if (createdBy.school?.schooleName) return createdBy.school.schooleName;
    if (Array.isArray(createdBy.students) && createdBy.students.length > 0) {
        const names = createdBy.students.map((s) => s?.firstName).filter(Boolean);
        if (names.length) return names.join(', ');
    }
    return createdBy.userName || createdBy.serialNumber || '—';
};

const buildExportRows = (groups) => {
    const rows = [];
    (groups || []).forEach((group) => {
        const studentName = group.studentId
            ? `${group.studentId.firstName} ${group.studentId.lastName}`
            : '';
        const className = group.classId?.className || '';

        (group.activityRecordsId || []).forEach((activity) => {
            if (!isActivityRecord(activity)) return;
            const keyMarks = buildKeyStatusMarks(activity.key);
            rows.push({
                "Student Name": studentName,
                "Class Name": className,
                "Area Of Work": activity.superActivityId?.superActivityName || '',
                "List Of Activities": activity.activityId?.activityName || '',
                "Exercise": activity.subActivityId?.subActivityName || '',
                "Observation": activity.remarks || '',
                "Presented": keyMarks.Presented,
                "Work with assistance": keyMarks['Work with assistance'],
                "Work independently": keyMarks['Work independently'],
                "Mastered": keyMarks.Mastered,
                "Date": activity.date || '',
            });
        });
    });
    return rows;
};

const getActivityRowKey = (activity, group, index) => {
    if (activity?._id) return String(activity._id);
    const studentPart = normalizeRefId(group?.studentId);
    const activityPart = normalizeRefId(activity?.activityId);
    const subPart = normalizeRefId(activity?.subActivityId) || 'none';
    return `${studentPart}-${activityPart}-${subPart}-${index}`;
};

const mergeActivityRecordUpdate = (existing, updated) => {
    if (!existing || !updated) return existing;
    return {
        ...existing,
        key: Object.prototype.hasOwnProperty.call(updated, 'key') ? updated.key : existing.key,
        publicStatus: updated.publicStatus ?? existing.publicStatus,
        statusHistory: updated.statusHistory ?? existing.statusHistory,
        remarks: updated.remarks ?? existing.remarks,
        date: updated.date ?? existing.date,
        endDate: updated.endDate ?? existing.endDate,
        authorizedPerson: updated.authorizedPerson ?? existing.authorizedPerson,
        imageURL: updated.imageURL ?? existing.imageURL,
        videoURL: updated.videoURL ?? existing.videoURL,
    };
};

const MAX_ACTIVITY_IMAGES = 10;
const MAX_ACTIVITY_VIDEOS = 5;
const IMAGES_STORE_ALL_KEY = 'ALL';
const VIDEO_EXT = /\.(mp4|webm|mov|avi|mkv|m4v|ogv)(\?|$)/i;

const getMediaTypeFromUrl = (url) => {
    if (!url) return 'image';
    const lower = String(url).split('?')[0].toLowerCase();
    return VIDEO_EXT.test(lower) ? 'video' : 'image';
};

const getActivityImageUrls = (activity) => {
    if (!activity) return [];
    if (Array.isArray(activity.imageURL)) return activity.imageURL.filter(Boolean);
    return activity.imageURL ? [activity.imageURL] : [];
};

const getActivityVideoUrls = (activity) => {
    if (!activity) return [];
    if (Array.isArray(activity.videoURL)) return activity.videoURL.filter(Boolean);
    return activity.videoURL ? [activity.videoURL] : [];
};

const countStoreMedia = (rows) => (rows || []).reduce(
    (acc, row) => ({
        images: acc.images + (row.imageURL?.length || 0),
        videos: acc.videos + (row.videoURL?.length || 0),
    }),
    { images: 0, videos: 0 },
);

const getVisibleStoreMedia = (rows, selectedStoreId) => {
    const filtered = selectedStoreId === IMAGES_STORE_ALL_KEY
        ? rows
        : rows.filter((row) => row._id === selectedStoreId);

    const imageItems = filtered.flatMap((row) =>
        (row.imageURL || [])
            .map((url) => ({
                url: String(url || '').trim(),
                storeEventName: row.eventName || '—',
                storeRecordId: row._id,
                mediaType: 'image',
            }))
            .filter((item) => item.url),
    );

    const videoItems = filtered.flatMap((row) =>
        (row.videoURL || [])
            .map((url) => ({
                url: String(url || '').trim(),
                storeEventName: row.eventName || '—',
                storeRecordId: row._id,
                mediaType: 'video',
            }))
            .filter((item) => item.url),
    );

    return [...imageItems, ...videoItems];
};

const getFileNameFromUrl = (url) => {
    try {
        const path = (url || '').split('/').pop() || url;
        return (path || '').split('?')[0] || 'image';
    } catch {
        return 'image';
    }
};

const downloadFromUrl = async (url, filename) => {
    if (!url) return;
    try {
        const response = await fetch(url);
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.setAttribute('download', filename || getFileNameFromUrl(url));
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
    } catch {
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename || getFileNameFromUrl(url));
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
};

const applyActivityRecordPatch = (groups, activityId, apiRecord, showMaster) => {
    const targetId = String(activityId);
    const key = apiRecord?.key;
    // Hide mastered rows only when Show Master is off; otherwise keep all keys.
    const shouldRemove = !showMaster && key === 'M';

    return groups.map((group) => {
        const records = group.activityRecordsId || [];
        const recordIndex = records.findIndex(
            (record) => isActivityRecord(record) && String(record._id) === targetId
        );
        if (recordIndex < 0) return group;

        if (shouldRemove) {
            return {
                ...group,
                activityRecordsId: records.filter((_, index) => index !== recordIndex),
            };
        }

        const nextRecords = [...records];
        nextRecords[recordIndex] = mergeActivityRecordUpdate(records[recordIndex], apiRecord);
        return { ...group, activityRecordsId: nextRecords };
    });
};

const KEY_SEQUENCE = ['P', 'WA', 'WI', 'M'];

const KEY_CIRCLE_COLORS = {
    P: '#1f8a5b',
    WA: '#1a1a1a',
    WI: '#7c4dff',
    M: '#d4a017',
};

const KEY_INCOMPLETE_COLOR = '#c5cdd8';
const KEY_INCOMPLETE_LABEL = '#b8c2cf';

const KEY_STEP_META = {
    P: { shortLabel: 'Present', Icon: CheckIcon },
    WA: { shortLabel: 'Work with Assist', Icon: PeopleOutlineIcon },
    WI: { shortLabel: 'Work Independent', Icon: PersonIcon },
    M: { shortLabel: 'Master', Icon: StarBorderIcon },
};

const normalizeActivityKey = (key) => String(key ?? '').trim();

const getActivityKeyIndex = (key) => {
    const normalized = normalizeActivityKey(key);
    if (!normalized) return -1;
    return KEY_SEQUENCE.indexOf(normalized);
};

const KEY_LEGEND_ITEMS = [
    {
        key: 'P',
        title: 'Present',
        description: 'Student is present. Default status.',
        color: '#1f8a5b',
        bg: '#eefbf3',
        Icon: CheckIcon,
    },
    {
        key: 'WA',
        title: 'Work with Assist',
        description: 'Student requires some assistance.',
        color: '#1a1a1a',
        bg: '#e6e6e6',
        Icon: PeopleOutlineIcon,
    },
    {
        key: 'WI',
        title: 'Work Independent',
        description: 'Student can work independently.',
        color: '#e6a23c',
        bg: '#fff8ed',
        Icon: PersonIcon,
    },
    {
        key: 'M',
        title: 'Master',
        description: 'Student has mastered this skill.',
        color: '#7c3aed',
        bg: '#f5f0ff',
        Icon: StarBorderIcon,
        badge: 'Final',
    },
];

const normalizeDialogMessage = (message) => {
    if (message == null) return '';
    if (typeof message === 'string') return message;
    if (Array.isArray(message)) {
        return message.map((item) => normalizeDialogMessage(item)).filter(Boolean).join('\n');
    }
    if (typeof message === 'object') {
        if (message.message != null) return normalizeDialogMessage(message.message);
    }
    return String(message);
};

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
    infoNote: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: theme.spacing(1.5),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        padding: theme.spacing(1.5, 2),
        borderRadius: 8,
        backgroundColor: theme.palette.type === 'light' ? 'rgba(25, 118, 210, 0.08)' : 'rgba(25, 118, 210, 0.16)',
        border: `1px solid ${theme.palette.type === 'light' ? 'rgba(25, 118, 210, 0.24)' : 'rgba(25, 118, 210, 0.4)'}`,
    },
    infoNoteIcon: {
        color: theme.palette.info.main,
        marginTop: 2,
        flexShrink: 0,
    },
    infoNoteText: {
        color: theme.palette.text.secondary,
        fontSize: '0.875rem',
        lineHeight: 1.5,
    },
    infoNoteLabel: {
        fontWeight: 600,
        color: theme.palette.info.dark || theme.palette.primary.main,
        marginBottom: 2,
    },
    pageHeader: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    pageTitle: {
        fontWeight: 700,
        fontSize: '1.9rem',
        color: '#1a1a1a',
        lineHeight: 1.2,
    },
    pageSubtitle: {
        color: '#555',
        fontSize: '0.9rem',
        marginTop: 2,
    },
    planBtn: {
        backgroundColor: '#121212',
        color: '#fff',
        textTransform: 'none',
        fontWeight: 500,
        borderRadius: 999,
        padding: '8px 22px',
        boxShadow: 'none',
        '&:hover': { backgroundColor: '#333' },
    },
    noteBanner: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: theme.spacing(1.5),
        padding: theme.spacing(1.5, 2),
        borderRadius: 12,
        backgroundColor: '#e6e6e6',
        border: '1px solid #d6e4ff',
        marginBottom: theme.spacing(2),
    },
    noteIconWrap: {
        width: 28,
        height: 28,
        borderRadius: '50%',
        backgroundColor: '#1a1a1a',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    filtersCard: {
        borderRadius: 14,
        border: '1px solid #d9d9d9',
        boxShadow: 'none',
        padding: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    filtersTopRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: theme.spacing(2),
    },
    filtersChip: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '6px 12px',
        borderRadius: 8,
        border: '1px solid #8f8f8f',
        backgroundColor: '#fff',
        cursor: 'pointer',
        fontWeight: 600,
        color: '#1a1a1a',
        userSelect: 'none',
    },
    quickRangeWrap: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        backgroundColor: '#efefef',
        borderRadius: 10,
        padding: 4,
    },
    quickRangeBtn: {
        textTransform: 'none',
        borderRadius: 999,
        padding: '4px 14px',
        minWidth: 'auto',
        color: '#444',
        fontWeight: 600,
        fontSize: '0.82rem',
    },
    quickRangeBtnActive: {
        backgroundColor: '#fff',
        color: '#1a1a1a',
        fontWeight: 600,
        boxShadow: 'none',
    },
    exportBtn: {
        backgroundColor: '#121212',
        color: '#fff',
        textTransform: 'none',
        fontWeight: 500,
        borderRadius: 999,
        '&:hover': { backgroundColor: '#333' },
    },
    fieldLabel: {
        fontSize: '0.78rem',
        fontWeight: 600,
        color: '#444',
        marginBottom: 6,
        display: 'flex',
        alignItems: 'center',
        gap: 4,
    },
    applyBtn: {
        backgroundColor: '#121212',
        color: '#fff',
        textTransform: 'none',
        fontWeight: 500,
        borderRadius: 999,
        '&:hover': { backgroundColor: '#333' },
    },
    resetBtn: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        color: '#444',
        border: '1px solid #8f8f8f',
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: theme.spacing(1.5),
        marginBottom: theme.spacing(1.5),
    },
    iconBtnOutlined: {
        border: '1px solid #8f8f8f',
        borderRadius: 8,
        padding: 8,
        color: '#444',
    },
    tableCard: {
        borderRadius: 14,
        border: '1px solid #d9d9d9',
        boxShadow: 'none',
        overflow: 'hidden',
    },
    skeletonBar: {
        backgroundColor: 'rgba(15, 45, 77, 0.08)',
    },
    tableSkeletonPagination: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        flexWrap: 'wrap',
        gap: theme.spacing(2),
        padding: theme.spacing(1, 2),
        borderTop: '1px solid #d9d9d9',
    },
    groupHeaderRow: {
        backgroundColor: '#e6e6e6',
    },
    groupHeaderCell: {
        padding: '10px 16px !important',
        cursor: 'pointer',
        userSelect: 'none',
    },
    groupHeaderInner: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    studentAvatar: {
        width: 28,
        height: 28,
        backgroundColor: '#1a1a1a',
    },
    classChip: {
        backgroundColor: '#e6e6e6',
        color: '#1a1a1a',
        fontWeight: 600,
        borderRadius: 6,
    },
    dateCell: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        color: '#444',
        whiteSpace: 'nowrap',
    },
    statusDraft: {
        backgroundColor: '#e6e6e6',
        color: '#1a1a1a',
        fontWeight: 600,
        borderRadius: 6,
        cursor: 'pointer',
    },
    statusPublished: {
        backgroundColor: '#e6f7ed',
        color: '#1f8a5b',
        fontWeight: 600,
        borderRadius: 6,
        cursor: 'pointer',
    },
    observationIconAction: {
        color: '#1a1a1a',
        padding: 6,
    },
    observationCell: {
        verticalAlign: 'middle',
        textAlign: 'center',
    },
    observationIconWrap: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 40,
    },
    noteExpandRow: {
        backgroundColor: '#f8fafc',
        '& td': {
            borderBottom: '1px solid #d9d9d9',
            paddingTop: theme.spacing(1.5),
            paddingBottom: theme.spacing(1.5),
        },
    },
    noteExpandBox: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: theme.spacing(1.5),
        padding: theme.spacing(1, 1.5),
        borderRadius: 10,
        border: '1px solid #d9d9d9',
        backgroundColor: '#fff',
    },
    imagesStoreLeftPanel: {
        border: '1px solid #d9d9d9',
        borderRadius: 10,
        overflow: 'hidden',
        maxHeight: 360,
        overflowY: 'auto',
    },
    imagesStoreListItem: {
        '&.Mui-selected': {
            backgroundColor: '#e6e6e6',
        },
    },
    imagesStoreGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(88px, 1fr))',
        gap: theme.spacing(1),
        maxHeight: 360,
        overflowY: 'auto',
        padding: theme.spacing(0.5),
    },
    imagesStoreCard: {
        position: 'relative',
        borderRadius: 8,
        border: '2px solid transparent',
        cursor: 'pointer',
        overflow: 'hidden',
        '&:hover': {
            borderColor: '#c4c4c4',
        },
    },
    imagesStoreCardSelected: {
        borderColor: '#1a1a1a',
    },
    imagesStoreCardDisabled: {
        opacity: 0.45,
        cursor: 'not-allowed',
    },
    imagesStoreThumb: {
        width: '100%',
        height: 72,
        objectFit: 'cover',
        display: 'block',
    },
    imagesStoreVideoThumb: {
        width: '100%',
        height: 72,
        backgroundColor: '#1a1a1a',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    imagesStoreCheck: {
        position: 'absolute',
        top: 4,
        right: 4,
        color: '#1a1a1a',
        backgroundColor: '#fff',
        borderRadius: '50%',
    },
    activityCountBadge: {
        backgroundColor: '#fff',
        color: '#1a1a1a',
        border: '1px solid #c4c4c4',
        borderRadius: 12,
        padding: '1px 10px',
        fontSize: '0.72rem',
        fontWeight: 700,
        marginLeft: 8,
    },
    planDialogPaper: {
        borderRadius: 14,
        width: 330,
        maxWidth: '95vw',
        margin: theme.spacing(2, 'auto'),
        boxSizing: 'border-box',
    },
    dialogTitleBar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(1.75, 2),
        borderBottom: '1px solid #d9d9d9',
    },
    dialogTitleText: {
        fontWeight: 700,
        fontSize: '1.15rem',
        color: '#1a1a1a',
    },
    dialogBody: {
        padding: theme.spacing(2),
        overflowX: 'hidden',
        boxSizing: 'border-box',
    },
    dialogFooter: {
        padding: theme.spacing(1.25, 2),
        borderTop: '1px solid #d9d9d9',
    },
    cancelBtn: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        color: '#444',
        border: '1px solid #8f8f8f',
    },
    saveBtn: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        backgroundColor: '#1a1a1a',
        color: '#fff',
        boxShadow: '0 4px 10px rgba(23,105,214,0.25)',
        '&:hover': { backgroundColor: '#125bbd' },
    },
    formSection: {
        marginBottom: theme.spacing(2),
    },
    sectionLabel: {
        fontWeight: 700,
        color: '#444',
        fontSize: '0.72rem',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        marginBottom: theme.spacing(1.25),
    },
    dateRow: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        columnGap: theme.spacing(1.5),
        alignItems: 'start',
    },
    dateFieldWrap: {
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column',
    },
    dateFieldLabel: {
        display: 'block',
        fontSize: '0.78rem',
        fontWeight: 600,
        color: '#444',
        marginBottom: 6,
        lineHeight: 1.2,
        minHeight: 18,
    },
    dateField: {
        width: '100%',
        margin: 0,
        '& .MuiOutlinedInput-root': {
            width: '100%',
            height: 40,
        },
        '& .MuiOutlinedInput-input': {
            padding: '8px 10px',
            fontSize: '0.8125rem',
        },
        '& input[type="date"]': {
            width: '100%',
            minWidth: 0,
            boxSizing: 'border-box',
        },
        '& .MuiFormHelperText-root': {
            minHeight: 20,
            marginTop: 4,
            marginLeft: 0,
            fontSize: '0.72rem',
            lineHeight: 1.3,
        },
    },
    activityTreeWrap: {
        border: '1px solid #d9d9d9',
        borderRadius: 10,
        padding: theme.spacing(1),
        maxHeight: 280,
        overflowY: 'auto',
        backgroundColor: '#fafbfc',
    },
    keyStepRow: {
        display: 'inline-flex',
        alignItems: 'flex-start',
        gap: 2,
    },
    keyStepItem: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 3,
        minWidth: 52,
        padding: '3px 2px 2px',
        borderRadius: 8,
        userSelect: 'none',
    },
    keyStepItemDoneP: {
        backgroundColor: '#e6f7ed',
    },
    keyStepIconWrap: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 28,
        height: 28,
        borderRadius: '50%',
        boxSizing: 'border-box',
        flexShrink: 0,
    },
    keyStepLabel: {
        fontSize: '0.58rem',
        fontWeight: 600,
        lineHeight: 1.15,
        textAlign: 'center',
        maxWidth: 58,
    },
    keyStepClickable: {
        cursor: 'pointer',
        '&:hover $keyStepIconWrap': {
            boxShadow: '0 0 0 2px rgba(23,105,214,0.25)',
        },
    },
    keyStepDisabled: {
        cursor: 'default',
    },
    keyLegendWrap: {
        display: 'inline-flex',
        alignItems: 'stretch',
        flexWrap: 'wrap',
        gap: 6,
        marginLeft: theme.spacing(0.5),
    },
    keyLegendCard: {
        display: 'inline-flex',
        alignItems: 'flex-start',
        gap: 6,
        padding: '5px 8px',
        borderRadius: 8,
        maxWidth: 168,
        minWidth: 0,
    },
    keyLegendIcon: {
        width: 22,
        height: 22,
        borderRadius: '50%',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        marginTop: 1,
    },
    keyLegendText: {
        minWidth: 0,
        flex: 1,
    },
    keyLegendTitleRow: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 4,
    },
    keyLegendTitle: {
        fontSize: '0.68rem',
        fontWeight: 700,
        lineHeight: 1.2,
    },
    keyLegendDesc: {
        fontSize: '0.58rem',
        color: '#555',
        lineHeight: 1.25,
        marginTop: 1,
    },
    keyLegendBadge: {
        fontSize: '0.52rem',
        fontWeight: 700,
        padding: '1px 5px',
        borderRadius: 4,
        lineHeight: 1.3,
        whiteSpace: 'nowrap',
    },
}));
export default function StudentActivity() {
    const classes = useStyles();
    const history = useHistory();
    const [openHistory, setOpenHistory] = useState(false);
    const [selectedHistory, setSelectedHistory] = useState([]);
    const [historyCurrentKey, setHistoryCurrentKey] = useState('');
    const [selectedActivities, setSelectedActivities] = useState([]);
    const [checkedActivities, setCheckedActivities] = useState([]);
    const [selectedActivityMap, setSelectedActivityMap] = useState({});  // Store relationships between sub-activities and their parents
    const [checkedSubActivities, setCheckedSubActivities] = useState([]);
    const [existingKeySet, setExistingKeySet] = useState(new Set());
    const [existingKeyStudents, setExistingKeyStudents] = useState({});
    const [showOnlyExisting, setShowOnlyExisting] = useState(false);
    /** Tap/click info icon to show note (mobile has no hover; Tooltip alone fails). */
    const [activityNoteDialog, setActivityNoteDialog] = useState({ open: false, title: "", text: "" });
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [openMessageDialog, setOpenMessageDialog] = useState(false);
    const [messageDialogContent, setMessageDialogContent] = useState({ title: '', message: '', type: 'info' });
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [pendingDeleteIds, setPendingDeleteIds] = useState([]);
    const [deletingActivities, setDeletingActivities] = useState(false);
    const [selectedTableActivityIds, setSelectedTableActivityIds] = useState([]);
    const [statusConfirmDialog, setStatusConfirmDialog] = useState({
        open: false,
        activity: null,
        activityIds: [],
        publicStatus: '',
        busy: false,
    });
    const [keyUpdateDialog, setKeyUpdateDialog] = useState({
        open: false,
        activity: null,
        currentKey: '',
        nextKey: '',
        currentLabel: '',
        nextLabel: '',
        deselect: false,
    });
    const [updatingKeyId, setUpdatingKeyId] = useState(null);
    const [uploadingImageId, setUploadingImageId] = useState(null);
    const [deletingMediaKey, setDeletingMediaKey] = useState(null);
    const [printing, setPrinting] = useState(false);
    const [observationExpanded, setObservationExpanded] = useState({});
    const [imagesExpanded, setImagesExpanded] = useState({});
    const [observationDialog, setObservationDialog] = useState({
        open: false,
        activity: null,
        text: '',
        saving: false,
    });
    const [imagesStoreDialog, setImagesStoreDialog] = useState({
        open: false,
        activity: null,
        loading: false,
        saving: false,
        error: '',
        imagesStoreRows: [],
        selectedStoreId: IMAGES_STORE_ALL_KEY,
        selectedUrls: [],
    });
    const [imageAddMenu, setImageAddMenu] = useState({
        anchorEl: null,
        activity: null,
        uploadInputId: '',
    });
    const [openUnmasteredDialog, setOpenUnmasteredDialog] = useState(false);
    const [unmasteredActivitiesList, setUnmasteredActivitiesList] = useState([]);
    const [pendingFormValues, setPendingFormValues] = useState(null);
    const [pendingResetForm, setPendingResetForm] = useState(null);
    const [groupedUnmasteredActivities, setGroupedUnmasteredActivities] = useState({}); // Grouped by studentId._id
    const [filteredUnmasteredActivities, setFilteredUnmasteredActivities] = useState([]); // Activities for selected students

    const [activityList, setActivityList] = useState([]);
    const [studentList, setStudentList] = useState([]);
    const [selectedAgeFilter, setSelectedAgeFilter] = useState('');
    const [subActivityList, setSubActivityList] = useState([]);
    const [studentReportList, setStudentReportList] = useState([]);
    const [classNameList, setClassNameList] = useState([]);
    const [age, setAge] = React.useState('');
    var [error, setError] = useState(null);
    const [activityIdList, setActivityIdList] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [isAdd, setIsAdd] = React.useState(false);
    const [subActivityIdList, setSubActivityIdList] = useState([]);
    const [addActivityList, setAddActivityList] = useState([]);
    const [addSuperActivityList, setAddSuperActivityList] = useState([]);
    const [startDate1, setStartDate1] = useState('');
    const [endDate1, setEndDate1] = useState('');
    const [addClassList, setAddClassList] = useState([]);
    const [sectionList, setSectionList] = useState([]);
    const [sectionId, setSectionId] = useState('');
    const [dialogSectionList, setDialogSectionList] = useState([]);
    const [studentReportResult, setStudentReportResult] = useState([]);
    var [studentId, setStudentId] = useState("");
    var [classId, setClassId] = useState("");
    const today = new Date();
    const [keyList, setKeyList] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [addActivityLoading, setAddActivityLoading] = useState(false);
    /** Per-student table sections: true = expanded; omitted/false = collapsed */
    const [studentActivityRowsExpanded, setStudentActivityRowsExpanded] = useState({});
    /** Per-student key filter: studentKey -> 'P'|'WA'|'WI'|'M'|'notSet' (or undefined for all) */
    const [studentKeyFilters, setStudentKeyFilters] = useState({});

    const getStudentGroupKey = (group, index) =>
        String(group?.studentId?._id ?? group?.studentId ?? `idx-${index}`);

    const isStudentActivityExpanded = (key) => studentActivityRowsExpanded[key] === true;

    const toggleStudentActivityRows = (key) => {
        setStudentActivityRowsExpanded((prev) => ({
            ...prev,
            [key]: !(prev[key] === true),
        }));
    };

    const toggleStudentKeyFilter = (studentKey, keyValue) => {
        setStudentKeyFilters((prev) => {
            const next = { ...prev };
            if (next[studentKey] === keyValue) {
                delete next[studentKey];
            } else {
                next[studentKey] = keyValue;
            }
            return next;
        });
        setStudentActivityRowsExpanded((prev) => ({ ...prev, [studentKey]: true }));
    };

    const collapseAllStudentActivityRows = () => setStudentActivityRowsExpanded({});

    // ---- New UI state for the redesigned Activity Planner screen ----
    const [filtersOpen, setFiltersOpen] = useState(true);
    const [quickRange, setQuickRange] = useState('custom');
    const [statusFilter, setStatusFilter] = useState('all');
    const [keyFilter, setKeyFilter] = useState('all');
    const [tableSearch, setTableSearch] = useState('');
    const [tableSearchDebounced, setTableSearchDebounced] = useState('');
    const fetchRequestIdRef = useRef(0);
    const filterDebounceRef = useRef(null);
    const searchDebounceRef = useRef(null);
    /** false = hide mastered; true = include mastered (M) along with other keys */
    const [showMaster, setShowMaster] = useState(false);
    const [activityTableLoading, setActivityTableLoading] = useState(true);
    const [pg, setpg] = React.useState(0);
    const [rpg, setrpg] = React.useState(20);
    // Total number of student groups on the server (drives TablePagination
    // count now that paging happens server-side).
    const [activityTotal, setActivityTotal] = useState(0);
    useEffect(() => {
        if (rpg > 100) setrpg(100);
    }, [rpg]);
    // Latest committed page/rowsPerPage, read synchronously by refreshActivityTable
    // so it can request the right server page without being re-created on every
    // page change (which would otherwise retrigger the debounced filter effect).
    const pgRef = useRef(pg);
    pgRef.current = pg;
    const rpgRef = useRef(rpg);
    rpgRef.current = rpg;
    const [columnMenuAnchor, setColumnMenuAnchor] = useState(null);
    const [howItWorksOpen, setHowItWorksOpen] = useState(false);
    const [actionMenu, setActionMenu] = useState({ anchorEl: null, activity: null, group: null });
    const [visibleCols, setVisibleCols] = useState({
        areaOfWork: true,
        listOfActivities: true,
        exercises: true,
        createdBy: true,
        key: true,
        startDate: true,
        endDate: true,
        status: true,
        images: true,
        observation: true,
    });

    const columnConfig = [
        { id: 'areaOfWork', label: 'Area Of Work' },
        { id: 'listOfActivities', label: 'List Of Activities' },
        { id: 'exercises', label: 'Exercises' },
        { id: 'createdBy', label: 'Created By' },
        { id: 'key', label: 'Key' },
        { id: 'observation', label: 'Observation' },
        { id: 'startDate', label: 'Start Date' },
        { id: 'endDate', label: 'End Date' },
       
        { id: 'status', label: 'Status' },
        { id: 'images', label: 'Images' },
    ];

    const openActionMenu = (event, activity, group) => {
        setActionMenu({ anchorEl: event.currentTarget, activity, group });
    };
    const closeActionMenu = () => setActionMenu({ anchorEl: null, activity: null, group: null });

    const isActivityPublishedToParent = (activity) =>
        String(activity?.publicStatus || '').toLowerCase() === 'publish';

    // Filter a single activity record against the More Filters + table search
    const matchesActivityFilters = (activity, studentName) => {
        if (statusFilter !== 'all') {
            const isDraft = !isActivityPublishedToParent(activity);
            if (statusFilter === 'draft' && !isDraft) return false;
            if (statusFilter === 'published' && isDraft) return false;
        }
        if (keyFilter !== 'all' && activity.key !== keyFilter) return false;
        // Default: hide mastered. Show Master: include M with P/WA/WI (and empty).
        if (!showMaster && activity.key === 'M') {
            return false;
        }
        const term = tableSearchDebounced.trim().toLowerCase();
        if (term) {
            const haystack = [
                studentName,
                activity.classId?.className,
                activity.sectionId?.sectionName,
                activity.superActivityId?.superActivityName,
                activity.activityId?.activityName,
                activity.subActivityId?.subActivityName,
                activity.remarks,
                getCreatedByLabel(activity.createdBy),
            ].filter(Boolean).join(' ').toLowerCase();
            if (!haystack.includes(term)) return false;
        }
        return true;
    };

    // Count of currently active filters (for the Filters badge)
    const activeFilterCount = [
        classId,
        sectionId,
        studentId,
        startDate1 && endDate1 ? 'range' : '',
        statusFilter !== 'all' ? 'status' : '',
        keyFilter !== 'all' ? 'key' : '',
    ].filter(Boolean).length;

    const pad2 = (n) => String(n).padStart(2, '0');
    const toIso = (d) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;

    // Quick range selector ("This Week" / "This Month" / "Custom")
    const applyQuickRange = (range) => {
        setQuickRange(range);
        if (range === 'week') {
            const w = getWeekStartEnd(new Date());
            setStartDate1(w.start);
            setEndDate1(w.end);
        } else if (range === 'month') {
            const now = new Date();
            const first = new Date(now.getFullYear(), now.getMonth(), 1);
            const last = new Date(now.getFullYear(), now.getMonth() + 1, 0);
            setStartDate1(toIso(first));
            setEndDate1(toIso(last));
        } else {
            setStartDate1('');
            setEndDate1('');
        }
    };

    // Reset all filters back to default
    const handleResetFilters = () => {
        setClassId('');
        setSectionId('');
        setStudentId('');
        setStartDate1('');
        setEndDate1('');
        setSectionList([]);
        setStudentList([]);
        setStatusFilter('all');
        setKeyFilter('all');
        setShowMaster(false);
        setQuickRange('custom');
        setTableSearch('');
        setTableSearchDebounced('');
    };

    const handleTableSearchChange = useCallback((e) => {
        const value = e.target.value;
        setTableSearch(value);
        if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);
        searchDebounceRef.current = setTimeout(() => {
            setTableSearchDebounced(value);
        }, 250);
    }, []);

    const headerCellStyle = {
        backgroundColor: '#efefef',
        color: '#444',
        fontWeight: 700,
        fontSize: '0.8rem',
        borderBottom: '1px solid #d9d9d9',
    };

    // Checkbox + Class + Section + visible dynamic columns + Actions
    const visibleColumnCount = 3 + columnConfig.filter((c) => visibleCols[c.id]).length + 1;

    const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
    const canMutateActivity = (activity) => canMutatePlannerActivity(activity, userDetails);

    const visiblePaginatedActivityIds = useMemo(() => {
        const ids = [];
        // Server already returns only the current page of groups.
        activityList
            .forEach((group, groupIndex) => {
                const studentName = `${group.studentId?.firstName || ''} ${group.studentId?.lastName || ''}`.trim();
                const records = (group.activityRecordsId || [])
                    .filter(isActivityRecord)
                    .filter((a) => matchesActivityFilters(a, studentName));
                const studentKey = getStudentGroupKey(group, groupIndex);
                const activeKeyFilter = studentKeyFilters[studentKey];
                const displayRecords = activeKeyFilter
                    ? records.filter((rec) => {
                        const idx = getActivityKeyIndex(rec.key);
                        return activeKeyFilter === 'notSet'
                            ? idx === -1
                            : KEY_SEQUENCE[idx] === activeKeyFilter;
                    })
                    : records;
                displayRecords.forEach((activity) => {
                    if (activity?._id && canMutateActivity(activity)) {
                        ids.push(String(activity._id));
                    }
                });
            });
        return ids;
    }, [
        activityList,
        pg,
        rpg,
        statusFilter,
        keyFilter,
        tableSearchDebounced,
        studentKeyFilters,
    ]);

    const selectedIdSet = useMemo(
        () => new Set(selectedTableActivityIds),
        [selectedTableActivityIds]
    );

    const exportExcelData = useMemo(() => buildExportRows(activityList), [activityList]);

    const studentAgeWiseSummary = useMemo(() => buildAgeWiseSummary(studentList), [studentList]);

    const dialogStudentList = useMemo(() => {
        if (!selectedAgeFilter) return studentList;
        return studentList.filter((s) => s.ageGroupLabel === selectedAgeFilter);
    }, [studentList, selectedAgeFilter]);

    const getStudentsInAgeGroup = (ageLabel) => {
        if (!ageLabel) return studentList;
        return studentList.filter((s) => s.ageGroupLabel === ageLabel);
    };

    const allVisibleActivitiesSelected =
        visiblePaginatedActivityIds.length > 0
        && visiblePaginatedActivityIds.every((id) => selectedIdSet.has(id));
    const someVisibleActivitiesSelected =
        visiblePaginatedActivityIds.some((id) => selectedIdSet.has(id));

    const toggleActivitySelection = (activityId) => {
        const id = String(activityId);
        setSelectedTableActivityIds((prev) =>
            prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
        );
    };

    const toggleSelectAllVisibleActivities = () => {
        if (allVisibleActivitiesSelected) {
            setSelectedTableActivityIds((prev) =>
                prev.filter((id) => !visiblePaginatedActivityIds.includes(id))
            );
            return;
        }
        setSelectedTableActivityIds((prev) => [
            ...new Set([...prev, ...visiblePaginatedActivityIds]),
        ]);
    };

    const getActivityLabelsForIds = (ids) => {
        const idSet = new Set((ids || []).map(String));
        const labels = [];
        activityList.forEach((group) => {
            (group.activityRecordsId || []).forEach((record) => {
                if (!isActivityRecord(record) || !idSet.has(String(record._id))) return;
                const studentName = `${group.studentId?.firstName || ''} ${group.studentId?.lastName || ''}`.trim();
                const activityName = record.activityId?.activityName || 'Activity';
                const exerciseName = record.subActivityId?.subActivityName;
                const label = [studentName, activityName, exerciseName].filter(Boolean).join(' — ');
                labels.push(label || 'Activity');
            });
        });
        return labels;
    };

    const keyOptions = [
        { label: 'Presented(1)', value: 'P' },
        { label: 'Works with Assistance(2)', value: 'WA' },
        { label: 'Works Independently(3)', value: 'WI' },
        { label: 'Mastered(4)', value: 'M' }
    ];

    // Function to get color styling for key status
    const getKeyStatusStyle = (key) => {
        switch (key) {
            case 'P': // Presented
                return {
                    backgroundColor: '#2196F3', // Blue
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontWeight: '500',
                    display: 'inline-block'
                };
            case 'WA': // Work with Assistance
                return {
                    backgroundColor: '#FF9800', // Orange
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontWeight: '500',
                    display: 'inline-block'
                };
            case 'WI': // Work Independently
                return {
                    backgroundColor: '#9C27B0', // Purple
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontWeight: '500',
                    display: 'inline-block'
                };
            case 'M': // Mastered
                return {
                    backgroundColor: '#4CAF50', // Green
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontWeight: '500',
                    display: 'inline-block'
                };
            default:
                return {};
        }
    };

    // Function to get key status text
    const getKeyStatusText = (key) => {
        switch (key) {
            case 'P':
                return 'Presented';
            case 'WA':
                return 'Work with Assistance';
            case 'WI':
                return 'Work Independently';
            case 'M':
                return 'Mastered';
            default:
                return key || 'Not set';
        }
    };

    const openKeyUpdateDialog = (activity, currentKey, nextKey) => {
        setKeyUpdateDialog({
            open: true,
            activity,
            currentKey,
            nextKey,
            currentLabel: getKeyStatusText(currentKey),
            nextLabel: getKeyStatusText(nextKey),
            deselect: false,
        });
    };

    const openKeyDeselectDialog = (activity, currentKey) => {
        setKeyUpdateDialog({
            open: true,
            activity,
            currentKey,
            nextKey: '',
            currentLabel: getKeyStatusText(currentKey),
            nextLabel: getKeyStatusText(''),
            deselect: true,
        });
    };

    const handleKeyUpdateCancel = () => {
        setKeyUpdateDialog({
            open: false,
            activity: null,
            currentKey: '',
            nextKey: '',
            currentLabel: '',
            nextLabel: '',
            deselect: false,
        });
    };

    const patchActivityInList = (activityId, apiRecord) => {
        setActivityList((prev) => applyActivityRecordPatch(prev, activityId, apiRecord, showMaster));
    };

    const handleKeyUpdateConfirm = async () => {
        const { activity, nextKey, deselect } = keyUpdateDialog;
        if (!activity?._id) return;
        if (!deselect && !nextKey) return;

        setUpdatingKeyId(activity._id);
        try {
            const response = await ActivityService.updateActivityStatus({ id: activity._id, key: nextKey });
            const clearedKey = deselect ? '' : nextKey;
            const apiRecord = response?.activityRecord
                ? { ...response.activityRecord, key: clearedKey }
                : { key: clearedKey };
            patchActivityInList(activity._id, apiRecord);
            handleKeyUpdateCancel();
            setMessageDialogContent({
                title: 'Success',
                message: response?.message || (deselect ? 'Activity status removed successfully.' : 'Activity key updated successfully.'),
                type: 'success',
            });
            setOpenMessageDialog(true);
        } catch (err) {
            const apiMessage = err.response?.data?.message ?? err.response?.data ?? err.message;
            setMessageDialogContent({
                title: 'Error',
                message: normalizeDialogMessage(apiMessage) || 'Failed to update activity key.',
                type: 'error',
            });
            setOpenMessageDialog(true);
        } finally {
            setUpdatingKeyId(null);
        }
    };

    const renderActivityTableSkeleton = () =>
        Array.from({ length: 6 }).map((_, index) => (
            <TableRow key={`activity-skeleton-${index}`} className={classes.groupHeaderRow}>
                <TableCell
                    colSpan={visibleColumnCount}
                    className={classes.groupHeaderCell}
                    style={{ cursor: 'default' }}
                >
                    <Box className={classes.groupHeaderInner}>
                        <Box display="flex" alignItems="center" gridGap={10}>
                            <Skeleton variant="circle" width={28} height={28} animation="wave" classes={{ root: classes.skeletonBar }} />
                            <Skeleton
                                variant="text"
                                width={120 + (index % 3) * 36}
                                height={24}
                                animation="wave"
                                classes={{ root: classes.skeletonBar }}
                            />
                            <Skeleton
                                variant="rect"
                                width={index % 2 === 0 ? 76 : 64}
                                height={20}
                                animation="wave"
                                style={{ borderRadius: 12 }}
                                classes={{ root: classes.skeletonBar }}
                            />
                        </Box>
                        <Skeleton variant="circle" width={20} height={20} animation="wave" classes={{ root: classes.skeletonBar }} />
                    </Box>
                </TableCell>
            </TableRow>
        ));

    const renderKeyStatusStepper = (activity, group) => {
        const isUpdating = updatingKeyId === activity._id;
        const currentKey = normalizeActivityKey(activity.key);
        const currentIndex = getActivityKeyIndex(activity.key);
        const canEditKeys = !isUpdating && canMutateActivity(activity);

        if (isUpdating) {
            return <CircularProgress size={14} />;
        }

        return (
            <Box className={classes.keyStepRow}>
                {keyOptions.map((option) => {
                    const stepIndex = KEY_SEQUENCE.indexOf(option.value);
                    const color = KEY_CIRCLE_COLORS[option.value];
                    const meta = KEY_STEP_META[option.value];
                    const StepIcon = meta.Icon;
                    const optionKey = normalizeActivityKey(option.value);
                    const isCurrent = Boolean(currentKey) && optionKey === currentKey;
                    const isDone = currentIndex >= 0 && stepIndex < currentIndex;
                    const isComplete = isDone || isCurrent;
                    const isClickable = canEditKeys;

                    const iconWrapStyle = {
                        border: `2px solid ${KEY_INCOMPLETE_COLOR}`,
                        backgroundColor: '#fff',
                        color: KEY_INCOMPLETE_COLOR,
                    };
                    let labelColor = KEY_INCOMPLETE_LABEL;

                    if (isComplete) {
                        labelColor = color;
                        if (isDone) {
                            iconWrapStyle.backgroundColor = color;
                            iconWrapStyle.border = `2px solid ${color}`;
                            iconWrapStyle.color = '#fff';
                        } else {
                            iconWrapStyle.backgroundColor = '#fff';
                            iconWrapStyle.border = `2px solid ${color}`;
                            iconWrapStyle.color = color;
                        }
                    }

                    const itemClassName = [
                        classes.keyStepItem,
                        isDone && option.value === 'P' && classes.keyStepItemDoneP,
                        isClickable && classes.keyStepClickable,
                        !isClickable && classes.keyStepDisabled,
                    ].filter(Boolean).join(' ');

                    const handleStepClick = (e) => {
                        if (!isClickable) return;
                        e.stopPropagation();
                        if (isCurrent) {
                            openKeyDeselectDialog(activity, currentKey);
                        } else {
                            openKeyUpdateDialog(activity, currentKey, option.value);
                        }
                    };

                    const tooltipTitle = isClickable
                        ? isCurrent
                            ? `${meta.shortLabel} (current) — click to deselect`
                            : isDone
                                ? `${meta.shortLabel} — click to change back`
                                : `${meta.shortLabel} — click to update`
                        : isCurrent
                            ? `${meta.shortLabel} (current)`
                            : isDone
                                ? `${meta.shortLabel} (completed)`
                                : meta.shortLabel;

                    const stepContent = (
                        <Box
                            className={itemClassName}
                            onClick={handleStepClick}
                            onKeyDown={(e) => {
                                if (isClickable && (e.key === 'Enter' || e.key === ' ')) {
                                    e.preventDefault();
                                    if (isCurrent) {
                                        openKeyDeselectDialog(activity, currentKey);
                                    } else {
                                        openKeyUpdateDialog(activity, currentKey, option.value);
                                    }
                                }
                            }}
                            role={isClickable ? 'button' : undefined}
                            tabIndex={isClickable ? 0 : -1}
                            aria-label={tooltipTitle}
                            aria-disabled={!isClickable}
                        >
                            <span className={classes.keyStepIconWrap} style={iconWrapStyle}>
                                <StepIcon style={{ fontSize: isDone && option.value === 'P' ? 16 : 15 }} />
                            </span>
                            <Typography
                                component="span"
                                className={classes.keyStepLabel}
                                style={{ color: labelColor }}
                            >
                                {meta.shortLabel}
                            </Typography>
                        </Box>
                    );

                    return (
                        <Tooltip key={option.value} title={tooltipTitle} arrow>
                            <span style={{ display: 'inline-flex' }}>{stepContent}</span>
                        </Tooltip>
                    );
                })}
            </Box>
        );
    };

    // Format a stored date per the school's configured date format.
    const formatDate = (dateString) => formatDateShared(dateString) || dateString || '';

    const getWeekStartEnd = (date) => {
        const startOfWeek = new Date(date);
        startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay());
        const endOfWeek = new Date(date);
        endOfWeek.setDate(endOfWeek.getDate() + (5 - endOfWeek.getDay()));

        let startDay = startOfWeek.getDate();
        let startMonth = startOfWeek.getMonth() + 1;
        let startYear = startOfWeek.getFullYear();
        if (startDay < 10) {
            startDay = '0' + startDay;
        }

        if (startMonth < 10) {
            startMonth = `0${startMonth}`;
        }
        let format = startYear + "-" + startMonth + "-" + startDay;

        let endDay = endOfWeek.getDate();
        let endMonth = endOfWeek.getMonth() + 1;
        let endYear = endOfWeek.getFullYear();
        if (endDay < 10) {
            endDay = '0' + endDay;
        }

        if (endMonth < 10) {
            endMonth = `0${endMonth}`;
        }

        let format1 = endYear + "-" + endMonth + "-" + endDay;

        return { start: format, end: format1 };
    }
    const date = new Date();
    const week = getWeekStartEnd(date);
    const year = today.getFullYear();

    const [activity, setActivity] = useState({
        classId: '',
        sectionId: '',
        // date: new Date().toISOString().split("T")[0],
        // studentId: '',
        studentId: [],
        superActivityId: '',
        activityId: '',
        subActivityId: '',
        key: '',
        remarks: '',
        // planning: '',
        isEdit: false,
        endDate: '',
        date: '',
    });

    const handleChangePage = (event, newpage) => {
        setpg(newpage);
        refreshActivityTable(undefined, undefined, { page: newpage });
    }
    const verifyeetnt = () => {};
    const formRefs = {
        date: React.useRef(),
        endDate: React.useRef(),
        classId: React.useRef(),
        studentId: React.useRef(),
    };
    const filterTreeNode = (node) => {
        if (searchTerm === "") return true;
        const term = searchTerm.toLowerCase();

        // Check if current node matches
        if (node.superActivityName?.toLowerCase().includes(term) ||
            node.activityName?.toLowerCase().includes(term) ||
            node.subActivityName?.toLowerCase().includes(term)) {
            return true;
        }

        // Check children (activities)
        if (node.activities?.some(activity =>
            activity.activityName?.toLowerCase().includes(term) ||
            activity.subActivities?.some(sub =>
                sub.subActivityName?.toLowerCase().includes(term)
            )
        )) {
            return true;
        }

        // Check sub-activities
        if (node.subActivities?.some(sub =>
            sub.subActivityName?.toLowerCase().includes(term)
        )) {
            return true;
        }

        return false;
    };
    const handleChangeRowsPerPage = (event) => {
        const newLimit = parseInt(event.target.value, 10);
        setrpg(newLimit);
        setpg(0);
        refreshActivityTable(undefined, undefined, { page: 0, limit: newLimit });
    }
    const getAllSuperActivityTabelMultiple = (event, obj) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const schooleId =
            userDetails?.schooleId?._id ||
            userDetails?.schooleId ||
            userDetails?.schoolId?._id ||
            userDetails?.schoolId;
        // catalogType is resolved server-side from the school registration.
        const getsupActList = {
            classId: event.target.value,
            schooleId,
        };

        SuperActivityService.getAllSuperActivityTabelMultiple(getsupActList).then((res) => {
            setSelectedActivities(filterCatalogTreeBySchool(res, schooleId));
        }).catch((err) => {
            // setError(err.message);
        });
    }
    // const handleChangePage = (event, newPage) => {
    //     setPage(newPage);
    //   };

    //   const handleChangeRowsPerPage = (event) => {
    //     setRowsPerPage(parseInt(event.target.value, 10));
    //     setPage(0);
    //   };
    // classId: Yup.string().required('Class Name is required'),

    const validationSchema = Yup.object().shape({
        classId: Yup.string().required('Class Name is required'),
       // date: Yup.string(new Date().toISOString().split("T")[0]).required('Date is required'),
        studentId: Yup.array(),
        activityId: Yup.string(),
        subActivityId: Yup.string().nullable(),
        key: Yup.string(),
        // academicYear:Yup.string(),
        remarks: Yup.string(),
        planning: Yup.string(),
        //date: Yup.string().nullable(),
        isEdit: Yup.boolean(),
        _id: Yup.string().nullable(),
        date: Yup.string().required('date is required'),
        endDate: Yup.string().required('date is required'),
        isEventForAllStudent: Yup.boolean(),
    });
    useEffect(() => {
        getAddClassList();
        return () => {
            fetchRequestIdRef.current += 1;
            if (filterDebounceRef.current) clearTimeout(filterDebounceRef.current);
            if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);
        };
    }, []);
    // useEffect(() => {
    //     //getActivityList();
    //     onSubmit();
    //     // getStudentActivityList();

    //     getAddClassList();
    //     //  getSuperActivityList();
    //     return () => {
    //         setSubActivityList([]);
    //         setActivityIdList([]);
    //         setActivityList([]);
    //         setStudentList([]);
    //         setAddSuperActivityList([]);
    //         setStudentReportList([]);
    //     }
    // }, []);
    
    // Function to check for duplicate activities
    // const checkDuplicateActivities = async (studentIds, activityRelationships, isEventForAllStudent, classId) => {
    //     const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    //     const duplicates = [];
        
    //     // Get all students to check (handle "For All Class Students" case)
    //     let studentsToCheck = studentIds;
    //     if (isEventForAllStudent && classId) {
    //         // If "For All Class Students" is checked, fetch all students in the class
    //         try {
    //             const allStudents = await StudentService.getAllStudentById(userDetails.schooleId, { classId });
    //             studentsToCheck = allStudents.map(student => student._id);
    //         } catch (error) {
    //             console.error('Error fetching all students:', error);
    //             // Fallback to selected students if fetch fails
    //             studentsToCheck = studentIds;
    //         }
    //     }

    //     // Check each student and activity combination
    //     for (const studentId of studentsToCheck) {
    //         for (const [key, relationship] of Object.entries(activityRelationships)) {
    //             const checkData = {
    //                 schooleId: userDetails.schooleId,
    //                 classId: classId,
    //                 studentId: studentId,
    //                 isFuturePlanning: false
    //             };

    //             try {
    //                 const existingActivities = await ActivityService.findActivityList(checkData);
                    
    //                 // Check if any activity record matches
    //                 if (existingActivities && existingActivities.length > 0) {
    //                     for (const activityGroup of existingActivities) {
    //                         if (activityGroup.activityRecordsId && activityGroup.activityRecordsId.length > 0) {
    //                             const matchingRecord = activityGroup.activityRecordsId.find(record => {
    //                                 const activityMatch = record.activityId?._id === relationship.activityId;
    //                                 const subActivityMatch = relationship.subActivityId 
    //                                     ? record.subActivityId?._id === relationship.subActivityId
    //                                     : !record.subActivityId; // If no subActivity in relationship, check for null in record
    //                                 return activityMatch && subActivityMatch;
    //                             });
                                
    //                             if (matchingRecord) {
    //                                 const studentName = activityGroup.studentId 
    //                                     ? `${activityGroup.studentId.firstName} ${activityGroup.studentId.lastName}`
    //                                     : 'Unknown Student';
    //                                 const activityName = matchingRecord.activityId?.activityName || 'Unknown Activity';
    //                                 const subActivityName = matchingRecord.subActivityId?.subActivityName || '';
    //                                 duplicates.push({
    //                                     studentId,
    //                                     studentName,
    //                                     activityName,
    //                                     subActivityName: subActivityName || 'N/A'
    //                                 });
    //                             }
    //                         }
    //                     }
    //                 }
    //             } catch (error) {
    //                 console.error('Error checking duplicates:', error);
    //             }
    //         }
    //     }
        
    //     return duplicates;
    // };

    // Function to fetch and group unmastered activities by studentId
    const fetchAndGroupUnmasteredActivities = async (classId, schooleId) => {
        try {
            if (!classId || !schooleId) {
                setGroupedUnmasteredActivities({});
                return;
            }

            // Get all students in the class
        

            const checkData = {
                schooleId: schooleId,
                classId: classId,
                sectionId: sectionId || undefined,
            };

            const response = await ActivityService.getUnmasteredActivities(checkData);
            const responseData = response.data || response;
            
            if (responseData && responseData.success && responseData.activities) {
                // Group activities by studentId._id
                const grouped = {};
                responseData.activities.forEach(activity => {
                    const studentIdKey = activity.studentId?._id;
                    if (studentIdKey) {
                        if (!grouped[studentIdKey]) {
                            grouped[studentIdKey] = [];
                        }
                        grouped[studentIdKey].push(activity);
                    }
                });
                setGroupedUnmasteredActivities(grouped);
            } else {
                setGroupedUnmasteredActivities({});
            }
        } catch (error) {
            console.error('Error fetching unmastered activities:', error);
            setGroupedUnmasteredActivities({});
        }
    };

    // Function to check unmastered activities before submitting
    const checkUnmasteredActivitiesBeforeSubmit = async (studentIds, classId, isEventForAllStudent, schooleId) => {
        try {
            let studentsToCheck = studentIds || [];
            // If "For All Class Students" is selected, fetch all students in the class
            if (isEventForAllStudent && classId) {
                try {
                    const allStudents = await StudentService.getAllStudentById(schooleId, { classId });
                    studentsToCheck = allStudents.map(student => student._id);
                } catch (error) {
                    console.error('Error fetching all students:', error);
                    studentsToCheck = studentIds || [];
                }
            }

            if (!studentsToCheck || studentsToCheck.length === 0) {
                return { hasUnmastered: false, activities: [], count: 0 };
            }

            const checkData = {
                studentId: studentsToCheck,
                schooleId: schooleId,
                classId: classId,
                sectionId: sectionId || undefined,
            };

            const response = await ActivityService.getUnmasteredActivities(checkData);
            const responseData = response.data || response;
            
            if (responseData && responseData.success && responseData.count > 0) {
                return {
                    hasUnmastered: true,
                    activities: responseData.activities || [],
                    count: responseData.count || 0
                };
            }

            return {
                hasUnmastered: false,
                activities: [],
                count: 0
            };
        } catch (error) {
            console.error('Error checking unmastered activities:', error);
            return { hasUnmastered: false, activities: [], count: 0 };
        }
    };

    // Function to submit activity after user confirms
    const resetActivityForm = () => {
        setActivity({
            classId: classId || '',
            sectionId: sectionId || '',
            studentId: [],
            superActivityId: '',
            activityId: '',
            subActivityId: '',
            key: '',
            remarks: '',
            isEdit: false,
            endDate: '',
            date: '',
            sfd: '',
        });
    };

    const refreshExistingActivityKeys = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
        const schooleId = userDetails.schooleId?._id || userDetails.schooleId || userDetails.schoolId?._id || userDetails.schoolId;
        if (!schooleId || !classId) {
            setExistingKeySet(new Set());
            setExistingKeyStudents({});
            return Promise.resolve();
        }
        return ActivityService.getExistingActivityKeys({
            schooleId,
            classId,
            sectionId: sectionId || null,
            studentId: [],
            isEventForAllStudent: false,
        }).then((r) => {
            const data = r?.data || r;
            const keys = Array.isArray(data?.keys) ? data.keys : [];
            setExistingKeySet(new Set(keys));
            setExistingKeyStudents(data?.byKey || {});
        }).catch(() => {
            setExistingKeySet(new Set());
            setExistingKeyStudents({});
        });
    };

    const refreshActivityTable = useCallback((startDate, endDate, opts = {}) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const newstartDate = startDate1 || startDate || "";
        const newendDate = endDate1 || endDate || "";

        // Server-side pagination: request only the current page of student
        // groups. Overrides (page/limit) let handlers request an exact page
        // without waiting for the pg/rpg state to commit.
        const page = opts.page !== undefined ? opts.page : pgRef.current;
        const limit = opts.limit !== undefined ? opts.limit : rpgRef.current;

        const keys = {
            schooleId: userDetails.schooleId,
            isFuturePlanning: false,
            studentId,
            classId,
            sectionId: sectionId || undefined,
            status: true,
            page,
            limit,
        };
        if (newstartDate && newendDate) {
            keys.startDate1 = newstartDate;
            keys.endDate1 = newendDate;
        }
        keys.showMaster = Boolean(showMaster);

        const requestId = fetchRequestIdRef.current + 1;
        fetchRequestIdRef.current = requestId;
        setActivityTableLoading(true);

        return ActivityService.findActivityList(keys)
            .then((res) => {
                if (requestId !== fetchRequestIdRef.current) return [];
                // Paginated response is { data, total, ... }; fall back to a
                // plain array for safety / backward compatibility.
                const list = Array.isArray(res) ? res : (Array.isArray(res?.data) ? res.data : []);
                const total = Array.isArray(res) ? list.length : (Number(res?.total) || 0);
                setActivityList(list);
                setActivityTotal(total);
                setObservationExpanded({});
                setImagesExpanded({});
                collapseAllStudentActivityRows();
                return list;
            })
            .catch(() => [])
            .finally(() => {
                if (requestId === fetchRequestIdRef.current) {
                    setActivityTableLoading(false);
                }
            });
    }, [classId, sectionId, studentId, startDate1, endDate1, showMaster]);

    const submitActivityAfterConfirmation = (values, resetForm) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        let currentYear = new Date().getFullYear();
        let nextYear = new Date().getFullYear() + 1;
        values['academicYear'] = currentYear + "-" + nextYear;
        values.subActivityId = (values.subActivityId && values.subActivityId.trim() !== '') ? values.subActivityId : null;
        values.date = values.date ? values.date : new Date().toISOString().split("T")[0];
        values.isEventForAllStudent = values.isEventForAllStudent || false;
        values.schooleId = userDetails.schooleId;
        // Section is optional: only apply the section explicitly chosen in the
        // dialog (do not fall back to the page-level section filter).
        values.sectionId = values.sectionId || null;
        values.authorizedPerson = userDetails.email;
        values.teacherId = userDetails.teacherId || null;
        values.isFuturePlanning = false;
        if (!values.activityRelationships || Object.keys(values.activityRelationships).length === 0) {
            values.activityRelationships = selectedActivityMap;
        }
        
        setAddActivityLoading(true);
        ActivityService.creteMultipleActivity(values).then(async () => {
            setpg(0);
            await refreshActivityTable(undefined, undefined, { page: 0 });
            await refreshExistingActivityKeys();
            setAddActivityLoading(false);
            resetForm();
            resetActivityForm();
            setCheckedActivities([]);
            setSelectedActivityMap({});
            setCheckedSubActivities([]);
            handleClose();
            setMessageDialogContent({
                title: 'Success',
                message: 'Activity Added Successfully.',
                type: 'success'
            });
            setOpenMessageDialog(true);
        }).catch((err) => {
            setAddActivityLoading(false);
            setMessageDialogContent({
                title: 'Error',
                message: err.response?.data?.message || 'Failed to add activity.',
                type: 'error'
            });
            setOpenMessageDialog(true);
        });
    };

    const formik = useFormik({
        initialValues: activity,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: async (values, { resetForm }) => {
            const userDetails = JSON.parse(localStorage.getItem("userDetail"));
            values.schooleId = userDetails.schooleId;
            values.authorizedPerson = userDetails.email
            values.isFuturePlanning = false
            // Section is optional: use only the section explicitly chosen in the
            // dialog. Do NOT fall back to the page-level section filter, otherwise
            // adding for a class with no section wrongly triggers a section error.
            values.sectionId = values.sectionId || null;
            values.activityRelationships = selectedActivityMap;

            const recordId = values._id || activity._id;

            if (recordId) {
                const payload = { ...values, _id: recordId };
                try {
                    await ActivityService.upadeActivity(payload);
                    setpg(0);
                    await refreshActivityTable(undefined, undefined, { page: 0 });
                    await refreshExistingActivityKeys();
                    handleClose();
                    resetForm();
                    resetActivityForm();
                    setMessageDialogContent({
                        title: 'Success',
                        message: 'Activity Updated Successfully.',
                        type: 'success'
                    });
                    setOpenMessageDialog(true);
                } catch (err) {
                    setMessageDialogContent({
                        title: 'Error',
                        message: err.response?.data?.message || 'Failed to update activity.',
                        type: 'error'
                    });
                    setOpenMessageDialog(true);
                }
            }
            else if (values.isEdit) {
                if (!values.activityId || !values.superActivityId) {
                    setMessageDialogContent({
                        title: 'Validation Error',
                        message: 'Please select area of work and activity before adding more.',
                        type: 'error'
                    });
                    setOpenMessageDialog(true);
                    return;
                }
                if (!values.studentId || values.studentId.length === 0) {
                    setMessageDialogContent({
                        title: 'Validation Error',
                        message: 'Please select at least one student.',
                        type: 'error'
                    });
                    setOpenMessageDialog(true);
                    return;
                }

                values.activityRelationships = {
                    [`add-more-${values.activityId}-${values.subActivityId || 'none'}`]: {
                        superActivityId: values.superActivityId,
                        activityId: values.activityId,
                        subActivityId: values.subActivityId || null,
                    },
                };

                try {
                    const dupRes = await ActivityService.checkDuplicateActivities({
                        schooleId: values.schooleId,
                        classId: values.classId,
                        sectionId: values.sectionId || sectionId || null,
                        studentId: values.studentId,
                        isEventForAllStudent: false,
                        activityRelationships: values.activityRelationships,
                    });
                    const payload = dupRes?.data || dupRes;
                    if (payload?.hasDuplicates && Array.isArray(payload.duplicates) && payload.duplicates.length > 0) {
                        const names = Array.from(new Set(payload.duplicates.map((d) => d.studentName).filter(Boolean)));
                        const list = names.slice(0, 15).map((n) => `• ${n}`).join("\n");
                        const more = names.length > 15 ? `\n...and ${names.length - 15} more` : "";
                        setMessageDialogContent({
                            title: 'Duplicate Activity',
                            message: `This activity already exists for the following student(s):\n${list}${more}\n\nPlease select a different activity or edit the existing one.`,
                            type: 'error'
                        });
                        setOpenMessageDialog(true);
                        return;
                    }
                } catch (e) {
                    const preCheckMsg = e?.response?.data?.message;
                    if (preCheckMsg) {
                        setMessageDialogContent({
                            title: 'Error',
                            message: preCheckMsg,
                            type: 'error'
                        });
                        setOpenMessageDialog(true);
                        return;
                    }
                }

                submitActivityAfterConfirmation(values, resetForm);
            }
            else {
                // Validation checks
                if (!values.isEventForAllStudent && (!values.studentId || values.studentId.length === 0)) {
                    setMessageDialogContent({
                        title: 'Validation Error',
                        message: 'Please select at least one student.',
                        type: 'error'
                    });
                    setOpenMessageDialog(true);
                    return;
                }

                if (values.isEventForAllStudent) {
                    if (!values.classId) {
                        setMessageDialogContent({
                            title: 'Validation Error',
                            message: 'Please select a class first.',
                            type: 'error'
                        });
                        setOpenMessageDialog(true);
                        return;
                    }
                    const effectiveSectionId = values.sectionId || null;
                    if (studentList.length === 0) {
                        setMessageDialogContent({
                            title: 'No Students Found',
                            message: effectiveSectionId
                                ? 'No students found in the selected section. Please add students to this section or choose a different section.'
                                : 'No students found in the selected class. Please add students to this class or choose a different class.',
                            type: 'error'
                        });
                        setOpenMessageDialog(true);
                        return;
                    }
                }

                if (!selectedActivityMap || Object.keys(selectedActivityMap).length === 0) {
                    setMessageDialogContent({
                        title: 'Validation Error',
                        message: 'Please select at least one activity.',
                        type: 'error'
                    });
                    setOpenMessageDialog(true);
                    return;
                }

                // Pre-check duplicates BEFORE saving (single student / multiple / entire class)
                try {
                    const dupRes = await ActivityService.checkDuplicateActivities({
                        schooleId: values.schooleId,
                        classId: values.classId,
                        sectionId: values.sectionId || null,
                        studentId: values.studentId,
                        isEventForAllStudent: values.isEventForAllStudent || false,
                        activityRelationships: selectedActivityMap,
                    });
                    const payload = dupRes?.data || dupRes;
                    if (payload?.hasDuplicates && Array.isArray(payload.duplicates) && payload.duplicates.length > 0) {
                        const names = Array.from(new Set(payload.duplicates.map((d) => d.studentName).filter(Boolean)));
                        const list = names.slice(0, 15).map((n) => `• ${n}`).join("\n");
                        const more = names.length > 15 ? `\n...and ${names.length - 15} more` : "";
                        setMessageDialogContent({
                            title: 'Duplicate Activity',
                            message: `This activity already exists for the following student(s):\n${list}${more}\n\nPlease select a different activity or edit the existing one.`,
                            type: 'error'
                        });
                        setOpenMessageDialog(true);
                        return;
                    }
                } catch (e) {
                    const preCheckMsg = e?.response?.data?.message;
                    if (preCheckMsg) {
                        setMessageDialogContent({
                            title: 'Error',
                            message: preCheckMsg,
                            type: 'error'
                        });
                        setOpenMessageDialog(true);
                        return;
                    }
                    console.error("Duplicate pre-check failed:", e);
                }

                // Proceed with submission
                submitActivityAfterConfirmation(values, resetForm);
            }

        },
    });

    /** Sync unmastered list + existing-key cache after dialog student selection changes */
    const syncDialogStudentSideEffects = (selectedStudentIds, isEventForAllStudent = false) => {
        if (isEventForAllStudent) {
            const allActivities = [];
            Object.values(groupedUnmasteredActivities).forEach((activities) => {
                allActivities.push(...activities);
            });
            setFilteredUnmasteredActivities(allActivities);
        } else if (selectedStudentIds && selectedStudentIds.length > 0) {
            const filtered = [];
            selectedStudentIds.forEach((id) => {
                if (groupedUnmasteredActivities[id]) {
                    filtered.push(...groupedUnmasteredActivities[id]);
                }
            });
            setFilteredUnmasteredActivities(filtered);
        } else {
            setFilteredUnmasteredActivities([]);
        }

        try {
            const userDetails = JSON.parse(localStorage.getItem('userDetail') || '{}');
            const schooleId =
                userDetails.schooleId?._id ||
                userDetails.schooleId ||
                userDetails.schoolId?._id ||
                userDetails.schoolId;
            ActivityService.getExistingActivityKeys({
                schooleId,
                classId: formik.values.classId,
                sectionId: formik.values.sectionId || null,
                studentId: selectedStudentIds || [],
                isEventForAllStudent: Boolean(isEventForAllStudent),
            })
                .then((r) => {
                    const data = r?.data || r;
                    const keys = Array.isArray(data?.keys) ? data.keys : [];
                    setExistingKeySet(new Set(keys));
                    setExistingKeyStudents(data?.byKey || {});
                })
                .catch(() => {
                    setExistingKeySet(new Set());
                    setExistingKeyStudents({});
                });
        } catch (err) {
            setExistingKeySet(new Set());
            setExistingKeyStudents({});
        }
    };

    /**
     * Age chip: select ALL students in that age (multi-add).
     * User can then refine the multi-select to specific students in the same age.
     */
    const handleAgeChipSelect = (ageLabel) => {
        if (formik.values.isEdit) return;

        if (selectedAgeFilter === ageLabel) {
            // Toggle off age filter; keep current student selection
            setSelectedAgeFilter('');
            return;
        }

        const ageStudents = getStudentsInAgeGroup(ageLabel);
        const ageStudentIds = ageStudents.map((s) => s._id);
        setSelectedAgeFilter(ageLabel);
        formik.setFieldValue('isEventForAllStudent', false);
        formik.setFieldValue('studentId', ageStudentIds);
        syncDialogStudentSideEffects(ageStudentIds, false);
    };

    /** "N students" chip: clear age filter and select every student in class/section */
    const handleSelectAllStudentsChip = () => {
        if (formik.values.isEdit) return;
        const allIds = studentList.map((s) => s._id);
        setSelectedAgeFilter('');
        formik.setFieldValue('isEventForAllStudent', false);
        formik.setFieldValue('studentId', allIds);
        syncDialogStudentSideEffects(allIds, false);
    };

    const renderTree = (node) => {
        // Don't render if it doesn't match the search
        if (!filterTreeNode(node)) return null;
        const superActivitId = node._id;
        // Super Activity node
        if (node.superActivityName) {
            return (
                <TreeItem
                    key={node._id}
                    nodeId={node._id}
                    // label={node.superActivityName}
                    label={
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <LanguageIcon style={{ marginRight: 8, color: "#4caf50" }} />
                            {node.superActivityName}
                        </div>
                    }
                    onClick={(e) => e.stopPropagation()}
                >
                    {Array.isArray(node.activities) && node.activities.map(renderTree)}
                </TreeItem>
            );
        }
        // Activity node
        if (node.activityName) {
            const hasSubActivities = Array.isArray(node.subActivities) && node.subActivities.length > 0;
            const subActivityIds = hasSubActivities ? node.subActivities.map(sub => sub._id) : [];
            const existingKey = `${String(node._id)}|`;
            const isAlreadyAdded = existingKeySet.has(existingKey);
            if (showOnlyExisting && !isAlreadyAdded && !hasSubActivities) return null;
            const hasNotes = Boolean(node.notes && String(node.notes).trim() !== "");
            const imageCount = Array.isArray(node.imageURL) ? node.imageURL.filter(Boolean).length : 0;
            const videoCount = Array.isArray(node.videoURL) ? node.videoURL.filter(Boolean).length : 0;
            const hasMedia = imageCount > 0 || videoCount > 0;
            const showInfoIcon = hasNotes || hasMedia;

            return (
                <TreeItem
                    key={node._id}
                    nodeId={node._id}
                    label={
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                opacity: isAlreadyAdded ? 0.7 : 1,
                                background: isAlreadyAdded ? "rgba(220, 38, 38, 0.08)" : "transparent",
                                borderRadius: 8,
                                paddingRight: 6,
                            }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <Checkbox
                                size="small"
                                color="primary"
                                checked={checkedActivities.includes(node._id)}
                                onChange={(e) => {
                                    e.stopPropagation();
                                    const checked = e.target.checked;
                                    if (checked) {
                                        setCheckedActivities((prev) =>
                                            prev.includes(node._id) ? prev : [...prev, node._id]
                                        );
                                        if (hasSubActivities) {
                                            setCheckedSubActivities((prev) => {
                                                const next = [...prev];
                                                subActivityIds.forEach((id) => {
                                                    if (!next.some((p) => String(p) === String(id))) {
                                                        next.push(id);
                                                    }
                                                });
                                                return next;
                                            });
                                            setSelectedActivityMap((prev) => {
                                                const next = { ...prev };
                                                node.subActivities.forEach((sub) => {
                                                    next[sub._id] = {
                                                        subActivityId: sub._id,
                                                        activityId: node._id,
                                                        superActivityId: node.superActivityId,
                                                        isChild: true,
                                                    };
                                                });
                                                return next;
                                            });
                                        } else {
                                            setSelectedActivityMap((prev) => ({
                                                ...prev,
                                                [node._id]: {
                                                    activityId: node._id,
                                                    superActivityId: node.superActivityId,
                                                    isChild: false,
                                                },
                                            }));
                                        }
                                    } else {
                                        setCheckedActivities((prev) => prev.filter((id) => id !== node._id));
                                        if (hasSubActivities) {
                                            setCheckedSubActivities((prev) =>
                                                prev.filter(
                                                    (id) =>
                                                        !subActivityIds.some((sid) => String(sid) === String(id))
                                                )
                                            );
                                            setSelectedActivityMap((prev) => {
                                                const newMap = { ...prev };
                                                subActivityIds.forEach((id) => delete newMap[id]);
                                                return newMap;
                                            });
                                        } else {
                                            setSelectedActivityMap((prev) => {
                                                const newMap = { ...prev };
                                                delete newMap[node._id];
                                                return newMap;
                                            });
                                        }
                                    }
                                }}
                            />
                            <span onClick={(e) => e.stopPropagation()}>{node.activityName}</span>
                            {showInfoIcon && (
                                <Tooltip
                                    title={
                                        hasMedia
                                            ? `View ${imageCount} image${imageCount === 1 ? "" : "s"} and ${videoCount} video${videoCount === 1 ? "" : "s"}`
                                            : "View activity details & media"
                                    }
                                    placement="bottom"
                                >
                                    <IconButton
                                        size="small"
                                        aria-label="View activity media"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            history.push(`/app/activity-media/${node._id}`);
                                        }}
                                        style={{ marginLeft: 2, padding: 6 }}
                                    >
                                        <InfoOutlinedIcon style={{ fontSize: 18, color: "#0f3b62" }} />
                                    </IconButton>
                                </Tooltip>
                            )}
                            {isAlreadyAdded && (
                                <Button
                                    size="small"
                                    style={{ marginLeft: 8, fontSize: 12, color: "#dc2626", fontWeight: 700, textTransform: "none" }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        const students = existingKeyStudents?.[existingKey] || [];
                                        const unique = Array.from(new Set(students.filter(Boolean)));
                                        const shown = unique.slice(0, 30);
                                        const list = shown.map((n) => `• ${n}`).join("\n");
                                        const more = unique.length > shown.length ? `\n...and ${unique.length - shown.length} more` : "";
                                        setMessageDialogContent({
                                            title: "Already added",
                                            message: `Already added for ${unique.length} student(s):\n${list}${more}`,
                                            type: "info",
                                        });
                                        setOpenMessageDialog(true);
                                    }}
                                >
                                    (Already added: {(existingKeyStudents?.[existingKey] || []).length})
                                </Button>
                            )}
                        </div>
                    }
                >
                    {hasSubActivities && node.subActivities.map(sub =>
                        renderTree({ ...sub, parentActivityId: node._id, superActivityId: node.superActivityId, isChild: true })
                    )}
                </TreeItem>
            );
        }
        // SubActivity node
        if (node.subActivityName) {
            const existingKey = `${String(node.parentActivityId)}|${String(node._id)}`;
            const isAlreadyAdded = existingKeySet.has(existingKey);
            if (showOnlyExisting && !isAlreadyAdded) return null;
            const hasNotes = Boolean(node.notes && String(node.notes).trim() !== "");
            const imageCount = Array.isArray(node.imageURL) ? node.imageURL.filter(Boolean).length : 0;
            const videoCount = Array.isArray(node.videoURL) ? node.videoURL.filter(Boolean).length : 0;
            const hasMedia = imageCount > 0 || videoCount > 0;
            const showInfoIcon = hasNotes || hasMedia;
            return (
                <TreeItem
                    key={node._id}
                    nodeId={node._id}
                    label={
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                opacity: isAlreadyAdded ? 0.7 : 1,
                                background: isAlreadyAdded ? "rgba(220, 38, 38, 0.08)" : "transparent",
                                borderRadius: 8,
                                paddingRight: 6,
                            }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <Checkbox
                                size="small"
                                color="primary"
                                checked={checkedSubActivities.includes(node._id)}
                                onChange={(e) => {
                                    e.stopPropagation();
                                    const checked = e.target.checked;
                                    if (checked) {
                                        // Check sub-activity
                                        setCheckedSubActivities(prev => [...prev, node._id]);
                                        // Check parent activity if not already checked
                                        if (!checkedActivities.includes(node.parentActivityId)) {
                                            setCheckedActivities(prev => [...prev, node.parentActivityId]);
                                        }
                                        // Store the relationship
                                        setSelectedActivityMap(prev => ({
                                            ...prev,
                                            [node._id]: {
                                                subActivityId: node._id,
                                                activityId: node.parentActivityId,
                                                superActivityId: node.superActivityId,
                                                isChild: true
                                            }
                                        }));
                                    } else {
                                        // Just uncheck the sub-activity
                                        setCheckedSubActivities(prev => prev.filter(id => id !== node._id));
                                        // Remove the relationship
                                        setSelectedActivityMap(prev => {
                                            const newMap = { ...prev };
                                            delete newMap[node._id];
                                            return newMap;
                                        });
                                    }
                                }}
                            />
                            <span onClick={(e) => e.stopPropagation()}>{node.subActivityName}</span>
                            {showInfoIcon && (
                                <Tooltip
                                    title={
                                        hasMedia
                                            ? `View ${imageCount} image${imageCount === 1 ? "" : "s"} and ${videoCount} video${videoCount === 1 ? "" : "s"}`
                                            : "View exercise details & media"
                                    }
                                    placement="bottom"
                                >
                                    <IconButton
                                        size="small"
                                        aria-label="View exercise media"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            history.push(`/app/activity-media/${node._id}?type=exercise`);
                                        }}
                                        style={{ marginLeft: 2, padding: 6 }}
                                    >
                                        <InfoOutlinedIcon style={{ fontSize: 18, color: "#0f3b62" }} />
                                    </IconButton>
                                </Tooltip>
                            )}
                            {isAlreadyAdded && (
                                <Button
                                    size="small"
                                    style={{ marginLeft: 8, fontSize: 12, color: "#dc2626", fontWeight: 700, textTransform: "none" }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        const students = existingKeyStudents?.[existingKey] || [];
                                        const unique = Array.from(new Set(students.filter(Boolean)));
                                        const shown = unique.slice(0, 30);
                                        const list = shown.map((n) => `• ${n}`).join("\n");
                                        const more = unique.length > shown.length ? `\n...and ${unique.length - shown.length} more` : "";
                                        setMessageDialogContent({
                                            title: "Already added",
                                            message: `Already added for ${unique.length} student(s):\n${list}${more}`,
                                            type: "info",
                                        });
                                        setOpenMessageDialog(true);
                                    }}
                                >
                                    (Already added: {(existingKeyStudents?.[existingKey] || []).length})
                                </Button>
                            )}
                        </div>
                    }
                >
                </TreeItem>
            );
        }
        return null;
    };

    const groupByStudentId = (data) => {
        return data.reduce((acc, item) => {
            const studentId = item.studentId ? item.studentId._id : "";

            if (!acc[studentId]) {
                acc[studentId] = {
                    studentDetails: {
                        _id: studentId,
                        firstName: item.studentId.firstName,
                        lastName: item.studentId.lastName,
                    },
                    activities: [],
                };
            }
            acc[studentId].activities.push(item);
            return acc;
        }, {});
    };
    const getSuperActivityList = (event, obj) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const getsupActList = { classId: event.target.value };

        const schoolId =
            userDetails?.schooleId?._id ||
            userDetails?.schooleId ||
            userDetails?.schoolId?._id ||
            userDetails?.schoolId;
        SuperActivityService.getAllSuperActivityById(schoolId, getsupActList).then((res) => {
            const rows = Array.isArray(res) ? res : [];
            setAddSuperActivityList(rows.filter((row) => matchesSchoolCatalogScope(row, schoolId)));
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const loadDialogSectionList = (classId) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
        if (!classId) {
            setDialogSectionList([]);
            return;
        }
        SectionService.findSectionList({
            schooleId: userDetails.schooleId,
            classId,
        })
            .then((res) => {
                let list = Array.isArray(res) ? res : [];
                // if (userDetails.role === 'TEACHER' && userDetails.sectionId) {
                //     list = list.filter((s) => String(s._id) === String(userDetails.sectionId));
                // }
                setDialogSectionList(list);
            })
            .catch(() => setDialogSectionList([]));
    };

    const handleOpen = (isAdd) => {
        setOpen(true);
        if (isAdd) {
            const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
            // Section is optional when adding: teachers stay locked to their own
            // section, everyone else starts with no section (add for the whole
            // class) and can optionally pick one in the dialog. We intentionally
            // do NOT inherit the page-level section filter here.
            const initialSectionId = (userDetails.role === 'TEACHER' && userDetails.sectionId)
                ? userDetails.sectionId
                : '';
            setActivity({
                classId: classId || '',
                sectionId: initialSectionId,
                // date: new Date().toISOString().split("T")[0],
                // studentId: '',
                studentId: [],
                superActivityId: '',
                activityId: '',
                subActivityId: '',
                key: '',
                remarks: '',
                // planning: '',
                isEdit: false,
                endDate: '',
                sfd: '',
            });
            loadDialogSectionList(classId || '');
            if (classId) {
                // Load activity tree for the class so activities show when section/student are selected (without waiting for student)
                getAllSuperActivityTabelMultiple({ target: { value: classId } });
                getStudentList({ target: { value: classId } }, null, initialSectionId || '');
            } else {
                setStudentList([]);
            }
            // Clear activity selection state
            setCheckedActivities([]);
            setSelectedActivityMap({});
            setCheckedSubActivities([]);
            // Clear unmastered activities
            setGroupedUnmasteredActivities({});
            setFilteredUnmasteredActivities([]);
        }
    };
    const onclick = () => {
        setOpen(true);
    }
    const handleClose = () => {
        setOpen(false);
        // Clear activity selection state when closing the dialog
        setCheckedActivities([]);
        setSelectedActivityMap({});
        setCheckedSubActivities([]);
    };
    const handleChange = (event) => {
        setAge(event.target.value);
    };

    const getSectionListByClass = (classId, defaultSectionId, onLoaded) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
        if (!classId) {
            setSectionList([]);
            setSectionId('');
            return;
        }
        SectionService.findSectionList({
            schooleId: userDetails.schooleId,
            classId,
        })
            .then((res) => {
                let list = Array.isArray(res) ? res : [];
                // if (userDetails.role === 'TEACHER' && userDetails.sectionId) {
                //     list = list.filter((s) => String(s._id) === String(userDetails.sectionId));
                // }
                setSectionList(list);
                if (list.length === 0) {
                    // Selected class has no sections, so there is no section to filter by
                    setSectionId(null);
                } else if (defaultSectionId) {
                    setSectionId(defaultSectionId);
                }
                if (typeof onLoaded === 'function') {
                    onLoaded();
                }
            })
            .catch(() => {
                setSectionList([]);
                setSectionId(null);
                if (typeof onLoaded === 'function') {
                    onLoaded();
                }
            });
    };

    const getAddClassList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
        const schoolId = userDetails?.schooleId?._id || userDetails?.schooleId || userDetails?.schoolId?._id || userDetails?.schoolId;
        if (!schoolId) return;
        AddClassService.getAllAddClass(schoolId).then((res) => {
            const list = Array.isArray(res) ? res : [];
            // For TEACHER: only show their assigned class so class name and section show by default
            // const filteredList = userDetails.role === "TEACHER" && userDetails.classId
            //     ? list.filter((c) => String(c._id) === String(userDetails.classId))
            //     : list;
            setAddClassList(list);

            // By default show teacher's class name and section when they have classId (and optionally sectionId)
            if (userDetails.classId) {
                setClassId(userDetails.classId);
                const defaultSectionId = userDetails.sectionId ? String(userDetails.sectionId) : '';
                if (defaultSectionId) {
                    setSectionId(defaultSectionId);
                }
                const classIdForStudents = userDetails.classId;
                getSectionListByClass(userDetails.classId, defaultSectionId || undefined, () => {
                    // After section list (and default section) are set, load students so section filter applies on first load
                    getStudentList({ target: { value: classIdForStudents } }, null, defaultSectionId || undefined);
                });
            } else {
                setClassId("");
                setSectionId("");
                setSectionList([]);
            }
        }).catch((err) => {
            setAddClassList([]);
        });
    };
    const onSubmit = useCallback(
        (startDate, endDate) => refreshActivityTable(startDate, endDate),
        [refreshActivityTable]
    );

    const handlePrintFilteredData = async () => {
        if (!classId) {
            setMessageDialogContent({
                title: 'Validation Error',
                message: 'Please select a class before printing.',
                type: 'error',
            });
            setOpenMessageDialog(true);
            return;
        }

        setPrinting(true);
        try {
            const userDetails = JSON.parse(localStorage.getItem('userDetail') || '{}');
            const keys = {
                schooleId: userDetails.schooleId,
                isFuturePlanning: false,
                studentId,
                classId,
                sectionId: sectionId || undefined,
                status: true,
                page: 0,
                limit: Math.max(activityTotal || 0, rpg, 1),
            };
            if (startDate1 && endDate1) {
                keys.startDate1 = startDate1;
                keys.endDate1 = endDate1;
            }
            keys.showMaster = Boolean(showMaster);

            const res = await ActivityService.findActivityList(keys);
            const groups = Array.isArray(res) ? res : (Array.isArray(res?.data) ? res.data : []);
            const rows = buildPrintRowsFromGroups(groups, {
                matchesActivityFilters,
                studentKeyFilters,
                getStudentGroupKey,
            });

            if (rows.length === 0) {
                setMessageDialogContent({
                    title: 'No data',
                    message: 'No activities match the current filters to print.',
                    type: 'info',
                });
                setOpenMessageDialog(true);
                return;
            }

            const classLabel = addClassList.find((c) => String(c._id) === String(classId))?.className || '—';
            const sectionLabel = sectionId
                ? (sectionList.find((s) => String(s._id) === String(sectionId))?.sectionName || '—')
                : 'All Sections';
            const studentLabel = studentId
                ? (studentList.find((s) => String(s._id) === String(studentId))?.studentName || '—')
                : 'All Students';
            const dateLabel = startDate1 && endDate1 ? `${formatDate(startDate1)} to ${formatDate(endDate1)}` : 'All dates';
            const statusLabel = statusFilter === 'all'
                ? 'All Status'
                : statusFilter.charAt(0).toUpperCase() + statusFilter.slice(1);
            const keyLabel = keyFilter === 'all'
                ? 'All Keys'
                : (KEY_DISPLAY_LABELS[keyFilter] || keyFilter);
            const searchLabel = tableSearchDebounced.trim() || '—';

            const html = buildActivityPrintHtml({
                title: 'Activity Planner Report',
                subtitle: 'Filtered activity records',
                filterLines: [
                    `Class: ${classLabel}`,
                    `Section: ${sectionLabel}`,
                    `Student: ${studentLabel}`,
                    `Date range: ${dateLabel}`,
                    `Status: ${statusLabel}`,
                    `Key: ${keyLabel}`,
                    `Search: ${searchLabel}`,
                    `Records: ${rows.length}`,
                ],
                rows,
                generatedAt: new Date().toLocaleString(),
            });

            const printWindow = openPrintHtml(html);
            if (!printWindow) {
                setMessageDialogContent({
                    title: 'Popup blocked',
                    message: 'Please allow popups to print the report.',
                    type: 'error',
                });
                setOpenMessageDialog(true);
            }
        } catch (err) {
            setMessageDialogContent({
                title: 'Error',
                message: err?.response?.data?.message || 'Failed to prepare print view.',
                type: 'error',
            });
            setOpenMessageDialog(true);
        } finally {
            setPrinting(false);
        }
    };

    // Auto-load when filters change (debounced to avoid API storms)
    useEffect(() => {
        if (filterDebounceRef.current) clearTimeout(filterDebounceRef.current);
        filterDebounceRef.current = setTimeout(() => {
            // Filters changed -> always jump back to the first server page.
            setpg(0);
            refreshActivityTable(startDate1, endDate1, { page: 0 });
        }, 300);
        return () => {
            if (filterDebounceRef.current) clearTimeout(filterDebounceRef.current);
        };
    }, [classId, sectionId, studentId, startDate1, endDate1, showMaster, refreshActivityTable]);

    const getStudentReportList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const newstartDate1 = startDate1 ? startDate1 : "";
        const newendDate1 = endDate1 ? endDate1 : "";
        if (studentId === '') {
            setMessageDialogContent({
                title: 'Validation Error',
                message: 'Please Select Student',
                type: 'error'
            });
            setOpenMessageDialog(true);
            return;
        }
        const getstudentId = { "studentId": studentId, "startDate1": newstartDate1, "endDate1": newendDate1 };

        SubActivityService.getStudentReport(getstudentId).then((res) => {
            // const blob = new Blob(res.pdfBuffer);
            const buffer = Buffer.from(res.pdfBuffer);
            const blob = new Blob([buffer]);
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = url;
            a.download = "studentreport.pdf";
            a.click();
            window.URL.revokeObjectURL(url);
            // const blob = new Blob([res.pdfBuffer]);
            // saveAs(blob, 'filename.pdf');
            // const file = new File(res.pdfBuffer, 'filename.txt', { type: 'text/plain' });
            // setStudentReportList(res);
        }).catch((err) => {
            setMessageDialogContent({
                title: 'Error',
                message: err.response?.data?.message || 'An error occurred',
                type: 'error'
            });
            setOpenMessageDialog(true);
        });
    };
    
    const getSubActivityList = (event, obj) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const activityId = event?.target?.value;
        if (!activityId) {
            setSubActivityList([]);
            if (obj) {
                setActivity(obj);
            }
            return;
        }
        const getsubActList = {
            schooleId: userDetails.schooleId,
            classId: obj?.classId || formik.values.classId,
            activityId,
        };
        const schoolId =
            userDetails?.schooleId?._id ||
            userDetails?.schooleId ||
            userDetails?.schoolId?._id ||
            userDetails?.schoolId;
        SubActivityService.getAllSubActivityByActivityId(getsubActList).then((res) => {
            let list = (Array.isArray(res) ? res : []).filter((row) =>
                matchesSchoolCatalogScope(row, schoolId)
            );
            const applyList = (finalList) => {
                setSubActivityList(finalList);
                if (obj) {
                    setActivity(obj);
                }
            };
            if (list.length === 0 && obj?.subActivityId && getsubActList.classId) {
                SubActivityService.getAllSubActivityByActivityId({
                    schooleId: getsubActList.schooleId,
                    activityId: getsubActList.activityId,
                })
                    .then((fallback) =>
                        applyList(
                            (Array.isArray(fallback) ? fallback : []).filter((row) =>
                                matchesSchoolCatalogScope(row, schoolId)
                            )
                        )
                    )
                    .catch(() => applyList([]));
                return;
            }
            applyList(list);
        }).catch(() => {
            setSubActivityList([]);
            if (obj) {
                setActivity(obj);
            }
        });
    }
    
    const getActivityList = (event, obj) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const superActivityId = event?.target?.value;
        if (!superActivityId) {
            setAddActivityList([]);
            if (obj) {
                setActivity(obj);
            }
            return;
        }
        const getsubActList = {
            schooleId: userDetails.schooleId,
            classId: obj?.classId || formik.values.classId,
            superActivityId,
        };

        const schoolId =
            userDetails?.schooleId?._id ||
            userDetails?.schooleId ||
            userDetails?.schoolId?._id ||
            userDetails?.schoolId;
        ActivityTabelService.getAllActivityTabeBySuperActivityId(getsubActList).then((res) => {
            setAddActivityList(
                (Array.isArray(res) ? res : []).filter((row) =>
                    matchesSchoolCatalogScope(row, schoolId)
                )
            );
            if (obj) {
                setActivity(obj);
            }
        }).catch(() => {
            setAddActivityList([]);
            if (obj) {
                setActivity(obj);
            }
        });
    }
    const getStudentList = (event, obj, sectionIdOverride) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
        const selectedClassId = event.target.value;
        
        // Clear student list if no class is selected
        if (!selectedClassId || selectedClassId === '') {
            setStudentList([]);
            setSelectedAgeFilter('');
            return;
        }
        
        const getStuList = {
            classId: selectedClassId,
        };
        // If a section is selected (from state or override), filter students by section as well
        const effectiveSectionId = sectionIdOverride !== undefined ? sectionIdOverride : sectionId;
        if (effectiveSectionId) {
            getStuList.sectionId = effectiveSectionId;
        }

        StudentService.getAllStudentById(userDetails.schooleId, getStuList).then((res) => {
            let studentDetails = res.map(res => {
                return {
                    _id: res._id,
                    studentName: `${res.firstName} ${res.lastName}`,
                    status: true,
                    dob: res.dob,
                    ageLabel: formatStudentAge(res.dob),
                    ageGroupLabel: getAgeGroupLabel(res.dob),
                };
            });

            setStudentList(studentDetails);
            setSelectedAgeFilter('');
            // Refresh "already added" highlights whenever class/section changes
            try {
                const schooleId = userDetails.schooleId?._id || userDetails.schooleId || userDetails.schoolId?._id || userDetails.schoolId;
                ActivityService.getExistingActivityKeys({
                    schooleId,
                    classId: selectedClassId,
                    sectionId: effectiveSectionId || null,
                    studentId: (formik?.values?.studentId || []),
                    isEventForAllStudent: Boolean(formik?.values?.isEventForAllStudent),
                }).then((r) => {
                    const data = r?.data || r;
                    const keys = Array.isArray(data?.keys) ? data.keys : [];
                    setExistingKeySet(new Set(keys));
                    setExistingKeyStudents(data?.byKey || {});
                }).catch(() => setExistingKeySet(new Set()));
            } catch (e) {
                setExistingKeySet(new Set());
                setExistingKeyStudents({});
            }

            if (obj) {
                setActivity(obj);
            }
        }).catch((err) => {
            // setError(err.message);
            setStudentList([]);
            setExistingKeySet(new Set());
            setExistingKeyStudents({});
        });
    }


    const getStudentActivityList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        ActivityTabelService.getStudentActivity(userDetails.schooleId, false).then((res) => {
            setActivityList(res);
        }).catch((err) => {
            // setError(err.message);
        });
    }


    const editActivity = (useractivitys, isAddMore, group) => {
        if (!isActivityRecord(useractivitys)) return;

        const obj = JSON.parse(JSON.stringify(useractivitys));
        obj.classId = normalizeRefId(useractivitys.classId || group?.classId);
        obj.sectionId = normalizeRefId(useractivitys.sectionId || group?.sectionId);
        obj.studentId = normalizeStudentIds(useractivitys.studentId, group?.studentId);
        obj.superActivityId = normalizeRefId(useractivitys.superActivityId);
        obj.activityId = normalizeRefId(useractivitys.activityId);
        obj.subActivityId = normalizeRefId(useractivitys.subActivityId);
        obj.isEdit = true;

        if (isAddMore) {
            delete obj._id;
        }

        setActivity(obj);
        setOpen(true);

        if (obj.classId) {
            loadDialogSectionList(obj.classId);
            getSuperActivityList({ target: { value: obj.classId } }, obj);
            getStudentList({ target: { value: obj.classId } }, obj, obj.sectionId || undefined);
        }
        if (obj.superActivityId) {
            getActivityList({ target: { value: obj.superActivityId } }, obj);
        }
        if (obj.activityId) {
            getSubActivityList({ target: { value: obj.activityId } }, obj);
        }
    }

    const deleteActivities = async (activityIds) => {
        const ids = (activityIds || []).map(String).filter(Boolean);
        if (!ids.length || deletingActivities) return;

        setDeletingActivities(true);
        try {
            await ActivityService.deleteActivitiesBulk(ids);
            await refreshActivityTable();
            await refreshExistingActivityKeys();
            setOpenDeleteDialog(false);
            setPendingDeleteIds([]);
            setSelectedTableActivityIds((prev) => prev.filter((id) => !ids.includes(id)));
            setMessageDialogContent({
                title: 'Success',
                message: ids.length === 1
                    ? 'Activity deleted successfully.'
                    : `${ids.length} activities deleted successfully.`,
                type: 'success',
            });
            setOpenMessageDialog(true);
        } catch (err) {
            setOpenDeleteDialog(false);
            setPendingDeleteIds([]);
            setMessageDialogContent({
                title: 'Error',
                message: err.response?.data?.message || 'Failed to delete activity.',
                type: 'error',
            });
            setOpenMessageDialog(true);
        } finally {
            setDeletingActivities(false);
        }
    };

    const handleDeleteClick = (activityId) => {
        if (deletingActivities) return;
        setPendingDeleteIds([String(activityId)]);
        setOpenDeleteDialog(true);
    };

    const handleBulkDeleteClick = () => {
        if (!selectedTableActivityIds.length || deletingActivities) return;
        setPendingDeleteIds([...selectedTableActivityIds]);
        setOpenDeleteDialog(true);
    };

    const handleDeleteConfirm = () => {
        if (pendingDeleteIds.length > 0 && !deletingActivities) {
            deleteActivities(pendingDeleteIds);
        }
    };

    const handleDeleteCancel = () => {
        if (deletingActivities) return;
        setOpenDeleteDialog(false);
        setPendingDeleteIds([]);
    };
    const patchActivitiesPublicStatus = (activityIds, publicStatus) => {
        const idSet = new Set((activityIds || []).map((id) => String(id)));
        if (!idSet.size) return;
        setActivityList((prev) => prev.map((group) => ({
            ...group,
            activityRecordsId: (group.activityRecordsId || []).map((record) =>
                isActivityRecord(record) && idSet.has(String(record._id))
                    ? { ...record, publicStatus }
                    : record
            ),
        })));
    };

    const findSelectedActivityRecords = (ids) => {
        const idSet = new Set((ids || []).map((id) => String(id)));
        const found = [];
        (activityList || []).forEach((group) => {
            (group.activityRecordsId || []).forEach((record) => {
                if (isActivityRecord(record) && idSet.has(String(record._id))) {
                    found.push(record);
                }
            });
        });
        return found;
    };

    const handlePublicStatusChange = (activity, publicStatus) => {
        const isPublishing = publicStatus === 'publish';

        if (isPublishing && getActivityKeyIndex(activity?.key) === -1) {
            setMessageDialogContent({
                title: 'Key Required',
                message: 'Please select a key (P, WA, WI or M) before publishing this activity.',
                type: 'error',
            });
            setOpenMessageDialog(true);
            return;
        }

        setStatusConfirmDialog({
            open: true,
            activity,
            activityIds: activity?._id ? [String(activity._id)] : [],
            publicStatus,
            busy: false,
        });
    };

    const handleBulkPublicStatusClick = (publicStatus) => {
        const ids = [...selectedTableActivityIds];
        if (!ids.length) return;

        if (publicStatus === 'publish') {
            const records = findSelectedActivityRecords(ids);
            const missingKey = records.filter((rec) => getActivityKeyIndex(rec?.key) === -1);
            if (missingKey.length > 0) {
                setMessageDialogContent({
                    title: 'Key Required',
                    message: `${missingKey.length} selected activit${missingKey.length === 1 ? 'y has' : 'ies have'} no key (P, WA, WI or M). Set a key before publishing.`,
                    type: 'error',
                });
                setOpenMessageDialog(true);
                return;
            }
        }

        setStatusConfirmDialog({
            open: true,
            activity: null,
            activityIds: ids,
            publicStatus,
            busy: false,
        });
    };

    const closeStatusConfirmDialog = () => {
        if (statusConfirmDialog.busy) return;
        setStatusConfirmDialog({
            open: false,
            activity: null,
            activityIds: [],
            publicStatus: '',
            busy: false,
        });
    };

    const confirmPublicStatusChange = () => {
        const { activity, activityIds, publicStatus } = statusConfirmDialog;
        const ids = Array.isArray(activityIds) && activityIds.length
            ? activityIds.map(String)
            : activity?._id
                ? [String(activity._id)]
                : [];
        if (!ids.length || !publicStatus) {
            closeStatusConfirmDialog();
            return;
        }

        const isPublishing = publicStatus === 'publish';

        setStatusConfirmDialog((prev) => ({ ...prev, busy: true }));

        ActivityService.updatePublicStatusBulk(ids, publicStatus)
            .then((res) => {
                const payload = res?.data || res || {};
                const skipped = Array.isArray(payload.skipped) ? payload.skipped : [];
                const updatedIds = ids.filter(
                    (id) => !skipped.some((s) => String(s.id) === String(id)),
                );
                patchActivitiesPublicStatus(updatedIds, publicStatus);
                setSelectedTableActivityIds((prev) =>
                    prev.filter((id) => !updatedIds.includes(String(id))),
                );
                setStatusConfirmDialog({
                    open: false,
                    activity: null,
                    activityIds: [],
                    publicStatus: '',
                    busy: false,
                });

                let message = isPublishing
                    ? (updatedIds.length === 1
                        ? 'Reports published successfully'
                        : `${updatedIds.length} activities published successfully`)
                    : (updatedIds.length === 1
                        ? 'Activity moved back to draft'
                        : `${updatedIds.length} activities moved back to draft`);
                if (skipped.length) {
                    message += `. ${skipped.length} skipped (missing key).`;
                }
                setMessageDialogContent({
                    title: 'Success',
                    message,
                    type: skipped.length ? 'warning' : 'success',
                });
                setOpenMessageDialog(true);
            })
            .catch((err) => {
                setStatusConfirmDialog((prev) => ({ ...prev, busy: false }));
                setMessageDialogContent({
                    title: 'Error',
                    message: err.response?.data?.message || 'Failed to update public status.',
                    type: 'error',
                });
                setOpenMessageDialog(true);
            });
    };

    const patchActivityMedia = (activityId, { imageURL, videoURL }) => {
        setActivityList((prev) => prev.map((group) => ({
            ...group,
            activityRecordsId: (group.activityRecordsId || []).map((record) =>
                isActivityRecord(record) && String(record._id) === String(activityId)
                    ? {
                        ...record,
                        ...(imageURL !== undefined ? { imageURL } : {}),
                        ...(videoURL !== undefined ? { videoURL } : {}),
                    }
                    : record
            ),
        })));
    };

    const patchActivityRemarks = (activityId, remarks) => {
        setActivityList((prev) => prev.map((group) => ({
            ...group,
            activityRecordsId: (group.activityRecordsId || []).map((record) =>
                isActivityRecord(record) && String(record._id) === String(activityId)
                    ? { ...record, remarks }
                    : record
            ),
        })));
    };

    const getRemarksValue = (activity) => (activity?.remarks || '').trim();

    const hasSavedRemarks = (activity) => getRemarksValue(activity).length > 0;

    const openObservationDialog = (activity) => {
        setObservationDialog({
            open: true,
            activity,
            text: activity?.remarks || '',
            saving: false,
        });
    };

    const closeObservationDialog = () => {
        setObservationDialog({
            open: false,
            activity: null,
            text: '',
            saving: false,
        });
    };

    const handleObservationDialogChange = (text) => {
        setObservationDialog((prev) => ({ ...prev, text }));
    };

    const saveObservationDialog = async () => {
        const { activity, text } = observationDialog;
        if (!activity?._id) return;

        const activityId = activity._id;
        const newRemarks = (text || '').trim();
        const oldRemarks = (activity.remarks || '').trim();
        if (newRemarks === oldRemarks) {
            closeObservationDialog();
            return;
        }

        setObservationDialog((prev) => ({ ...prev, saving: true }));
        try {
            await ActivityService.patchActivityRecord({
                _id: activityId,
                remarks: newRemarks,
            });
            patchActivityRemarks(activityId, newRemarks);
            setObservationExpanded((prev) => ({ ...prev, [activityId]: false }));
            closeObservationDialog();
            setMessageDialogContent({
                title: 'Success',
                message: newRemarks ? 'Observation saved successfully.' : 'Observation removed.',
                type: 'success',
            });
            setOpenMessageDialog(true);
        } catch (err) {
            setObservationDialog((prev) => ({ ...prev, saving: false }));
            setMessageDialogContent({
                title: 'Error',
                message: err.response?.data?.message || 'Failed to save observation.',
                type: 'error',
            });
            setOpenMessageDialog(true);
        }
    };

    const renderObservationCell = (activity, group) => {
        const isExpanded = observationExpanded[activity._id] === true;
        const saved = hasSavedRemarks(activity);
        const canEdit = canMutateActivity(activity);

        if (!saved) {
            if (!canEdit) {
                return (
                    <Typography style={{ color: '#8a8a8a', fontSize: '0.8rem' }}>
                        —
                    </Typography>
                );
            }
            return (
                <Button
                    size="small"
                    startIcon={<AddIcon style={{ fontSize: 16 }} />}
                    onClick={() => openObservationDialog(activity)}
                    style={{
                        textTransform: 'none',
                        color: '#0f3b62',
                        whiteSpace: 'nowrap',
                    }}
                >
                    Add Observation
                </Button>
            );
        }

        return (
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                style={{ gap: 6, minWidth: 120 }}
            >
                <Tooltip title={isExpanded ? 'Hide observation' : 'View observation'}>
                    <IconButton
                        className={classes.observationIconAction}
                        size="small"
                        onClick={() => setObservationExpanded((prev) => ({
                            ...prev,
                            [activity._id]: !prev[activity._id],
                        }))}
                    >
                        {isExpanded
                            ? <VisibilityOffIcon fontSize="small" />
                            : <VisibilityIcon fontSize="small" />}
                    </IconButton>
                </Tooltip>
                {canEdit && (
                    <Button
                        size="small"
                        startIcon={<EditIcon style={{ fontSize: 14 }} />}
                        onClick={() => openObservationDialog(activity)}
                        style={{
                            textTransform: 'none',
                            color: '#0f3b62',
                            fontSize: '0.72rem',
                            padding: '2px 6px',
                            minWidth: 0,
                        }}
                    >
                        Edit Observation
                    </Button>
                )}
            </Box>
        );
    };

    const formatObservationHeaderDate = (dateString) => {
        const formatted = formatDate(dateString);
        return formatted ? formatted.replace(/\//g, '-') : '—';
    };

    const renderObservationExpandRow = (activity) => {
        const value = getRemarksValue(activity);
        const activityLabel = activity.activityId?.activityName
            || activity.subActivityId?.subActivityName
            || 'Activity';

        return (
            <TableRow key={`${activity._id}-observation`} className={classes.noteExpandRow}>
                <TableCell colSpan={visibleColumnCount}>
                    <Box className={classes.noteExpandBox}>
                        <NoteIcon style={{ color: '#1a1a1a', marginTop: 2, flexShrink: 0 }} />
                        <Box flex={1}>
                            <Typography
                                style={{
                                    fontSize: '0.72rem',
                                    fontWeight: 700,
                                    color: '#8a8a8a',
                                    textTransform: 'uppercase',
                                    marginBottom: 4,
                                }}
                            >
                                Observation · {activityLabel} · {formatObservationHeaderDate(activity.date)}
                            </Typography>
                            <Typography
                                style={{
                                    color: '#1a1a1a',
                                    fontSize: '0.9rem',
                                    lineHeight: 1.65,
                                    whiteSpace: 'pre-wrap',
                                }}
                            >
                                {value || 'No observation text recorded.'}
                            </Typography>
                        </Box>
                    </Box>
                </TableCell>
            </TableRow>
        );
    };

    const closeImagesStoreDialog = () => {
        setImagesStoreDialog({
            open: false,
            activity: null,
            loading: false,
            saving: false,
            error: '',
            imagesStoreRows: [],
            selectedStoreId: IMAGES_STORE_ALL_KEY,
            selectedUrls: [],
        });
    };

    const openImagesStoreDialog = async (activity) => {
        if (!activity?._id) return;

        const existingImages = getActivityImageUrls(activity);
        const existingVideos = getActivityVideoUrls(activity);
        if (
            existingImages.length >= MAX_ACTIVITY_IMAGES
            && existingVideos.length >= MAX_ACTIVITY_VIDEOS
        ) {
            setMessageDialogContent({
                title: 'Limit reached',
                message: `Maximum ${MAX_ACTIVITY_IMAGES} images and ${MAX_ACTIVITY_VIDEOS} videos allowed per activity.`,
                type: 'error',
            });
            setOpenMessageDialog(true);
            return;
        }

        const userDetails = JSON.parse(localStorage.getItem('userDetail') || '{}');
        const resolvedClassId = normalizeRefId(activity?.classId) || classId;
        if (!resolvedClassId || !userDetails.schooleId) {
            setMessageDialogContent({
                title: 'Error',
                message: 'Class is required to load Images Store.',
                type: 'error',
            });
            setOpenMessageDialog(true);
            return;
        }

        setImagesStoreDialog({
            open: true,
            activity,
            loading: true,
            saving: false,
            error: '',
            imagesStoreRows: [],
            selectedStoreId: IMAGES_STORE_ALL_KEY,
            selectedUrls: [],
        });

        try {
            const body = { schooleId: userDetails.schooleId, classId: resolvedClassId };
            const resolvedSectionId = normalizeRefId(activity?.sectionId) || sectionId;
            if (resolvedSectionId) body.sectionId = resolvedSectionId;

            const storeRes = await ImagesStoreService.findImagesStoreList(body);
            setImagesStoreDialog((prev) => ({
                ...prev,
                loading: false,
                imagesStoreRows: Array.isArray(storeRes) ? storeRes : [],
            }));
        } catch (err) {
            setImagesStoreDialog((prev) => ({
                ...prev,
                loading: false,
                error: err?.response?.data?.message || 'Failed to load Images Store.',
            }));
        }
    };

    const toggleImagesStoreSelection = (url, mediaType) => {
        setImagesStoreDialog((prev) => {
            const activity = prev.activity;
            if (!activity) return prev;

            const resolvedType = mediaType || getMediaTypeFromUrl(url);
            const isVideo = resolvedType === 'video';
            const existing = isVideo
                ? getActivityVideoUrls(activity)
                : getActivityImageUrls(activity);
            const max = isVideo ? MAX_ACTIVITY_VIDEOS : MAX_ACTIVITY_IMAGES;
            const remaining = max - existing.length;
            const selectedOfType = prev.selectedUrls.filter(
                (u) => getMediaTypeFromUrl(u) === resolvedType,
            );

            if (prev.selectedUrls.includes(url)) {
                return { ...prev, selectedUrls: prev.selectedUrls.filter((u) => u !== url) };
            }

            if (existing.includes(url) || selectedOfType.length >= remaining) {
                return prev;
            }

            return { ...prev, selectedUrls: [...prev.selectedUrls, url] };
        });
    };

    const saveImagesFromStore = async () => {
        const { activity, selectedUrls } = imagesStoreDialog;
        if (!activity?._id || selectedUrls.length === 0) return;

        const existingImages = getActivityImageUrls(activity);
        const existingVideos = getActivityVideoUrls(activity);
        const newImageUrls = selectedUrls
            .filter((url) => getMediaTypeFromUrl(url) === 'image' && !existingImages.includes(url))
            .slice(0, MAX_ACTIVITY_IMAGES - existingImages.length);
        const newVideoUrls = selectedUrls
            .filter((url) => getMediaTypeFromUrl(url) === 'video' && !existingVideos.includes(url))
            .slice(0, MAX_ACTIVITY_VIDEOS - existingVideos.length);

        if (newImageUrls.length === 0 && newVideoUrls.length === 0) {
            closeImagesStoreDialog();
            return;
        }

        setImagesStoreDialog((prev) => ({ ...prev, saving: true }));
        try {
            const updatedImages = [...existingImages, ...newImageUrls];
            const updatedVideos = [...existingVideos, ...newVideoUrls];
            await ActivityService.patchActivityRecord({
                _id: activity._id,
                imageURL: updatedImages,
                videoURL: updatedVideos,
            });
            patchActivityMedia(activity._id, {
                imageURL: updatedImages,
                videoURL: updatedVideos,
            });
            setImagesExpanded((prev) => ({ ...prev, [activity._id]: false }));
            closeImagesStoreDialog();
            const addedCount = newImageUrls.length + newVideoUrls.length;
            setMessageDialogContent({
                title: 'Success',
                message: addedCount > 1
                    ? `${addedCount} items added from Images Store.`
                    : 'Media added from Images Store.',
                type: 'success',
            });
            setOpenMessageDialog(true);
        } catch (err) {
            setImagesStoreDialog((prev) => ({ ...prev, saving: false }));
            setMessageDialogContent({
                title: 'Error',
                message: err?.response?.data?.message || 'Failed to add media from Images Store.',
                type: 'error',
            });
            setOpenMessageDialog(true);
        }
    };

    const handleDeleteActivityImage = async (activity, urlToRemove) => {
        if (!activity?._id || !urlToRemove) return;
        if (!await showAppConfirm('Delete this uploaded image?')) return;

        const existing = getActivityImageUrls(activity);
        const updatedFiles = existing.filter((url) => url !== urlToRemove);
        if (updatedFiles.length === existing.length) return;

        const mediaKey = `${activity._id}-img-${urlToRemove}`;
        setDeletingMediaKey(mediaKey);
        try {
            await ActivityService.patchActivityRecord({
                _id: activity._id,
                imageURL: updatedFiles,
            });
            patchActivityMedia(activity._id, { imageURL: updatedFiles });
            if (updatedFiles.length === 0 && getActivityVideoUrls(activity).length === 0) {
                setImagesExpanded((prev) => {
                    const next = { ...prev };
                    delete next[activity._id];
                    return next;
                });
            }
            setMessageDialogContent({
                title: 'Success',
                message: 'Image deleted successfully.',
                type: 'success',
            });
            setOpenMessageDialog(true);
        } catch (err) {
            setMessageDialogContent({
                title: 'Error',
                message: err.response?.data?.message || 'Failed to delete image.',
                type: 'error',
            });
            setOpenMessageDialog(true);
        } finally {
            setDeletingMediaKey(null);
        }
    };

    const handleActivityImageUpload = async (e, activity) => {
        const files = e.target.files ? Array.from(e.target.files) : [];
        if (files.length === 0 || !activity?._id) return;

        if (files.length > MAX_ACTIVITY_IMAGES) {
            setMessageDialogContent({
                title: 'Limit exceeded',
                message: `You can upload at most ${MAX_ACTIVITY_IMAGES} images at a time.`,
                type: 'error',
            });
            setOpenMessageDialog(true);
            if (e?.target) e.target.value = '';
            return;
        }

        const existing = getActivityImageUrls(activity);
        const remaining = MAX_ACTIVITY_IMAGES - existing.length;
        if (remaining <= 0) {
            setMessageDialogContent({
                title: 'Limit reached',
                message: `Maximum ${MAX_ACTIVITY_IMAGES} images allowed per activity.`,
                type: 'error',
            });
            setOpenMessageDialog(true);
            if (e?.target) e.target.value = '';
            return;
        }

        const filesToUpload = files.slice(0, remaining);
        if (filesToUpload.length < files.length) {
            setMessageDialogContent({
                title: 'Limit reached',
                message: `Only ${filesToUpload.length} image(s) will be added. Maximum ${MAX_ACTIVITY_IMAGES} images allowed per activity.`,
                type: 'info',
            });
            setOpenMessageDialog(true);
        }

        setUploadingImageId(activity._id);
        try {
            const uploadResults = await Promise.all(
                filesToUpload.map((file) => {
                    const formData = new FormData();
                    formData.append('image', file);
                    formData.append('imageName', file.name);
                    return StudentService.uploadImage(formData);
                })
            );

            const urls = uploadResults.map((res) => res?.url).filter(Boolean);
            if (urls.length === 0) {
                setMessageDialogContent({
                    title: 'Error',
                    message: 'Failed to upload images.',
                    type: 'error',
                });
                setOpenMessageDialog(true);
                return;
            }

            const updatedFiles = [...existing, ...urls];

            await ActivityService.patchActivityRecord({
                _id: activity._id,
                imageURL: updatedFiles,
            });

            patchActivityMedia(activity._id, { imageURL: updatedFiles });
            setImagesExpanded((prev) => ({ ...prev, [activity._id]: false }));
            setMessageDialogContent({
                title: 'Success',
                message: urls.length > 1
                    ? `${urls.length} images uploaded successfully.`
                    : 'Image uploaded successfully.',
                type: 'success',
            });
            setOpenMessageDialog(true);
        } catch (err) {
            setMessageDialogContent({
                title: 'Error',
                message: err.response?.data?.message || 'Failed to upload images.',
                type: 'error',
            });
            setOpenMessageDialog(true);
        } finally {
            setUploadingImageId(null);
            if (e?.target) e.target.value = '';
        }
    };

    const openImageAddMenu = (event, activity, uploadInputId) => {
        setImageAddMenu({
            anchorEl: event.currentTarget,
            activity,
            uploadInputId,
        });
    };

    const closeImageAddMenu = () => {
        setImageAddMenu({
            anchorEl: null,
            activity: null,
            uploadInputId: '',
        });
    };

    const handleImageAddMenuUpload = () => {
        const { uploadInputId } = imageAddMenu;
        const input = document.getElementById(uploadInputId);
        if (input) input.click();
        closeImageAddMenu();
    };

    const handleImageAddMenuStore = () => {
        const { activity } = imageAddMenu;
        closeImageAddMenu();
        if (activity) openImagesStoreDialog(activity);
    };

    const renderActivityImageAddActions = (activity, images, isUploading, uploadInputId, group) => {
        if (!canMutateActivity(activity)) {
            return null;
        }
        const videos = getActivityVideoUrls(activity);
        const canAddMore = images.length < MAX_ACTIVITY_IMAGES || videos.length < MAX_ACTIVITY_VIDEOS;
        const canUploadImages = images.length < MAX_ACTIVITY_IMAGES;
        const addDisabled = isUploading || !canAddMore;
        const uploadDisabled = isUploading || !canUploadImages;
        const hasImages = images.length > 0 || videos.length > 0;
        const buttonLabel = isUploading
            ? 'Uploading...'
            : (hasImages ? 'Edit Media' : 'Add Media');

        return (
            <Box display="flex" flexDirection="column" style={{ gap: 4 }}>
                <input
                    id={uploadInputId}
                    type="file"
                    accept="image/*"
                    multiple
                    style={{ display: 'none' }}
                    disabled={uploadDisabled}
                    onChange={(ev) => handleActivityImageUpload(ev, activity)}
                />
                <Button
                    size="small"
                    startIcon={
                        isUploading
                            ? <CircularProgress size={14} style={{ color: '#9e9e9e' }} />
                            : hasImages
                                ? <EditIcon style={{ fontSize: 18 }} />
                                : <CloudUploadIcon style={{ fontSize: 18 }} />
                    }
                    endIcon={!isUploading ? <ArrowDropDownIcon /> : null}
                    disabled={addDisabled}
                    onClick={(e) => openImageAddMenu(e, activity, uploadInputId)}
                    style={{
                        color: addDisabled ? '#9e9e9e' : '#0f3b62',
                        textTransform: 'none',
                    }}
                >
                    {buttonLabel}
                </Button>
            </Box>
        );
    };

    const renderActivityImagesCell = (activity, group) => {
        const images = getActivityImageUrls(activity);
        const videos = getActivityVideoUrls(activity);
        const mediaCount = images.length + videos.length;
        const isUploading = uploadingImageId === activity._id;
        const hasUploadedMedia = mediaCount > 0;
        const isExpanded = imagesExpanded[activity._id] === true;
        const uploadInputId = `activity-image-upload-${activity._id}`;
        const mediaCountLabel = `${images.length}/${MAX_ACTIVITY_IMAGES} img · ${videos.length}/${MAX_ACTIVITY_VIDEOS} vid`;
        const canEditMedia = canMutateActivity(activity);

        if (!hasUploadedMedia) {
            if (!canEditMedia) {
                return (
                    <Typography style={{ color: '#8a8a8a', fontSize: '0.8rem' }}>
                        —
                    </Typography>
                );
            }
            return (
                <Box display="flex" flexDirection="column" style={{ gap: 6, minWidth: 140 }}>
                    {renderActivityImageAddActions(activity, images, isUploading, uploadInputId, group)}
                </Box>
            );
        }

        return (
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                style={{ gap: 6, minWidth: 140 }}
            >
                {isExpanded && (
                    <Box
                        display="flex"
                        flexDirection="row"
                        flexWrap="nowrap"
                        alignItems="flex-start"
                        style={{ gap: 8, overflowX: 'auto', maxWidth: 320, paddingBottom: 2 }}
                    >
                        {images.map((url, idx) => {
                            const imageDeleteKey = `${activity._id}-img-${url}`;
                            const isDeletingImage = deletingMediaKey === imageDeleteKey;
                            return (
                            <Box
                                key={`${activity._id}-img-${idx}`}
                                display="flex"
                                flexDirection="column"
                                alignItems="center"
                                style={{ gap: 2, flex: '0 0 auto' }}
                            >
                                <Box style={{ position: 'relative', width: 40, height: 40 }}>
                                    <img
                                        src={url}
                                        alt={`Activity ${idx + 1}`}
                                        loading="lazy"
                                        decoding="async"
                                        style={{
                                            width: 40,
                                            height: 40,
                                            objectFit: 'cover',
                                            borderRadius: 4,
                                            border: '1px solid #e0e0e0',
                                            cursor: 'pointer',
                                            opacity: isDeletingImage ? 0.5 : 1,
                                        }}
                                        onClick={() => window.open(url, '_blank', 'noopener,noreferrer')}
                                    />
                                    {canEditMedia && (
                                    <Tooltip title="Delete image">
                                        <span>
                                            <IconButton
                                                size="small"
                                                disabled={isDeletingImage || isUploading}
                                                onClick={() => handleDeleteActivityImage(activity, url)}
                                                style={{
                                                    position: 'absolute',
                                                    top: -8,
                                                    right: -8,
                                                    width: 20,
                                                    height: 20,
                                                    padding: 0,
                                                    backgroundColor: '#fff',
                                                    border: '1px solid #e0e0e0',
                                                    color: '#b3261e',
                                                }}
                                            >
                                                {isDeletingImage
                                                    ? <CircularProgress size={10} style={{ color: '#b3261e' }} />
                                                    : <DeleteIcon style={{ fontSize: 12 }} />}
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                    )}
                                </Box>
                                <Button
                                    size="small"
                                    startIcon={<GetAppIcon style={{ fontSize: 14 }} />}
                                    onClick={() => downloadFromUrl(url, `activity-${idx + 1}-${getFileNameFromUrl(url)}`)}
                                    disabled={isDeletingImage}
                                    style={{
                                        color: '#0f3b62',
                                        justifyContent: 'center',
                                        textTransform: 'none',
                                        fontSize: '0.7rem',
                                        padding: '0 4px',
                                        minWidth: 0,
                                    }}
                                >
                                    Download
                                </Button>
                            </Box>
                            );
                        })}
                        {videos.map((url, idx) => (
                            <Box
                                key={`${activity._id}-vid-${idx}`}
                                display="flex"
                                flexDirection="column"
                                alignItems="center"
                                style={{ gap: 2, flex: '0 0 auto' }}
                            >
                                <Box
                                    onClick={() => window.open(url, '_blank', 'noopener,noreferrer')}
                                    style={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: 4,
                                        border: '1px solid #e0e0e0',
                                        backgroundColor: '#1a1a1a',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        cursor: 'pointer',
                                    }}
                                >
                                    <PlayArrowIcon style={{ color: '#fff', fontSize: 22 }} />
                                </Box>
                                <Button
                                    size="small"
                                    startIcon={<GetAppIcon style={{ fontSize: 14 }} />}
                                    onClick={() => downloadFromUrl(url, `activity-video-${idx + 1}-${getFileNameFromUrl(url)}`)}
                                    style={{
                                        color: '#0f3b62',
                                        justifyContent: 'center',
                                        textTransform: 'none',
                                        fontSize: '0.7rem',
                                        padding: '0 4px',
                                        minWidth: 0,
                                    }}
                                >
                                    Download
                                </Button>
                            </Box>
                        ))}
                    </Box>
                )}
                <Box display="flex" alignItems="center" style={{ gap: 6 }}>
                    <Tooltip title={isExpanded ? 'Hide media' : 'Show media'}>
                        <IconButton
                            className={classes.observationIconAction}
                            size="small"
                            onClick={() => setImagesExpanded((prev) => ({
                                ...prev,
                                [activity._id]: !prev[activity._id],
                            }))}
                        >
                            {isExpanded
                                ? <VisibilityOffIcon fontSize="small" />
                                : <VisibilityIcon fontSize="small" />}
                        </IconButton>
                    </Tooltip>
                    <Chip
                        size="small"
                        clickable
                        onClick={() => setImagesExpanded((prev) => ({
                            ...prev,
                            [activity._id]: !prev[activity._id],
                        }))}
                        label={isExpanded ? 'Hide' : mediaCountLabel}
                        style={{
                            backgroundColor: '#e6e6e6',
                            color: '#1a1a1a',
                            fontWeight: 600,
                            cursor: 'pointer',
                        }}
                    />
                </Box>
                {renderActivityImageAddActions(activity, images, isUploading, uploadInputId, group)}
            </Box>
        );
    };


    const historyTimeline = buildKeyStatusTimeline(selectedHistory, historyCurrentKey);
    const historyCurrentIdx = KEY_STATUS_ORDER.indexOf(String(historyCurrentKey || '').toUpperCase());

    return (

        <>
            {/* Page header */}
            <Box className={classes.pageHeader}>
                <Box>
                    <Typography className={classes.pageTitle}>Activity Planner</Typography>
                    <Typography className={classes.pageSubtitle}>
                        Plan and manage class activities for students.
                    </Typography>
                </Box>
                <Box display="flex" alignItems="center" gridGap={10} flexWrap="wrap">
                    <Button
                        className={classes.planBtn}
                        variant="outlined"
                        startIcon={<EventIcon />}
                        onClick={() => history.push('/app/quickactivity')}
                        style={{
                            borderColor: '#1a1a1a',
                            color: '#1a1a1a',
                            backgroundColor: '#fff',
                        }}
                    >
                        Quick activity allotment
                    </Button>
                    <Button
                        className={classes.planBtn}
                        variant="outlined"
                        startIcon={<EventIcon />}
                        onClick={() => history.push('/app/activitymatrix')}
                        style={{
                            borderColor: '#1a1a1a',
                            color: '#1a1a1a',
                            backgroundColor: '#fff',
                        }}
                    >
                        Progress grid
                    </Button>
                    <Button
                        className={classes.planBtn}
                        variant="contained"
                        startIcon={<EventIcon />}
                        onClick={() => handleOpen(true)}
                    >
                        Multiple Activity planner 
                    </Button>
                </Box>
            </Box>

            <Box className={classes.filtersTopRow} style={{ marginBottom: 16 }}>
                <Box display="flex" alignItems="center" gridGap={16} flexWrap="wrap">
                        <Box display="flex" alignItems="center" gridGap={8}>
                            <Typography style={{ fontSize: '0.8rem', color: '#444', fontWeight: 600 }}>
                                Quick Range
                            </Typography>
                            <Box className={classes.quickRangeWrap}>
                                <Button
                                    className={`${classes.quickRangeBtn} ${quickRange === 'week' ? classes.quickRangeBtnActive : ''}`}
                                    onClick={() => applyQuickRange('week')}
                                >
                                    This Week
                                </Button>
                                <Button
                                    className={`${classes.quickRangeBtn} ${quickRange === 'month' ? classes.quickRangeBtnActive : ''}`}
                                    onClick={() => applyQuickRange('month')}
                                >
                                    This Month
                                </Button>
                                <Button
                                    className={`${classes.quickRangeBtn} ${quickRange === 'custom' ? classes.quickRangeBtnActive : ''}`}
                                    startIcon={<CalendarTodayIcon style={{ fontSize: 14 }} />}
                                    onClick={() => applyQuickRange('custom')}
                                >
                                    Custom
                                </Button>
                            </Box>
                        </Box>
                </Box>
                    <Box display="flex" alignItems="center" gridGap={10}>
                        <Button
                            variant="contained"
                            className={classes.exportBtn}
                            startIcon={printing ? <CircularProgress size={16} style={{ color: '#fff' }} /> : <PrintIcon />}
                            onClick={handlePrintFilteredData}
                            disabled={printing || activityTableLoading || !classId}
                        >
                            {printing ? 'Preparing…' : 'Print'}
                        </Button>
                        <ExportExcel excelData={exportExcelData} fileName={'Activity recorder'} />
                    </Box>
            </Box>

            <Card className={classes.tableCard} elevation={0}>
                {/* Toolbar */}
                <Box className={classes.toolbar} px={2} pt={2}>
                    <Box display="flex" alignItems="center" gridGap={16} flexWrap="wrap">
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={showMaster}
                                    onChange={(e) => {
                                        const checked = e.target.checked;
                                        setShowMaster(checked);
                                        setStudentKeyFilters({});
                                        // When revealing master rows, clear key chip filters so M appears with others.
                                        if (checked && keyFilter !== 'all') {
                                            setKeyFilter('all');
                                        }
                                    }}
                                    color="primary"
                                    size="small"
                                    inputProps={{ 'aria-label': 'Show mastered activities along with other keys' }}
                                />
                            }
                            label={
                                <Typography variant="body2" style={{ color: '#444' }}>
                                    Show Master Activities
                                </Typography>
                            }
                        />
                    </Box>
                    <Box display="flex" alignItems="center" gridGap={10} flexWrap="wrap">
                        {selectedTableActivityIds.length > 0 && (
                            <>
                                <Button
                                    variant="contained"
                                    startIcon={<PublishIcon />}
                                    onClick={() => handleBulkPublicStatusClick('publish')}
                                    disabled={statusConfirmDialog.busy}
                                    style={{
                                        textTransform: 'none',
                                        backgroundColor: '#1f8a5b',
                                        color: '#fff',
                                        fontWeight: 600,
                                    }}
                                >
                                    Publish selected ({selectedTableActivityIds.length})
                                </Button>
                                <Button
                                    variant="outlined"
                                    startIcon={<DraftsIcon />}
                                    onClick={() => handleBulkPublicStatusClick('draft')}
                                    disabled={statusConfirmDialog.busy}
                                    style={{
                                        textTransform: 'none',
                                        color: '#e65100',
                                        borderColor: '#ffcc80',
                                        fontWeight: 600,
                                        backgroundColor: '#fff8f1',
                                    }}
                                >
                                    Draft selected ({selectedTableActivityIds.length})
                                </Button>
                                <Button
                                    variant="contained"
                                    startIcon={<DeleteIcon />}
                                    onClick={handleBulkDeleteClick}
                                    style={{
                                        textTransform: 'none',
                                        backgroundColor: '#b3261e',
                                        color: '#fff',
                                        fontWeight: 600,
                                    }}
                                >
                                    Delete selected ({selectedTableActivityIds.length})
                                </Button>
                            </>
                        )}
                        <TextField
                            size="small"
                            variant="outlined"
                            placeholder="Search activities..."
                            value={tableSearch}
                            onChange={handleTableSearchChange}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon fontSize="small" style={{ color: '#8a8a8a' }} />
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <Button
                            variant="outlined"
                            startIcon={<ViewColumnIcon />}
                            onClick={(e) => setColumnMenuAnchor(e.currentTarget)}
                            style={{ textTransform: 'none', color: '#444', borderColor: '#8f8f8f' }}
                        >
                            Column
                        </Button>
                        <Button
                            variant="outlined"
                            startIcon={<FilterListIcon fontSize="small" />}
                            onClick={() => setFiltersOpen((o) => !o)}
                            aria-pressed={filtersOpen}
                            style={filtersOpen ? { backgroundColor: '#e6e6e6' } : undefined}
                        >
                            Filters
                            {activeFilterCount > 0 && <span className={classes.activityCountBadge}>{activeFilterCount}</span>}
                        </Button>
                        <Tooltip title="Refresh">
                            <IconButton className={classes.iconBtnOutlined} onClick={() => onSubmit(startDate1, endDate1)}>
                                <RefreshIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>

                <Box display="flex" alignItems="stretch" flexWrap="wrap">
                <Box flex="1 1 520px" minWidth={0}>
                <TableContainer component={Paper} elevation={0} style={{ maxHeight: 540 }}>
                    <Table stickyHeader className="mb-0 dashboard-table-row-hover">
                        <TableHead>
                            <TableRow>
                                <TableCell padding="checkbox" style={headerCellStyle}>
                                    <Checkbox
                                        color="primary"
                                        size="small"
                                        indeterminate={someVisibleActivitiesSelected && !allVisibleActivitiesSelected}
                                        checked={allVisibleActivitiesSelected}
                                        onChange={toggleSelectAllVisibleActivities}
                                        disabled={activityTableLoading || visiblePaginatedActivityIds.length === 0}
                                        inputProps={{ 'aria-label': 'Select all activities on this page' }}
                                    />
                                </TableCell>
                                {/* <TableCell style={headerCellStyle}>Class</TableCell>
                                <TableCell style={headerCellStyle}>Section</TableCell> */}
                                {columnConfig.map((col) =>
                                    visibleCols[col.id] ? (
                                        <TableCell key={col.id} style={headerCellStyle}>{col.label}</TableCell>
                                    ) : null
                                )}
                                <TableCell style={headerCellStyle} align="center">Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {activityTableLoading
                                ? renderActivityTableSkeleton()
                                : activityList
                                .map((group, groupIndex) => {
                                    const studentName = `${group.studentId?.firstName || ''} ${group.studentId?.lastName || ''}`.trim();
                                    const records = (group.activityRecordsId || [])
                                        .filter(isActivityRecord)
                                        .filter((a) => matchesActivityFilters(a, studentName));
                                    if (records.length === 0) return null;
                                    const studentKey = getStudentGroupKey(group, groupIndex);
                                    const expanded = isStudentActivityExpanded(studentKey);
                                    const keyCounts = records.reduce((acc, rec) => {
                                        const idx = getActivityKeyIndex(rec.key);
                                        if (idx === -1) acc.notSet += 1;
                                        else acc[KEY_SEQUENCE[idx]] += 1;
                                        return acc;
                                    }, { P: 0, WA: 0, WI: 0, M: 0, notSet: 0 });
                                    const keySummary = [
                                        { label: 'P', value: 'P', count: keyCounts.P, color: '#1f8a5b', bg: '#eefbf3' },
                                        { label: 'WA', value: 'WA', count: keyCounts.WA, color: '#1a1a1a', bg: '#e6e6e6' },
                                        { label: 'WI', value: 'WI', count: keyCounts.WI, color: '#e6a23c', bg: '#fff8ed' },
                                        { label: 'M', value: 'M', count: keyCounts.M, color: '#7c3aed', bg: '#f5f0ff' },
                                        { label: 'No Key', value: 'notSet', count: keyCounts.notSet, color: '#64748b', bg: '#f1f5f9' },
                                    ];
                                    const activeKeyFilter = studentKeyFilters[studentKey];
                                    const displayRecords = activeKeyFilter
                                        ? records.filter((rec) => {
                                            const idx = getActivityKeyIndex(rec.key);
                                            return activeKeyFilter === 'notSet'
                                                ? idx === -1
                                                : KEY_SEQUENCE[idx] === activeKeyFilter;
                                        })
                                        : records;
                                    return (
                                        <React.Fragment key={studentKey}>
                                            <TableRow className={`dashboard-table-no-hover ${classes.groupHeaderRow}`}>
                                                <TableCell
                                                    className={classes.groupHeaderCell}
                                                    colSpan={visibleColumnCount}
                                                    onClick={() => toggleStudentActivityRows(studentKey)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter' || e.key === ' ') {
                                                            e.preventDefault();
                                                            toggleStudentActivityRows(studentKey);
                                                        }
                                                    }}
                                                    role="button"
                                                    tabIndex={0}
                                                    aria-expanded={expanded}
                                                >
                                                    <Box className={classes.groupHeaderInner}>
                                                        <Box display="flex" alignItems="center" gridGap={10}>
                                                            <Avatar className={classes.studentAvatar}>
                                                                <PersonIcon style={{ fontSize: 18 }} />
                                                            </Avatar>
                                                            <Typography style={{ fontWeight: 700, color: '#1a1a1a', textTransform: 'uppercase', fontSize: '0.9rem' }}>
                                                                {studentName || 'Unknown Student'}
                                                            </Typography>
                                                            <span className={classes.activityCountBadge}>
                                                                {records.length} {records.length === 1 ? 'Activity' : 'Activities'}
                                                            </span>
                                                            <Box display="flex" alignItems="center" gridGap={6} flexWrap="wrap">
                                                                {keySummary.map((item) => {
                                                                    const isActive = activeKeyFilter === item.value;
                                                                    const isDisabled = item.count === 0;
                                                                    const badge = (
                                                                        <span
                                                                            key={item.label}
                                                                            role="button"
                                                                            tabIndex={isDisabled ? -1 : 0}
                                                                            title={item.value === 'M'
                                                                                ? undefined
                                                                                : (isDisabled
                                                                                    ? `${item.label}: ${item.count}`
                                                                                    : `Show ${item.label} activities (${item.count})`)}
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                if (isDisabled) return;
                                                                                toggleStudentKeyFilter(studentKey, item.value);
                                                                            }}
                                                                            onKeyDown={(e) => {
                                                                                if (isDisabled) return;
                                                                                if (e.key === 'Enter' || e.key === ' ') {
                                                                                    e.preventDefault();
                                                                                    e.stopPropagation();
                                                                                    toggleStudentKeyFilter(studentKey, item.value);
                                                                                }
                                                                            }}
                                                                            style={{
                                                                                display: 'inline-flex',
                                                                                alignItems: 'center',
                                                                                gap: 4,
                                                                                padding: '2px 8px',
                                                                                borderRadius: 999,
                                                                                fontSize: '0.72rem',
                                                                                fontWeight: 700,
                                                                                color: isActive ? '#ffffff' : item.color,
                                                                                backgroundColor: isActive ? item.color : item.bg,
                                                                                border: `1px solid ${isActive ? item.color : `${item.color}33`}`,
                                                                                opacity: isDisabled ? 0.45 : 1,
                                                                                cursor: isDisabled ? 'default' : 'pointer',
                                                                                boxShadow: isActive ? `0 2px 6px ${item.color}55` : 'none',
                                                                            }}
                                                                        >
                                                                            {item.label}: {item.count}
                                                                        </span>
                                                                    );

                                                                    if (item.value === 'M') {
                                                                        // Tip only when master activities are hidden; hide once Show Master is on.
                                                                        if (showMaster) {
                                                                            return badge;
                                                                        }
                                                                        return (
                                                                            <Tooltip
                                                                                key={item.label}
                                                                                title="Turn on Show Master Activities to include mastered rows with other keys"
                                                                                arrow
                                                                            >
                                                                                <span>{badge}</span>
                                                                            </Tooltip>
                                                                        );
                                                                    }

                                                                    return badge;
                                                                })}
                                                                {activeKeyFilter && (
                                                                    <span
                                                                        role="button"
                                                                        tabIndex={0}
                                                                        title="Clear key filter"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            toggleStudentKeyFilter(studentKey, activeKeyFilter);
                                                                        }}
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Enter' || e.key === ' ') {
                                                                                e.preventDefault();
                                                                                e.stopPropagation();
                                                                                toggleStudentKeyFilter(studentKey, activeKeyFilter);
                                                                            }
                                                                        }}
                                                                        style={{
                                                                            display: 'inline-flex',
                                                                            alignItems: 'center',
                                                                            padding: '2px 8px',
                                                                            borderRadius: 999,
                                                                            fontSize: '0.72rem',
                                                                            fontWeight: 700,
                                                                            color: '#64748b',
                                                                            backgroundColor: '#f1f5f9',
                                                                            border: '1px solid #cbd5e1',
                                                                            cursor: 'pointer',
                                                                        }}
                                                                    >
                                                                        Clear
                                                                    </span>
                                                                )}
                                                            </Box>
                                                        </Box>
                                                        {expanded ? (
                                                            <ExpandMoreIcon style={{ color: '#444' }} />
                                                        ) : (
                                                            <ChevronRightIcon style={{ color: '#444' }} />
                                                        )}
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                            {expanded
                                                ? displayRecords.flatMap((activity, recordIndex) => {
                                                    const isObsExpanded = observationExpanded[activity._id] === true;
                                                    const hasObservation = hasSavedRemarks(activity);
                                                    const rowKey = getActivityRowKey(activity, group, recordIndex);
                                                    const canMutateRow = canMutateActivity(activity);

                                                    return [
                                                        <TableRow key={rowKey}>
                                                            <TableCell padding="checkbox">
                                                                <Checkbox
                                                                    color="primary"
                                                                    size="small"
                                                                    disabled={!canMutateRow}
                                                                    checked={canMutateRow && selectedIdSet.has(String(activity._id))}
                                                                    onChange={() => canMutateRow && toggleActivitySelection(activity._id)}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                    inputProps={{ 'aria-label': `Select activity ${activity.activityId?.activityName || ''}` }}
                                                                />
                                                            </TableCell>
                                                            {/* <TableCell>
                                                                {activity.classId ? (
                                                                    <Chip size="small" label={activity.classId.className} className={classes.classChip} />
                                                                ) : ''}
                                                            </TableCell> */}
                                                            {/* <TableCell>{activity.sectionId ? activity.sectionId.sectionName : ''}</TableCell> */}
                                                            {visibleCols.areaOfWork && (
                                                                <TableCell>{activity.superActivityId ? activity.superActivityId.superActivityName : ''}</TableCell>
                                                            )}
                                                            {visibleCols.listOfActivities && (
                                                                <TableCell>{activity.activityId ? activity.activityId.activityName : ''}</TableCell>
                                                            )}
                                                            {visibleCols.exercises && (
                                                                <TableCell>{activity.subActivityId ? activity.subActivityId.subActivityName : ''}</TableCell>
                                                            )}
                                                            {visibleCols.createdBy && (
                                                                <TableCell style={{ color: '#444' }}>
                                                                    {getCreatedByLabel(activity.createdBy)}
                                                                </TableCell>
                                                            )}
                                                            {visibleCols.key && (
                                                                <TableCell>
                                                                    {renderKeyStatusStepper(activity, group)}
                                                                </TableCell>
                                                            )}
                                                                {visibleCols.observation && (
                                                                <TableCell
                                                                    className={
                                                                        hasSavedRemarks(activity)
                                                                            ? classes.observationCell
                                                                            : undefined
                                                                    }
                                                                >
                                                                    {renderObservationCell(activity, group)}
                                                                </TableCell>
                                                            )}
                                                            {visibleCols.startDate && (
                                                                <TableCell>
                                                                    <span className={classes.dateCell}>
                                                                        <CalendarTodayIcon style={{ fontSize: 14, color: '#8a8a8a' }} />
                                                                        {formatDate(activity.date)}
                                                                    </span>
                                                                </TableCell>
                                                            )}
                                                            {visibleCols.endDate && (
                                                                <TableCell>
                                                                    <span className={classes.dateCell}>
                                                                        <CalendarTodayIcon style={{ fontSize: 14, color: '#8a8a8a' }} />
                                                                        {formatDate(activity.endDate)}
                                                                    </span>
                                                                </TableCell>
                                                            )}
                                                        
                                                            {visibleCols.status && (
                                                                <TableCell>
                                                                    {!isActivityPublishedToParent(activity) ? (
                                                                        <Chip
                                                                            size="small"
                                                                            label="Draft"
                                                                            className={classes.statusDraft}
                                                                            onClick={canMutateRow
                                                                                ? () => handlePublicStatusChange(activity, 'publish')
                                                                                : undefined}
                                                                            style={canMutateRow ? undefined : { cursor: 'default' }}
                                                                        />
                                                                    ) : (
                                                                        <Chip
                                                                            size="small"
                                                                            label="Published"
                                                                            className={classes.statusPublished}
                                                                            onClick={canMutateRow
                                                                                ? () => handlePublicStatusChange(activity, 'draft')
                                                                                : undefined}
                                                                            style={canMutateRow ? undefined : { cursor: 'default' }}
                                                                        />
                                                                    )}
                                                                </TableCell>
                                                            )}
                                                            {visibleCols.images && (
                                                                <TableCell>
                                                                    {renderActivityImagesCell(activity, group)}
                                                                </TableCell>
                                                            )}
                                                            <TableCell align="center">
                                                                <IconButton size="small" onClick={(e) => openActionMenu(e, activity, group)}>
                                                                    <MoreVertIcon fontSize="small" />
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>,
                                                        isObsExpanded && hasObservation && visibleCols.observation
                                                            ? renderObservationExpandRow(activity)
                                                            : null,
                                                    ].filter(Boolean);
                                                })
                                                : null}
                                        </React.Fragment>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </TableContainer>

                {activityTableLoading ? (
                    <Box className={classes.tableSkeletonPagination}>
                        <Skeleton variant="text" width={96} height={20} animation="wave" classes={{ root: classes.skeletonBar }} />
                        <Skeleton variant="rect" width={52} height={28} animation="wave" style={{ borderRadius: 6 }} classes={{ root: classes.skeletonBar }} />
                        <Skeleton variant="text" width={72} height={20} animation="wave" classes={{ root: classes.skeletonBar }} />
                        <Skeleton variant="circle" width={28} height={28} animation="wave" classes={{ root: classes.skeletonBar }} />
                        <Skeleton variant="circle" width={28} height={28} animation="wave" classes={{ root: classes.skeletonBar }} />
                    </Box>
                ) : (
                <TablePagination
                    component="div"
                    rowsPerPageOptions={[20, 50, 100]}
                    count={activityTotal}
                    page={pg}
                    onPageChange={handleChangePage}
                    rowsPerPage={rpg}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
                )}
                </Box>
                {filtersOpen && (
                    <FilterPanel onReset={handleResetFilters} onApply={() => onSubmit(startDate1, endDate1)} applyLabel="Apply filters">
                    <FilterSection title="Class *" icon={<SchoolIcon style={{ fontSize: 16 }} />}>
                            <FormControl fullWidth variant="outlined" size="small" required>
                                <Select
                                    displayEmpty
                                    name="classId"
                                    value={classId}
                                    onChange={e => {
                                        const value = e.target.value;
                                        setClassId(value);
                                        setSectionId('');
                                        getStudentList(e, null, '');
                                        getSectionListByClass(value);
                                    }}
                                >
                                    <MenuItem value=""><em>Select Class</em></MenuItem>
                                    {addClassList.map(({ _id, className }) => (
                                        <MenuItem key={_id} value={_id}>{className}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                    </FilterSection>
                    <FilterSection title="Section" icon={<PersonIcon style={{ fontSize: 16 }} />}>
                            <FormControl fullWidth variant="outlined" size="small">
                                <Select
                                    displayEmpty
                                    name="sectionId"
                                    value={sectionId}
                                    onChange={(e) => {
                                        const selectedSectionId = e.target.value;
                                        setSectionId(selectedSectionId);
                                        if (classId) {
                                            getStudentList({ target: { value: classId } }, null, selectedSectionId || undefined);
                                        }
                                    }}
                                    disabled={!classId || sectionList.length === 0}
                                >
                                    <MenuItem value=""><em>All Sections</em></MenuItem>
                                    {sectionList.map(({ _id, sectionName }) => (
                                        <MenuItem key={_id} value={_id}>{sectionName}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                    </FilterSection>
                    <FilterSection title="Student" icon={<PersonIcon style={{ fontSize: 16 }} />}>
                            <FormControl fullWidth variant="outlined" size="small">
                                <Select
                                    displayEmpty
                                    name="studentId"
                                    value={studentId}
                                    onChange={e => { setStudentId(e.target.value) }}
                                >
                                    <MenuItem value=""><em>All Students</em></MenuItem>
                                    {studentList.map(({ index, _id, studentName, ageLabel }) => (
                                        <MenuItem key={index} value={_id}>
                                            {studentName}
                                            {ageLabel && (
                                                <span style={{ color: '#8a8a8a', marginLeft: 6, fontSize: '0.8rem' }}>
                                                    ({ageLabel})
                                                </span>
                                            )}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                    </FilterSection>
                    <FilterSection title="Date range" icon={<CalendarTodayIcon style={{ fontSize: 16 }} />}>
                            <Box display="flex" flexDirection="column" gridGap={8}>
                                <SchoolDatePicker
                                    minDate="2016-11-10"
                                    value={startDate1}
                                    onChange={iso => {
                                        setQuickRange('custom');
                                        setStartDate1(iso);
                                        if (endDate1 && iso && new Date(iso) > new Date(endDate1)) {
                                            setEndDate1('');
                                        }
                                    }}
                                />
                                <SchoolDatePicker
                                    minDate={startDate1 || '2016-11-10'}
                                    value={endDate1}
                                    onChange={iso => {
                                        const selectedEndDate = iso;
                                        setQuickRange('custom');
                                        if (!startDate1 || new Date(selectedEndDate) >= new Date(startDate1)) {
                                            setEndDate1(selectedEndDate);
                                        } else {
                                            setMessageDialogContent({
                                                title: 'Validation Error',
                                                message: 'End date must be greater than or equal to start date',
                                                type: 'error'
                                            });
                                            setOpenMessageDialog(true);
                                        }
                                    }}
                                    error={Boolean(endDate1 && startDate1 && new Date(endDate1) < new Date(startDate1))}
                                />
                            </Box>
                    </FilterSection>
                    <FilterSection title="Status">
                            <FormControl fullWidth variant="outlined" size="small">
                                <Select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
                                    <MenuItem value="all">All Status</MenuItem>
                                    <MenuItem value="draft">Draft</MenuItem>
                                    <MenuItem value="published">Published</MenuItem>
                                </Select>
                            </FormControl>
                    </FilterSection>
                    <FilterSection title="Key">
                            <FormControl fullWidth variant="outlined" size="small">
                                <Select value={keyFilter} onChange={(e) => setKeyFilter(e.target.value)}>
                                    <MenuItem value="all">All Keys</MenuItem>
                                    {keyOptions.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                    </FilterSection>
                    </FilterPanel>
                )}
                </Box>
            </Card>

            {/* Column visibility menu */}
            <Menu
                anchorEl={columnMenuAnchor}
                open={Boolean(columnMenuAnchor)}
                onClose={() => setColumnMenuAnchor(null)}
            >
                {columnConfig.map((col) => (
                    <MenuItem
                        key={col.id}
                        onClick={() => setVisibleCols((v) => ({ ...v, [col.id]: !v[col.id] }))}
                    >
                        <Checkbox checked={visibleCols[col.id]} size="small" color="primary" />
                        {col.label}
                    </MenuItem>
                ))}
            </Menu>

            {/* Image add options menu */}
            <Menu
                anchorEl={imageAddMenu.anchorEl}
                open={Boolean(imageAddMenu.anchorEl)}
                onClose={closeImageAddMenu}
            >
                <MenuItem onClick={handleImageAddMenuUpload}>
                    <CloudUploadIcon fontSize="small" style={{ marginRight: 10, color: '#444' }} />
                    Upload Images
                </MenuItem>
                <MenuItem onClick={handleImageAddMenuStore}>
                    <PhotoLibraryIcon fontSize="small" style={{ marginRight: 10, color: '#444' }} />
                    From Images Store
                </MenuItem>
            </Menu>

            {/* Row actions menu */}
            <Menu
                anchorEl={actionMenu.anchorEl}
                open={Boolean(actionMenu.anchorEl)}
                onClose={closeActionMenu}
            >
                {canMutateActivity(actionMenu.activity) && (
                    <MenuItem
                        onClick={() => { editActivity(actionMenu.activity, false, actionMenu.group); closeActionMenu(); }}
                    >
                        <EditIcon fontSize="small" style={{ marginRight: 10, color: '#444' }} /> Edit
                    </MenuItem>
                )}
                <MenuItem
                    onClick={() => { editActivity(actionMenu.activity, true, actionMenu.group); closeActionMenu(); }}
                >
                    <AddIcon fontSize="small" style={{ marginRight: 10, color: '#444' }} /> Add More
                </MenuItem>
                {canMutateActivity(actionMenu.activity)
                    && actionMenu.activity
                    && isActivityPublishedToParent(actionMenu.activity) && (
                    <MenuItem
                        onClick={() => {
                            handlePublicStatusChange(actionMenu.activity, 'draft');
                            closeActionMenu();
                        }}
                    >
                        <EditIcon fontSize="small" style={{ marginRight: 10, color: '#1a1a1a' }} /> Move to Draft
                    </MenuItem>
                )}
                <MenuItem
                    onClick={() => {
                        const a = actionMenu.activity;
                        setSelectedHistory(Array.isArray(a?.statusHistory) ? a.statusHistory : []);
                        setHistoryCurrentKey(a?.key || '');
                        setOpenHistory(true);
                        closeActionMenu();
                    }}
                >
                    <HistoryIcon fontSize="small" style={{ marginRight: 10, color: '#444' }} /> History
                </MenuItem>
                {canMutateActivity(actionMenu.activity) && (
                    <>
                        <Divider />
                        <MenuItem
                            onClick={() => { handleDeleteClick(actionMenu.activity._id); closeActionMenu(); }}
                            style={{ color: '#b3261e' }}
                        >
                            <DeleteIcon fontSize="small" style={{ marginRight: 10 }} /> Delete
                        </MenuItem>
                    </>
                )}
            </Menu>

            <Dialog
                open={open}
                onClose={handleClose}
                scroll="paper"
                PaperProps={{ className: classes.planDialogPaper }}
            >
                <Box className={classes.dialogTitleBar}>
                    <span className={classes.dialogTitleText}>
                        {activity._id ? 'Edit Plan Activity' : 'Plan Activity'}
                    </span>
                    <IconButton size="small" onClick={handleClose} disabled={addActivityLoading}>
                        <CloseIcon style={{ fontSize: 20, color: '#7a8aa0' }} />
                    </IconButton>
                </Box>
                <form onSubmit={formik.handleSubmit}>
                    <DialogContent className={classes.dialogBody}>
                        <Box className={classes.formSection}>
                            <Typography className={classes.sectionLabel}>Schedule</Typography>
                            <Box className={classes.dateRow}>
                                <Box className={classes.dateFieldWrap}>
                                    <span className={classes.dateFieldLabel}>Start Date *</span>
                                    <SchoolDatePicker
                                        id="date"
                                        name="date"
                                        required
                                        error={formik.touched.date && Boolean(formik.errors.date)}
                                        value={formik.values.date}
                                        onChange={(iso) => {
                                            formik.setFieldValue('date', iso);
                                            if (formik.values.endDate && iso && new Date(iso) > new Date(formik.values.endDate)) {
                                                formik.setFieldValue('endDate', '');
                                            }
                                        }}
                                        helperText={formik.touched.date && formik.errors.date ? formik.errors.date : ' '}
                                    />
                                </Box>
                                <Box className={classes.dateFieldWrap}>
                                    <span className={classes.dateFieldLabel}>End Date *</span>
                                    <SchoolDatePicker
                                        id="endDate"
                                        name="endDate"
                                        required
                                        minDate={formik.values.date || undefined}
                                        value={formik.values.endDate}
                                        onChange={(iso) => {
                                            const selectedEndDate = iso;
                                            if (!formik.values.date || new Date(selectedEndDate) >= new Date(formik.values.date)) {
                                                formik.setFieldValue('endDate', iso);
                                            } else {
                                                setMessageDialogContent({
                                                    title: 'Validation Error',
                                                    message: 'End date must be greater than or equal to start date',
                                                    type: 'error'
                                                });
                                                setOpenMessageDialog(true);
                                            }
                                        }}
                                        error={(formik.touched.endDate && Boolean(formik.errors.endDate)) || (formik.values.endDate && formik.values.date && new Date(formik.values.endDate) < new Date(formik.values.date))}
                                        helperText={
                                            formik.touched.endDate && formik.errors.endDate
                                                ? formik.errors.endDate
                                                : (formik.values.endDate && formik.values.date && new Date(formik.values.endDate) < new Date(formik.values.date)
                                                    ? 'End date must be >= start date'
                                                    : ' ')
                                        }
                                    />
                                </Box>
                            </Box>
                        </Box>

                        <Box className={classes.formSection}>
                            <Typography className={classes.sectionLabel}>Class &amp; Students</Typography>
                            <Box mb={1.5}>
                                <span className={classes.fieldLabel}>Select Class *</span>
                                <FormControl
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    required
                                    error={formik.touched.classId && Boolean(formik.errors.classId)}
                                >
                                    <Select
                                        id="demo-simple-select"
                                        name="classId"
                                        displayEmpty
                                        value={formik.values.classId}
                                        onChange={e => {
                                            formik.handleChange(e);
                                            formik.setFieldValue('sectionId', '');
                                            loadDialogSectionList(e.target.value);
                                            getStudentList(e, null, '');
                                            getAllSuperActivityTabelMultiple(e);
                                            if (!e.target.value || e.target.value === '') {
                                                formik.setFieldValue('studentId', []);
                                                setGroupedUnmasteredActivities({});
                                                setFilteredUnmasteredActivities([]);
                                            } else {
                                                const userDetails = JSON.parse(localStorage.getItem("userDetail"));
                                                fetchAndGroupUnmasteredActivities(e.target.value, userDetails.schooleId);
                                            }
                                        }}
                                    >
                                        <MenuItem value=""><em>Select Class</em></MenuItem>
                                        {addClassList.map(({ _id, className }) => (
                                            <MenuItem key={_id} value={_id}>{className}</MenuItem>
                                        ))}
                                    </Select>
                                    {formik.touched.classId && formik.errors.classId && (
                                        <FormHelperText>{formik.errors.classId}</FormHelperText>
                                    )}
                                </FormControl>
                            </Box>

                            <Box mb={1.5}>
                                <span className={classes.fieldLabel}>Select Section (Optional)</span>
                                <FormControl variant="outlined" size="small" fullWidth>
                                    <Select
                                        id="dialog-section-select"
                                        name="sectionId"
                                        displayEmpty
                                        value={formik.values.sectionId || ''}
                                        onChange={(e) => {
                                            formik.handleChange(e);
                                            if (formik.values.classId) {
                                                // Pass '' (not undefined) when cleared so we load ALL
                                                // class students instead of falling back to the page filter.
                                                getStudentList({ target: { value: formik.values.classId } }, null, e.target.value || '');
                                            }
                                        }}
                                        disabled={!formik.values.classId || dialogSectionList.length === 0}
                                    >
                                        {!(userDetails?.role === 'TEACHER' && userDetails?.sectionId) && (
                                            <MenuItem value=""><em>None</em></MenuItem>
                                        )}
                                        {dialogSectionList.map(({ _id, sectionName }) => (
                                            <MenuItem key={_id} value={_id}>{sectionName}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>

                            <Box mb={1}>
                                <span className={classes.fieldLabel}>Student Name</span>
                                <FormControl variant="outlined" size="small" fullWidth>
                                    <Select
                                        id="studentName-select"
                                        name="studentId"
                                        multiple
                                        displayEmpty
                                        disabled={formik.values.isEdit || !formik.values.classId || formik.values.classId === ''}
                                        value={formik.values.studentId}
                                        onChange={(e) => {
                                            formik.handleChange(e);
                                            if (!formik.values.isEventForAllStudent) {
                                                const selectedStudentIds = e.target.value;
                                                if (selectedStudentIds && selectedStudentIds.length > 0) {
                                                    const filtered = [];
                                                    selectedStudentIds.forEach(studentId => {
                                                        if (groupedUnmasteredActivities[studentId]) {
                                                            filtered.push(...groupedUnmasteredActivities[studentId]);
                                                        }
                                                    });
                                                    setFilteredUnmasteredActivities(filtered);
                                                } else {
                                                    setFilteredUnmasteredActivities([]);
                                                }
                                            }
                                            try {
                                                const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
                                                const schooleId = userDetails.schooleId?._id || userDetails.schooleId || userDetails.schoolId?._id || userDetails.schoolId;
                                                ActivityService.getExistingActivityKeys({
                                                    schooleId,
                                                    classId: formik.values.classId,
                                                    sectionId: formik.values.sectionId || null,
                                                    studentId: e.target.value,
                                                    isEventForAllStudent: Boolean(formik.values.isEventForAllStudent),
                                                }).then((r) => {
                                                    const data = r?.data || r;
                                                    const keys = Array.isArray(data?.keys) ? data.keys : [];
                                                    setExistingKeySet(new Set(keys));
                                                    setExistingKeyStudents(data?.byKey || {});
                                                }).catch(() => setExistingKeySet(new Set()));
                                            } catch (err) {
                                                setExistingKeySet(new Set());
                                                setExistingKeyStudents({});
                                            }
                                        }}
                                        renderValue={(selected) => {
                                            if (!formik.values.classId || formik.values.classId === '') {
                                                return <span style={{ color: '#8a8a8a' }}>Please select a class first</span>;
                                            }
                                            const selectedIds = (selected || []).map(String);
                                            const selectedNames = studentList
                                                .filter(({ _id }) => selectedIds.includes(String(_id)))
                                                .map(({ studentName }) => studentName);
                                            return selectedNames.length > 0 ? selectedNames.join(", ") : <span style={{ color: '#8a8a8a' }}>Select students</span>;
                                        }}
                                    >
                                        {dialogStudentList.length === 0 ? (
                                            <MenuItem disabled value="">
                                                {formik.values.classId
                                                    ? (selectedAgeFilter ? 'No students in this age group' : 'No students found')
                                                    : 'Please select a class first'}
                                            </MenuItem>
                                        ) : (
                                            dialogStudentList.map(({ _id, studentName, ageLabel }) => {
                                                const isChecked = (formik.values.studentId || []).some(
                                                    (id) => String(id) === String(_id)
                                                );
                                                return (
                                                    <MenuItem key={_id} value={_id} dense>
                                                        <Checkbox
                                                            color="primary"
                                                            checked={isChecked}
                                                            style={{ padding: '4px 8px 4px 0' }}
                                                        />
                                                        <ListItemText
                                                            primary={
                                                                <span>
                                                                    {studentName}
                                                                    {ageLabel && (
                                                                        <span style={{ color: '#8a8a8a', marginLeft: 6, fontSize: '0.8rem' }}>
                                                                            ({ageLabel})
                                                                        </span>
                                                                    )}
                                                                </span>
                                                            }
                                                        />
                                                    </MenuItem>
                                                );
                                            })
                                        )}
                                    </Select>
                                </FormControl>
                                {formik.values.classId && studentList.length > 0 && (
                                    <Box mt={0.75}>
                                        <span className={classes.fieldLabel}>Age Group</span>
                                        <Box display="flex" flexWrap="wrap" alignItems="center" style={{ gap: 6 }}>
                                            <Chip
                                                size="small"
                                                label={`All (${studentList.length})`}
                                                onClick={handleSelectAllStudentsChip}
                                                disabled={formik.values.isEdit}
                                                style={{
                                                    backgroundColor: !selectedAgeFilter ? '#1a1a1a' : '#e6e6e6',
                                                    color: !selectedAgeFilter ? '#fff' : '#1a1a1a',
                                                    fontWeight: 600,
                                                    cursor: formik.values.isEdit ? 'default' : 'pointer',
                                                }}
                                            />
                                            {studentAgeWiseSummary.map(([label, count]) => {
                                                const isActive = selectedAgeFilter === label;
                                                return (
                                                    <Chip
                                                        key={label}
                                                        size="small"
                                                        label={`${label} (${count})`}
                                                        clickable={!formik.values.isEdit}
                                                        disabled={formik.values.isEdit}
                                                        onClick={() => handleAgeChipSelect(label)}
                                                        variant={isActive ? 'default' : 'outlined'}
                                                        style={
                                                            isActive
                                                                ? { backgroundColor: '#1a1a1a', color: '#fff', fontWeight: 600 }
                                                                : undefined
                                                        }
                                                    />
                                                );
                                            })}
                                        </Box>
                                        <Typography
                                            variant="caption"
                                            style={{ display: 'block', marginTop: 6, color: '#8a8a8a' }}
                                        >
                                            {selectedAgeFilter
                                                ? `Selected age “${selectedAgeFilter}”: all ${dialogStudentList.length} student(s) added. Open Student Name to keep or remove specific ones.`
                                                : 'Tap an age to select all students in that age, or pick specific students from the list.'}
                                        </Typography>
                                    </Box>
                                )}
                            </Box>

                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="isEventForAllStudent"
                                        id="terms"
                                        color="primary"
                                        value={formik.values.isEventForAllStudent}
                                        checked={Boolean(formik.values.isEventForAllStudent) && !selectedAgeFilter}
                                        disabled={Boolean(selectedAgeFilter) || formik.values.isEdit}
                                        onChange={(e) => {
                                            if (selectedAgeFilter) return;
                                            formik.handleChange(e);
                                            if (e.target.checked) {
                                                const allActivities = [];
                                                Object.values(groupedUnmasteredActivities).forEach(activities => {
                                                    allActivities.push(...activities);
                                                });
                                                setFilteredUnmasteredActivities(allActivities);
                                            } else {
                                                const selectedStudentIds = formik.values.studentId || [];
                                                if (selectedStudentIds.length > 0) {
                                                    const filtered = [];
                                                    selectedStudentIds.forEach(studentId => {
                                                        if (groupedUnmasteredActivities[studentId]) {
                                                            filtered.push(...groupedUnmasteredActivities[studentId]);
                                                        }
                                                    });
                                                    setFilteredUnmasteredActivities(filtered);
                                                } else {
                                                    setFilteredUnmasteredActivities([]);
                                                }
                                            }
                                            try {
                                                const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
                                                const schooleId = userDetails.schooleId?._id || userDetails.schooleId || userDetails.schoolId?._id || userDetails.schoolId;
                                                ActivityService.getExistingActivityKeys({
                                                    schooleId,
                                                    classId: formik.values.classId,
                                                    sectionId: formik.values.sectionId || null,
                                                    studentId: formik.values.studentId || [],
                                                    isEventForAllStudent: Boolean(e.target.checked),
                                                }).then((r) => {
                                                    const data = r?.data || r;
                                                    const keys = Array.isArray(data?.keys) ? data.keys : [];
                                                    setExistingKeySet(new Set(keys));
                                                    setExistingKeyStudents(data?.byKey || {});
                                                }).catch(() => setExistingKeySet(new Set()));
                                            } catch (err) {
                                                setExistingKeySet(new Set());
                                                setExistingKeyStudents({});
                                            }
                                        }}
                                    />
                                }
                                label={
                                    selectedAgeFilter
                                        ? 'For All Class Students (disabled while an age is selected)'
                                        : 'For All Class Students'
                                }
                                style={{ marginLeft: 0 }}
                            />
                        </Box>
                        {/* Display unmastered activities for selected students or all if "For All Class Students" is checked */}
                        {/* {(() => {
                            // Get activities to display - all if "For All Class Students" is checked, otherwise filtered
                            const activitiesToDisplay = formik.values.isEventForAllStudent 
                                ? Object.values(groupedUnmasteredActivities).flat()
                                : filteredUnmasteredActivities;
                            
                            return activitiesToDisplay.length > 0 && (
                                <FormControl variant="standard" style={{ width: 423, marginTop: '16px' }}>
                                    <InputLabel id="unmastered-activities-label">Unmastered Activities</InputLabel>
                                    <Select
                                        labelId="unmastered-activities-label"
                                        id="unmastered-activities-select"
                                        label="Unmastered Activities"
                                        multiple
                                        value={[]}
                                        renderValue={() => `${activitiesToDisplay.length} unmastered activity(ies) found`}
                                        style={{ maxHeight: '200px', overflowY: 'auto' }}
                                    >
                                        {activitiesToDisplay.map((activity, index) => {
                                        const studentName = activity.studentId?.fullName || 
                                            (activity.studentId?.firstName && activity.studentId?.lastName 
                                                ? `${activity.studentId.firstName} ${activity.studentId.lastName}` 
                                                : 'Unknown Student');
                                        const activityName = activity.activityId?.activityName || 'Unknown Activity';
                                        const subActivityName = activity.subActivityId?.subActivityName || '';
                                        const superActivityName = activity.superActivityId?.superActivityName || '';
                                        const keyText = activity.keyText || activity.key || '';
                                        
                                        return (
                                            <MenuItem key={index} value={activity._id} disabled>
                                                <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                                    <div style={{ fontWeight: '600', marginBottom: '4px' }}>
                                                        {studentName}
                                                    </div>
                                                    <div style={{ fontSize: '0.85rem', color: '#666' }}>
                                                        <div><strong>Area:</strong> {superActivityName}</div>
                                                        <div><strong>Activity:</strong> {activityName}</div>
                                                        {subActivityName && <div><strong>Exercise:</strong> {subActivityName}</div>}
                                                        <div><strong>Status:</strong> <span style={{ color: '#ff9800', fontWeight: '600' }}>{keyText}</span></div>
                                                    </div>
                                                </div>
                                            </MenuItem>
                                        );
                                        })}
                                    </Select>
                                </FormControl>
                            );
                        })()} */}
                        
                        <Box className={classes.formSection}>
                            <Typography className={classes.sectionLabel}>Activities</Typography>
                        {formik.values.isEdit ? (
                            <>
                                <Box mb={1.5}>
                                    <span className={classes.fieldLabel}>Area Of Work</span>
                                    <FormControl variant="outlined" size="small" fullWidth>
                                        <Select
                                            id="superActivityName"
                                            name="superActivityId"
                                            displayEmpty
                                            onChange={e => { formik.handleChange(e); getActivityList(e) }}
                                            value={formik.values.superActivityId}
                                            error={formik.touched.superActivityId && Boolean(formik.errors.superActivityId)}
                                        >
                                            <MenuItem value=""><em>Select area</em></MenuItem>
                                            {addSuperActivityList.map(({ _id, superActivityName }) => (
                                                <MenuItem key={_id} value={String(_id)}>{superActivityName}</MenuItem>
                                            ))}
                                        </Select>
                                        {formik.touched.superActivityId && formik.errors.superActivityId && (
                                            <FormHelperText error>{formik.errors.superActivityId}</FormHelperText>
                                        )}
                                    </FormControl>
                                </Box>
                                <Box mb={1.5}>
                                    <span className={classes.fieldLabel}>List Of Activities</span>
                                    <FormControl variant="outlined" size="small" fullWidth>
                                        <Select
                                            id="activityName"
                                            name="activityId"
                                            displayEmpty
                                            onChange={e => { formik.handleChange(e); getSubActivityList(e) }}
                                            value={formik.values.activityId}
                                            error={formik.touched.activityId && Boolean(formik.errors.activityId)}
                                        >
                                            <MenuItem value=""><em>Select activity</em></MenuItem>
                                            {addActivityList.map(({ _id, activityName }) => (
                                                <MenuItem key={_id} value={String(_id)}>{activityName}</MenuItem>
                                            ))}
                                        </Select>
                                        {formik.touched.activityId && formik.errors.activityId && (
                                            <FormHelperText error>{formik.errors.activityId}</FormHelperText>
                                        )}
                                    </FormControl>
                                </Box>
                                <Box mb={1.5}>
                                    <span className={classes.fieldLabel}>Exercise</span>
                                    <FormControl variant="outlined" size="small" fullWidth>
                                        <Select
                                            id="subActivityId"
                                            name="subActivityId"
                                            displayEmpty
                                            value={formik.values.subActivityId}
                                            onChange={formik.handleChange}
                                            error={formik.touched.subActivityId && Boolean(formik.errors.subActivityId)}
                                        >
                                            <MenuItem value=""><em>Select exercise</em></MenuItem>
                                            {subActivityList.map(({ _id, subActivityName }) => (
                                                <MenuItem key={_id} value={String(_id)}>{subActivityName}</MenuItem>
                                            ))}
                                        </Select>
                                        {formik.touched.subActivityId && formik.errors.subActivityId && (
                                            <FormHelperText error>{formik.errors.subActivityId}</FormHelperText>
                                        )}
                                    </FormControl>
                                </Box>
                            </>
                        ) : (
                            <>
                                <TextField
                                    fullWidth
                                    size="small"
                                    variant="outlined"
                                    id="search-activities"
                                    placeholder="Search activities..."
                                    type="text"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    style={{ marginBottom: 12 }}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon style={{ fontSize: 18, color: '#8a8a8a' }} />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                <Box display="flex" alignItems="center" flexWrap="wrap" gridGap={10} mb={1}>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={showOnlyExisting}
                                                onChange={(e) => setShowOnlyExisting(e.target.checked)}
                                                color="primary"
                                                size="small"
                                            />
                                        }
                                        label={<span style={{ fontSize: '0.875rem', color: '#444' }}>Show only already added</span>}
                                    />
                                    <Typography variant="caption" style={{ color: '#64748b' }}>
                                        (Already added items are highlighted in light red)
                                    </Typography>
                                </Box>
                                <Box className={classes.activityTreeWrap}>
                                    <TreeView
                                        defaultCollapseIcon={<ExpandMoreIcon />}
                                        defaultExpandIcon={<ChevronRightIcon />}
                                    >
                                        {selectedActivities.map((node) => renderTree(node))}
                                    </TreeView>
                                </Box>
                            </>
                        )}
                        </Box>
                        <Box className={classes.formSection}>
                            <Typography className={classes.sectionLabel}>Details</Typography>
                            <Box mb={1.5}>
                                <span className={classes.fieldLabel}>Select Key</span>
                                <FormControl variant="outlined" size="small" fullWidth>
                                    <Select
                                        id="demo-simple-select-standard"
                                        name="key"
                                        displayEmpty
                                        value={formik.values.key}
                                        onChange={formik.handleChange}
                                        error={formik.touched.key && Boolean(formik.errors.key)}
                                    >
                                        <MenuItem value=""><em>Select key</em></MenuItem>
                                        {keyOptions.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    <FormHelperText style={{ color: '#64748b' }}>
                                        Add the activity future without requiring key selection, and allow editing later if the student has performed any key.
                                    </FormHelperText>
                                </FormControl>
                            </Box>
                        </Box>

                    </DialogContent>
                    <DialogActions className={classes.dialogFooter}>
                        <Button onClick={handleClose} disabled={addActivityLoading} className={classes.cancelBtn}>
                            Cancel
                        </Button>
                        <Button
                            type="submit"
                            onClick={verifyeetnt}
                            disabled={addActivityLoading}
                            variant="contained"
                            className={classes.saveBtn}
                        >
                            {addActivityLoading ? (
                                <>
                                    <CircularProgress size={18} style={{ marginRight: 8, color: '#fff' }} />
                                    Adding...
                                </>
                            ) : (
                                activity._id ? 'Update' : 'Add'
                            )}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
            <Dialog
                open={activityNoteDialog.open}
                onClose={() => setActivityNoteDialog({ open: false, title: "", text: "" })}
                maxWidth="sm"
                fullWidth
                ModalProps={{ style: { zIndex: 2000 } }}
            >
                <DialogTitle>{activityNoteDialog.title || "Note"}</DialogTitle>
                <DialogContent dividers>
                    <Typography style={{ whiteSpace: "pre-wrap", fontSize: 15, lineHeight: 1.5 }}>
                        {activityNoteDialog.text || "—"}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => setActivityNoteDialog({ open: false, title: "", text: "" })}
                        color="primary"
                        variant="contained"
                        style={{ backgroundColor: "rgb(15 59 98)" }}
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={openHistory}
                onClose={() => {
                    setOpenHistory(false);
                    setHistoryCurrentKey('');
                }}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle>Key Status History</DialogTitle>
                <DialogContent dividers style={{ maxHeight: 420 }}>
                    {!historyTimeline.some((s) => s.changedAt || s.state === 'current') && !historyCurrentKey ? (
                        <div style={{ color: '#999', fontSize: '0.85rem' }}>No history available.</div>
                    ) : (
                        <div style={{ position: 'relative', paddingLeft: 4 }}>
                            {historyTimeline.map((step, index) => {
                                const isLast = index === historyTimeline.length - 1;
                                const style = getKeyStatusStyle(step.key);
                                const stateLabel = {
                                    completed: 'Completed',
                                    current: 'Current',
                                    skipped: 'Skipped',
                                    upcoming: 'Upcoming',
                                };
                                const dotColor = {
                                    completed: '#1a1a1a',
                                    current: '#1f8a5b',
                                    skipped: '#c5cdd8',
                                    upcoming: '#d9d9d9',
                                };
                                return (
                                    <div
                                        key={step.key}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'stretch',
                                            gap: 12,
                                            minHeight: 64,
                                        }}
                                    >
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: 18 }}>
                                            <div
                                                style={{
                                                    width: 14,
                                                    height: 14,
                                                    borderRadius: '50%',
                                                    backgroundColor: dotColor[step.state],
                                                    border: step.state === 'current' ? '2px solid #1a1a1a' : '2px solid #fff',
                                                    boxShadow: '0 0 0 1px #d5dde8',
                                                    flexShrink: 0,
                                                    marginTop: 4,
                                                }}
                                            />
                                            {!isLast && (
                                                <div
                                                    style={{
                                                        width: 2,
                                                        flex: 1,
                                                        backgroundColor: historyCurrentIdx > index ? '#1a1a1a' : '#d9d9d9',
                                                        marginTop: 4,
                                                    }}
                                                />
                                            )}
                                        </div>
                                        <div style={{ flex: 1, paddingBottom: isLast ? 0 : 16 }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                                                <span style={{ ...style, opacity: step.state === 'upcoming' || step.state === 'skipped' ? 0.55 : 1 }}>
                                                    {index + 1}. {step.label}
                                                </span>
                                                <span style={{ fontSize: '0.72rem', fontWeight: 700, color: step.state === 'current' ? '#1f8a5b' : '#7a8aa0' }}>
                                                    {stateLabel[step.state]}
                                                </span>
                                            </div>
                                            <div style={{ fontSize: '0.75rem', color: '#555', marginTop: 4 }}>
                                                {step.changedAt
                                                    ? step.changedAt.toLocaleString()
                                                    : (step.state === 'current' ? 'Current status' : '—')}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </DialogContent>
            </Dialog>

            <Dialog 
                open={openMessageDialog} 
                onClose={() => setOpenMessageDialog(false)} 
                maxWidth="sm" 
                fullWidth
                PaperProps={{
                    style: {
                        borderRadius: '12px',
                    }
                }}
            >
                <DialogTitle style={{ 
                    backgroundColor: messageDialogContent.type === 'success' ? '#d4edda' : messageDialogContent.type === 'error' ? '#f8d7da' : '#d1ecf1',
                    color: messageDialogContent.type === 'success' ? '#155724' : messageDialogContent.type === 'error' ? '#721c24' : '#0c5460',
                    padding: '20px 24px',
                    borderBottom: `2px solid ${messageDialogContent.type === 'success' ? '#28a745' : messageDialogContent.type === 'error' ? '#b3261e' : '#17a2b8'}`,
                    fontWeight: '600',
                    fontSize: '18px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px'
                }}>
                    {messageDialogContent.type === 'success' && '✓'}
                    {messageDialogContent.type === 'error' && '✕'}
                    {messageDialogContent.type === 'info' && 'ℹ'}
                    {messageDialogContent.title}
                </DialogTitle>
                <DialogContent dividers style={{ padding: '20px 24px' }}>
                    <div style={{ 
                        color: '#333',
                        fontSize: '15px',
                        lineHeight: '1.6'
                    }}>
                        {normalizeDialogMessage(messageDialogContent.message).split('\n').map((line, index) => {
                            // Check if line starts with bullet point and contains student name
                            if (line.trim().startsWith('•')) {
                                const studentName = line.trim().substring(1).trim(); // Remove bullet and trim
                                return (
                                    <div key={index} style={{ marginBottom: '4px' }}>
                                        • <strong style={{ fontWeight: '700' }}>{studentName}</strong>
                                    </div>
                                );
                            }
                            // Return empty line or regular line
                            if (line.trim() === '') {
                                return <div key={index} style={{ marginBottom: '8px' }}></div>;
                            }
                            return <div key={index} style={{ marginBottom: '4px' }}>{line}</div>;
                        })}
                    </div>
                </DialogContent>
                <DialogActions style={{ 
                    padding: '16px 24px',
                    backgroundColor: '#f8f9fa',
                    borderTop: '1px solid #dee2e6'
                }}>
                    <Button 
                        onClick={() => setOpenMessageDialog(false)}
                        variant="contained"
                        style={{
                            backgroundColor: messageDialogContent.type === 'success' ? '#28a745' : messageDialogContent.type === 'error' ? '#b3261e' : '#17a2b8',
                            color: 'white',
                            fontWeight: '500',
                            textTransform: 'none',
                            padding: '8px 24px',
                            borderRadius: '6px',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                        }}
                    >
                        OK
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={keyUpdateDialog.open}
                onClose={handleKeyUpdateCancel}
                maxWidth="sm"
                fullWidth
                PaperProps={{ style: { borderRadius: '12px' } }}
            >
                <DialogTitle style={{
                    backgroundColor: '#e6e6e6',
                    color: '#1a1a1a',
                    padding: '20px 24px',
                    borderBottom: '1px solid #d6e4ff',
                    fontWeight: 600,
                    fontSize: '18px',
                }}>
                    {keyUpdateDialog.deselect ? 'Confirm Deselect' : 'Confirm Key Update'}
                </DialogTitle>
                <DialogContent dividers style={{ padding: '20px 24px' }}>
                    <Typography style={{ color: '#333', fontSize: '15px', lineHeight: 1.6 }}>
                        {keyUpdateDialog.deselect ? (
                            <>
                                Deselect <strong>{keyUpdateDialog.currentLabel || keyUpdateDialog.currentKey}</strong> for this activity?
                            </>
                        ) : (
                            <>
                                Update key from <strong>{keyUpdateDialog.currentLabel || keyUpdateDialog.currentKey}</strong> to{' '}
                                <strong>{keyUpdateDialog.nextLabel || keyUpdateDialog.nextKey}</strong> for this activity?
                            </>
                        )}
                    </Typography>
                </DialogContent>
                <DialogActions style={{
                    padding: '16px 24px',
                    backgroundColor: '#f8f9fa',
                    borderTop: '1px solid #dee2e6',
                }}>
                    <Button
                        onClick={handleKeyUpdateCancel}
                        disabled={Boolean(updatingKeyId)}
                        style={{ textTransform: 'none', fontWeight: 500 }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleKeyUpdateConfirm}
                        variant="contained"
                        disabled={Boolean(updatingKeyId)}
                        style={{
                            backgroundColor: '#1a1a1a',
                            color: 'white',
                            textTransform: 'none',
                            fontWeight: 500,
                            borderRadius: 6,
                        }}
                    >
                        {updatingKeyId
                            ? (keyUpdateDialog.deselect ? 'Removing...' : 'Updating...')
                            : (keyUpdateDialog.deselect ? 'Deselect' : 'Update')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={observationDialog.open}
                onClose={closeObservationDialog}
                maxWidth="sm"
                fullWidth
                PaperProps={{ style: { borderRadius: 12 } }}
            >
                <DialogTitle style={{ fontWeight: 700, color: '#1a1a1a' }}>
                    {hasSavedRemarks(observationDialog.activity) ? 'Edit Observation' : 'Add Observation'}
                </DialogTitle>
                <DialogContent dividers style={{ padding: '20px 24px' }}>
                    <TextField
                        fullWidth
                        multiline
                        minRows={4}
                        maxRows={10}
                        variant="outlined"
                        size="small"
                        placeholder="Enter observation..."
                        value={observationDialog.text}
                        onChange={(e) => handleObservationDialogChange(e.target.value)}
                        disabled={observationDialog.saving}
                        autoFocus
                    />
                </DialogContent>
                <DialogActions style={{ padding: '12px 20px', backgroundColor: '#f8f9fa' }}>
                    <Button
                        onClick={closeObservationDialog}
                        disabled={observationDialog.saving}
                        style={{ textTransform: 'none' }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={saveObservationDialog}
                        color="primary"
                        variant="contained"
                        disabled={
                            observationDialog.saving
                            || (!hasSavedRemarks(observationDialog.activity) && !observationDialog.text.trim())
                        }
                        style={{ textTransform: 'none', backgroundColor: '#1a1a1a' }}
                    >
                        {observationDialog.saving ? 'Saving...' : 'Save'}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={imagesStoreDialog.open}
                onClose={closeImagesStoreDialog}
                maxWidth="md"
                fullWidth
                PaperProps={{ style: { borderRadius: 12 } }}
            >
                <DialogTitle style={{ fontWeight: 700, color: '#1a1a1a' }}>
                    Add Media from Images Store
                </DialogTitle>
                <DialogContent dividers style={{ padding: '16px 20px' }}>
                    {imagesStoreDialog.loading ? (
                        <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
                            <CircularProgress />
                        </Box>
                    ) : imagesStoreDialog.error ? (
                        <Typography color="error">{imagesStoreDialog.error}</Typography>
                    ) : (() => {
                        const dialogActivity = imagesStoreDialog.activity;
                        const existingImages = dialogActivity ? getActivityImageUrls(dialogActivity) : [];
                        const existingVideos = dialogActivity ? getActivityVideoUrls(dialogActivity) : [];
                        const remainingImageSlots = MAX_ACTIVITY_IMAGES - existingImages.length;
                        const remainingVideoSlots = MAX_ACTIVITY_VIDEOS - existingVideos.length;
                        const visibleMedia = getVisibleStoreMedia(
                            imagesStoreDialog.imagesStoreRows,
                            imagesStoreDialog.selectedStoreId,
                        );
                        const storeMediaCounts = countStoreMedia(imagesStoreDialog.imagesStoreRows);

                        return (
                            <Box display="flex" flexDirection="column" style={{ gap: 12 }}>
                                <Typography variant="body2" style={{ color: '#444' }}>
                                    Select images and/or videos to add (
                                    {remainingImageSlots} image slot{remainingImageSlots !== 1 ? 's' : ''},
                                    {' '}
                                    {remainingVideoSlots} video slot{remainingVideoSlots !== 1 ? 's' : ''} remaining).
                                </Typography>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={4}>
                                        <Box className={classes.imagesStoreLeftPanel}>
                                            <List disablePadding>
                                                <ListItem
                                                    button
                                                    selected={imagesStoreDialog.selectedStoreId === IMAGES_STORE_ALL_KEY}
                                                    className={classes.imagesStoreListItem}
                                                    onClick={() => setImagesStoreDialog((prev) => ({
                                                        ...prev,
                                                        selectedStoreId: IMAGES_STORE_ALL_KEY,
                                                    }))}
                                                >
                                                    <ListItemText
                                                        primary="All Media"
                                                        secondary={`${storeMediaCounts.images} images · ${storeMediaCounts.videos} videos`}
                                                    />
                                                </ListItem>
                                                {imagesStoreDialog.imagesStoreRows.map((row) => (
                                                    <ListItem
                                                        key={row._id}
                                                        button
                                                        selected={imagesStoreDialog.selectedStoreId === row._id}
                                                        className={classes.imagesStoreListItem}
                                                        onClick={() => setImagesStoreDialog((prev) => ({
                                                            ...prev,
                                                            selectedStoreId: row._id,
                                                        }))}
                                                    >
                                                        <ListItemText
                                                            primary={row.eventName || '—'}
                                                            secondary={`${(row.imageURL || []).length} image${(row.imageURL || []).length !== 1 ? 's' : ''} · ${(row.videoURL || []).length} video${(row.videoURL || []).length !== 1 ? 's' : ''}`}
                                                        />
                                                    </ListItem>
                                                ))}
                                                {imagesStoreDialog.imagesStoreRows.length === 0 ? (
                                                    <Typography
                                                        variant="caption"
                                                        color="textSecondary"
                                                        style={{ padding: 16, display: 'block' }}
                                                    >
                                                        No Images Store records for this class
                                                        {normalizeRefId(dialogActivity?.sectionId) || sectionId ? ' and section' : ''}.
                                                    </Typography>
                                                ) : null}
                                            </List>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={8}>
                                        {imagesStoreDialog.selectedUrls.length > 0 ? (
                                            <Typography variant="caption" style={{ fontWeight: 600, display: 'block', marginBottom: 8 }}>
                                                Selected ({imagesStoreDialog.selectedUrls.length})
                                            </Typography>
                                        ) : null}
                                        <Box className={classes.imagesStoreGrid}>
                                            {visibleMedia.length === 0 ? (
                                                <Typography color="textSecondary" style={{ gridColumn: '1 / -1' }}>
                                                    No images or videos to display.
                                                </Typography>
                                            ) : (
                                                visibleMedia.map((item, index) => {
                                                    const isVideo = item.mediaType === 'video';
                                                    const existingUrls = isVideo ? existingVideos : existingImages;
                                                    const remainingSlots = isVideo ? remainingVideoSlots : remainingImageSlots;
                                                    const alreadyOnActivity = existingUrls.includes(item.url);
                                                    const isSelected = imagesStoreDialog.selectedUrls.includes(item.url);
                                                    const selectedOfType = imagesStoreDialog.selectedUrls.filter(
                                                        (url) => getMediaTypeFromUrl(url) === item.mediaType,
                                                    );
                                                    const selectionFull = selectedOfType.length >= remainingSlots;
                                                    const isDisabled = alreadyOnActivity || (!isSelected && selectionFull);
                                                    const cardClass = [
                                                        classes.imagesStoreCard,
                                                        isSelected ? classes.imagesStoreCardSelected : '',
                                                        isDisabled ? classes.imagesStoreCardDisabled : '',
                                                    ].filter(Boolean).join(' ');

                                                    return (
                                                        <Box
                                                            key={`${item.storeRecordId}-${item.mediaType}-${item.url}-${index}`}
                                                            className={cardClass}
                                                            onClick={() => {
                                                                if (!isDisabled) {
                                                                    toggleImagesStoreSelection(item.url, item.mediaType);
                                                                }
                                                            }}
                                                            role="button"
                                                            tabIndex={isDisabled ? -1 : 0}
                                                            onKeyDown={(e) => {
                                                                if ((e.key === 'Enter' || e.key === ' ') && !isDisabled) {
                                                                    e.preventDefault();
                                                                    toggleImagesStoreSelection(item.url, item.mediaType);
                                                                }
                                                            }}
                                                        >
                                                            {isSelected ? (
                                                                <CheckCircleIcon
                                                                    className={classes.imagesStoreCheck}
                                                                    fontSize="small"
                                                                />
                                                            ) : null}
                                                            {isVideo ? (
                                                                <Box className={classes.imagesStoreVideoThumb}>
                                                                    <PlayArrowIcon style={{ color: '#fff', fontSize: 32 }} />
                                                                </Box>
                                                            ) : (
                                                                <img
                                                                    src={item.url}
                                                                    alt={item.storeEventName}
                                                                    className={classes.imagesStoreThumb}
                                                                    loading="lazy"
                                                                    decoding="async"
                                                                />
                                                            )}
                                                            <Typography
                                                                variant="caption"
                                                                noWrap
                                                                style={{ display: 'block', padding: '2px 4px', fontSize: '0.65rem' }}
                                                            >
                                                                {isVideo ? (
                                                                    <>
                                                                        <VideocamIcon style={{ fontSize: 10, verticalAlign: 'middle', marginRight: 2 }} />
                                                                        {item.storeEventName}
                                                                    </>
                                                                ) : item.storeEventName}
                                                            </Typography>
                                                        </Box>
                                                    );
                                                })
                                            )}
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                        );
                    })()}
                </DialogContent>
                <DialogActions style={{ padding: '12px 20px', backgroundColor: '#f8f9fa' }}>
                    <Button
                        onClick={closeImagesStoreDialog}
                        disabled={imagesStoreDialog.saving}
                        style={{ textTransform: 'none' }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={saveImagesFromStore}
                        color="primary"
                        variant="contained"
                        disabled={
                            imagesStoreDialog.saving
                            || imagesStoreDialog.loading
                            || imagesStoreDialog.selectedUrls.length === 0
                        }
                        style={{ textTransform: 'none', backgroundColor: '#1a1a1a' }}
                    >
                        {imagesStoreDialog.saving ? 'Adding...' : 'Add Selected'}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={statusConfirmDialog.open}
                onClose={closeStatusConfirmDialog}
                maxWidth="xs"
                fullWidth
                PaperProps={{ style: { borderRadius: 12 } }}
            >
                <DialogTitle style={{ fontWeight: 700, color: '#1a1a1a' }}>
                    {statusConfirmDialog.publicStatus === 'publish'
                        ? ((statusConfirmDialog.activityIds?.length || 0) > 1
                            ? `Publish ${statusConfirmDialog.activityIds.length} activities?`
                            : 'Publish activity?')
                        : ((statusConfirmDialog.activityIds?.length || 0) > 1
                            ? `Move ${statusConfirmDialog.activityIds.length} activities to draft?`
                            : 'Move to draft?')}
                </DialogTitle>
                <DialogContent dividers style={{ padding: '20px 24px' }}>
                    <Box display="flex" flexDirection="column" style={{ gap: 10 }}>
                        <Typography variant="body2" style={{ color: '#444' }}>
                            <strong style={{ color: '#e65100' }}>Draft</strong> — stays in this table only. Not sent to parents.
                        </Typography>
                        <Typography variant="body2" style={{ color: '#444' }}>
                            <strong style={{ color: '#1f8a5b' }}>Published</strong> — sent to parents.
                        </Typography>
                        <Typography variant="body2" style={{ color: '#1a1a1a', marginTop: 4 }}>
                            {statusConfirmDialog.publicStatus === 'publish'
                                ? ((statusConfirmDialog.activityIds?.length || 0) > 1
                                    ? `Publish ${statusConfirmDialog.activityIds.length} selected activities to parents?`
                                    : 'Publish this activity to parents?')
                                : ((statusConfirmDialog.activityIds?.length || 0) > 1
                                    ? `Move ${statusConfirmDialog.activityIds.length} selected activities back to draft? Parents will no longer see them.`
                                    : 'Move this activity back to draft? Parents will no longer see it.')}
                        </Typography>
                    </Box>
                </DialogContent>
                <DialogActions style={{ padding: '12px 20px', backgroundColor: '#f8f9fa' }}>
                    <Button
                        onClick={closeStatusConfirmDialog}
                        disabled={statusConfirmDialog.busy}
                        style={{ textTransform: 'none' }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={confirmPublicStatusChange}
                        color="primary"
                        variant="contained"
                        disabled={statusConfirmDialog.busy}
                        style={{ textTransform: 'none' }}
                    >
                        {statusConfirmDialog.busy
                            ? 'Updating…'
                            : statusConfirmDialog.publicStatus === 'publish'
                                ? 'Publish'
                                : 'Move to Draft'}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog 
                open={openDeleteDialog} 
                onClose={(event, reason) => {
                    if (deletingActivities) return;
                    handleDeleteCancel();
                }}
                disableEscapeKeyDown={deletingActivities}
                maxWidth="sm" 
                fullWidth
                PaperProps={{
                    style: {
                        borderRadius: '12px',
                    }
                }}
            >
                <DialogTitle style={{ 
                    backgroundColor: '#fff3cd',
                    color: '#856404',
                    padding: '20px 24px',
                    borderBottom: '2px solid #ffc107',
                    fontWeight: '600',
                    fontSize: '18px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px'
                }}>
                    ⚠️ Confirm Delete
                </DialogTitle>
                <DialogContent dividers style={{ padding: '20px 24px' }}>
                    <div style={{
                        color: '#333',
                        fontSize: '15px',
                        lineHeight: '1.6',
                    }}>
                        {pendingDeleteIds.length > 1 ? (
                            <>
                                Are you sure you want to delete <strong>{pendingDeleteIds.length} activities</strong>? This action cannot be undone.
                                <Box mt={2} component="ul" style={{ margin: '12px 0 0', paddingLeft: 20, maxHeight: 180, overflowY: 'auto' }}>
                                    {getActivityLabelsForIds(pendingDeleteIds).map((label, index) => (
                                        <li key={`delete-label-${index}`} style={{ marginBottom: 4 }}>{label}</li>
                                    ))}
                                </Box>
                            </>
                        ) : (
                            'Are you sure you want to delete this activity? This action cannot be undone.'
                        )}
                        {deletingActivities && (
                            <Box mt={2} display="flex" alignItems="center" style={{ gap: 10, color: '#856404' }}>
                                <CircularProgress size={18} style={{ color: '#b3261e' }} />
                                <span>
                                    Deleting {pendingDeleteIds.length > 1 ? `${pendingDeleteIds.length} activities` : 'activity'}…
                                    Please wait.
                                </span>
                            </Box>
                        )}
                    </div>
                </DialogContent>
                <DialogActions style={{ 
                    padding: '16px 24px',
                    backgroundColor: '#f8f9fa',
                    borderTop: '1px solid #dee2e6'
                }}>
                    <Button 
                        onClick={handleDeleteCancel}
                        disabled={deletingActivities}
                        style={{
                            color: '#6c757d',
                            fontWeight: '500',
                            textTransform: 'none',
                            padding: '8px 20px'
                        }}
                    >
                        Cancel
                    </Button>
                    <Button 
                        onClick={handleDeleteConfirm}
                        variant="contained"
                        disabled={deletingActivities}
                        startIcon={
                            deletingActivities
                                ? <CircularProgress size={16} style={{ color: '#fff' }} />
                                : null
                        }
                        style={{
                            backgroundColor: deletingActivities ? '#e57373' : '#b3261e',
                            color: 'white',
                            fontWeight: '500',
                            textTransform: 'none',
                            padding: '8px 24px',
                            borderRadius: '6px',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                        }}
                    >
                        {deletingActivities
                            ? 'Deleting…'
                            : `Delete${pendingDeleteIds.length > 1 ? ` (${pendingDeleteIds.length})` : ''}`}
                    </Button>
                </DialogActions>
            </Dialog>

        </>
    );
}


